(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ASVideoPlayer"] = factory();
	else
		root["ASVideoPlayer"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return webpackJsonpASVideoPlayer(["asvp"],{

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLIP = exports.CLIP = 'clip';
var EPISODE = exports.EPISODE = 'episode';
var MARATHON = exports.MARATHON = 'marathon';
var STREAM = exports.STREAM = 'stream';

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This is the master list of all actions that can be performed in the player
 */

var DESTROY = exports.DESTROY = '@@DESTROY';
var INIT = exports.INIT = '@@INIT';

var PLAYER_EVENT_CAN_PLAY_THROUGH = exports.PLAYER_EVENT_CAN_PLAY_THROUGH = 'PLAYER_EVENT_CAN_PLAY_THROUGH';
var PLAYER_EVENT_DURATION_CHANGE = exports.PLAYER_EVENT_DURATION_CHANGE = 'PLAYER_EVENT_DURATION_CHANGE';
var PLAYER_EVENT_ENDED = exports.PLAYER_EVENT_ENDED = 'PLAYER_EVENT_ENDED';
var PLAYER_EVENT_ERROR = exports.PLAYER_EVENT_ERROR = 'PLAYER_EVENT_ERROR';
var PLAYER_EVENT_FULLSCREEN_CHANGE = exports.PLAYER_EVENT_FULLSCREEN_CHANGE = 'PLAYER_EVENT_FULLSCREEN_CHANGE';
var PLAYER_EVENT_LOADED_DATA = exports.PLAYER_EVENT_LOADED_DATA = 'PLAYER_EVENT_LOADED_DATA';
var PLAYER_EVENT_PAUSE = exports.PLAYER_EVENT_PAUSE = 'PLAYER_EVENT_PAUSE';
var PLAYER_EVENT_PLAY = exports.PLAYER_EVENT_PLAY = 'PLAYER_EVENT_PLAY';
var PLAYER_EVENT_PLAYING = exports.PLAYER_EVENT_PLAYING = 'PLAYER_EVENT_PLAYING';
var PLAYER_EVENT_READY = exports.PLAYER_EVENT_READY = 'PLAYER_EVENT_READY';
var PLAYER_EVENT_TIME_UPDATE = exports.PLAYER_EVENT_TIME_UPDATE = 'PLAYER_EVENT_TIME_UPDATE';
var PLAYER_EVENT_VOLUME_CHANGE = exports.PLAYER_EVENT_VOLUME_CHANGE = 'PLAYER_EVENT_VOLUME_CHANGE';
var PLAYER_EVENT_WAITING = exports.PLAYER_EVENT_WAITING = 'PLAYER_EVENT_WAITING';

var HLS_EVENT_MEDIA_ATTACHED = exports.HLS_EVENT_MEDIA_ATTACHED = 'HLS_EVENT_MEDIA_ATTACHED';
var HLS_EVENT_LEVEL_LOADED = exports.HLS_EVENT_LEVEL_LOADED = 'HLS_EVENT_LEVEL_LOADED';
var HLS_EVENT_MANIFEST_PARSED = exports.HLS_EVENT_MANIFEST_PARSED = 'HLS_EVENT_MANIFEST_PARSED';
var HLS_EVENT_LOAD_ERROR = exports.HLS_EVENT_LOAD_ERROR = 'HLS_EVENT_LOAD_ERROR';
var HLS_FRAG_CHANGED = exports.HLS_FRAG_CHANGED = 'HLS_FRAG_CHANGED';

var FETCH_VIDEO_SOURCE_ERROR = exports.FETCH_VIDEO_SOURCE_ERROR = 'FETCH_VIDEO_SOURCE_ERROR';

var RECEIVE_VIDEO_SOURCE = exports.RECEIVE_VIDEO_SOURCE = 'RECEIVE_VIDEO_SOURCE';
var RECEIVE_MEDIA_SOURCE = exports.RECEIVE_MEDIA_SOURCE = 'RECEIVE_MEDIA_SOURCE';
var RECEIVE_CDN_TOKEN_SOURCE = exports.RECEIVE_CDN_TOKEN_SOURCE = 'RECEIVE_CDN_TOKEN_SOURCE';
var RECEIVE_ACCESS_TOKEN = exports.RECEIVE_ACCESS_TOKEN = 'RECEIVE_ACCESS_TOKEN';
var RECEIVE_VIDEO_PLAYER_DATA = exports.RECEIVE_VIDEO_PLAYER_DATA = 'RECEIVE_VIDEO_PLAYER_DATA';
var RECEIVE_AUDITUDE_URL = exports.RECEIVE_AUDITUDE_URL = 'RECEIVE_AUDITUDE_URL';
var RECEIVE_AUDITUDE_TRACKING_DATA = exports.RECEIVE_AUDITUDE_TRACKING_DATA = 'RECEIVE_AUDITUDE_TRACKING_DATA';
var RECONNECT_STREAM = exports.RECONNECT_STREAM = 'RECONNECT_STREAM';

var SET_CURRENT_TIME_STATE = exports.SET_CURRENT_TIME_STATE = 'SET_CURRENT_TIME_STATE';
var SET_DURATION_STATE = exports.SET_DURATION_STATE = 'SET_DURATION_STATE';
var SET_ERROR_STATE = exports.SET_ERROR_STATE = 'SET_ERROR_STATE';
var SET_FIRST_TIME_STATE = exports.SET_FIRST_TIME_STATE = 'SET_FIRST_TIME_STATE';
var SET_LIVE_STATE = exports.SET_LIVE_STATE = 'SET_LIVE_STATE';
var SET_MUTE_STATE = exports.SET_MUTE_STATE = 'SET_MUTE_STATE';
var SET_PAUSE_STATE = exports.SET_PAUSE_STATE = 'SET_PAUSE_STATE';
var SET_PLAYING_STATE = exports.SET_PLAYING_STATE = 'SET_PLAYING_STATE';
var SET_STARTED_STATE = exports.SET_STARTED_STATE = 'SET_STARTED_STATE';
var SET_VIDEO_ID = exports.SET_VIDEO_ID = 'SET_VIDEO_ID';
var START_CONTENT = exports.START_CONTENT = 'START_CONTENT';
var SET_VOLUME_STATE = exports.SET_VOLUME_STATE = 'SET_VOLUME_STATE';
var SET_VOLUME_DRAG_STATE = exports.SET_VOLUME_DRAG_STATE = 'SET_VOLUME_DRAG_STATE';
var SET_WAITING_STATE = exports.SET_WAITING_STATE = 'SET_WAITING_STATE';
var SET_AD_PLAYING_STATE = exports.SET_AD_PLAYING_STATE = 'SET_AD_PLAYING_STATE';
var SET_AD_SLOTS = exports.SET_AD_SLOTS = 'SET_AD_SLOTS';
var SET_ADS_RETURN_MIDROLL_TIME_STATE = exports.SET_ADS_RETURN_MIDROLL_TIME_STATE = 'SET_ADS_RETURN_MIDROLL_TIME_STATE';
var SET_QUERY_PARAM_TIMECODE_SEEKED_STATE = exports.SET_QUERY_PARAM_TIMECODE_SEEKED_STATE = 'SET_QUERY_PARAM_TIMECODE_SEEKED_STATE';
var SET_VIDEO_PROGRESS_STATE = exports.SET_VIDEO_PROGRESS_STATE = 'SET_VIDEO_PROGRESS_STATE';
var SET_PLAYBACK_URL = exports.SET_PLAYBACK_URL = 'SET_PLAYBACK_URL';
var SET_TRACKING_URL = exports.SET_TRACKING_URL = 'SET_TRACKING_URL';
var SET_PROGRAM_DATETIME = exports.SET_PROGRAM_DATETIME = 'SET_PROGRAM_DATETIME';
var SET_CURRENT_AD = exports.SET_CURRENT_AD = 'SET_CURRENT_AD';
var SET_CURRENT_AD_POD = exports.SET_CURRENT_AD_POD = 'SET_CURRENT_AD_POD';
var SET_CURRENT_AD_END_TIME = exports.SET_CURRENT_AD_END_TIME = 'SET_CURRENT_AD_END_TIME';
var SET_AD_TIME_REMAINING = exports.SET_AD_TIME_REMAINING = 'SET_AD_TIME_REMAINING';
var SET_CURRENT_AD_TIME_REMAINING = exports.SET_CURRENT_AD_TIME_REMAINING = 'SET_CURRENT_AD_TIME_REMAINING';
var SET_AD_END_TIME = exports.SET_AD_END_TIME = 'SET_AD_END_TIME';
var SET_AD_CLICK_HANDLER = exports.SET_AD_CLICK_HANDLER = 'SET_AD_CLICK_HANDLER';
var CLEAR_CURRENT_AD = exports.CLEAR_CURRENT_AD = 'CLEAR_CURRENT_AD';
var CLEAR_CURRENT_AD_POD = exports.CLEAR_CURRENT_AD_POD = 'CLEAR_CURRENT_AD_POD';
var SET_STREAM_BLOCKED = exports.SET_STREAM_BLOCKED = 'SET_STREAM_BLOCKED';
var RETRY_PLAIN_STREAM = exports.RETRY_PLAIN_STREAM = 'RETRY_PLAIN_STREAM';

var TRACK_USER_INTERACTION = exports.TRACK_USER_INTERACTION = 'TRACK_USER_INTERACTION';
var TRACK_VIDEO_BUFFERING = exports.TRACK_VIDEO_BUFFERING = 'TRACK_VIDEO_BUFFERING';
var TRACK_VIDEO_COMPLETE = exports.TRACK_VIDEO_COMPLETE = 'TRACK_VIDEO_COMPLETE';
var TRACK_VIDEO_START = exports.TRACK_VIDEO_START = 'TRACK_VIDEO_START';
var TRACK_VIDEO_PAUSE = exports.TRACK_VIDEO_PAUSE = 'TRACK_VIDEO_PAUSE';
var TRACK_VIDEO_PROGRESS = exports.TRACK_VIDEO_PROGRESS = 'TRACK_VIDEO_PROGRESS';
var TRACK_VIDEO_FIFTY = exports.TRACK_VIDEO_FIFTY = 'TRACK_VIDEO_FIFTY';
var TRACK_PREROLL = exports.TRACK_PREROLL = 'TRACK_PREROLL';
var TRACK_MIDROLL_START = exports.TRACK_MIDROLL_START = 'TRACK_MIDROLL_START';
var TRACK_MIDROLL_END = exports.TRACK_MIDROLL_END = 'TRACK_MIDROLL_END';
var TRACK_POSTROLL_START = exports.TRACK_POSTROLL_START = 'TRACK_POSTROLL_START';
var TRACK_POSTROLL_END = exports.TRACK_POSTROLL_END = 'TRACK_POSTROLL_END';

var ADS_EVENT_REQUEST_COMPLETE = exports.ADS_EVENT_REQUEST_COMPLETE = 'ADS_EVENT_REQUEST_COMPLETE';
var ADS_EVENT_SLOT_STARTED = exports.ADS_EVENT_SLOT_STARTED = 'ADS_EVENT_SLOT_STARTED';
var ADS_EVENT_SLOT_ENDED = exports.ADS_EVENT_SLOT_ENDED = 'ADS_EVENT_SLOT_ENDED';
var ADS_EVENT_IMPRESSION_STARTED = exports.ADS_EVENT_IMPRESSION_STARTED = 'ADS_EVENT_IMPRESSION_STARTED';
var ADS_EVENT_IMPRESSION_ENDED = exports.ADS_EVENT_IMPRESSION_ENDED = 'ADS_EVENT_IMPRESSION_ENDED';
var ADS_EVENT_ERROR = exports.ADS_EVENT_ERROR = 'ADS_EVENT_ERROR';
var ADS_EVENT_CLICK = exports.ADS_EVENT_CLICK = 'ADS_EVENT_CLICK';
var ADS_START_PREROLL = exports.ADS_START_PREROLL = 'ADS_START_PREROLL';
var ADS_PREROLL_END = exports.ADS_PREROLL_END = 'ADS_PREROLL_END';
var ADS_MIDROLL_END = exports.ADS_MIDROLL_END = 'ADS_MIDROLL_END';
var ADS_POSTROLL_END = exports.ADS_POSTROLL_END = 'ADS_POSTROLL_END';
var ENABLE_ADS = exports.ENABLE_ADS = 'ENABLE_ADS';
var DISABLE_ADS = exports.DISABLE_ADS = 'DISABLE_ADS';

var ON_DOCUMENT_MOUSE_MOVE = exports.ON_DOCUMENT_MOUSE_MOVE = 'ON_DOCUMENT_MOUSE_MOVE';
var ON_DOCUMENT_MOUSE_UP = exports.ON_DOCUMENT_MOUSE_UP = 'ON_DOCUMENT_MOUSE_UP';
var ON_SHARE_CONTROL_CLICK = exports.ON_SHARE_CONTROL_CLICK = 'ON_SHARE_CONTROL_CLICK';
var ON_SHARE_CONTROL_CLOSE = exports.ON_SHARE_CONTROL_CLOSE = 'ON_SHARE_CONTROL_CLOSE';
var ON_SHARE_SOCIAL = exports.ON_SHARE_SOCIAL = 'ON_SHARE_SOCIAL';
var ON_COPY_CLICK = exports.ON_COPY_CLICK = 'ON_COPY_CLICK';
var ON_TIMECODE_SELECTION_CHANGE = exports.ON_TIMECODE_SELECTION_CHANGE = 'ON_TIMECODE_SELECTION_CHANGE';
var ON_TIMECODE_INPUT_CHANGE = exports.ON_TIMECODE_INPUT_CHANGE = 'ON_TIMECODE_INPUT_CHANGE';
var ON_VOLUME_CONTROL_MOUSE_OUT = exports.ON_VOLUME_CONTROL_MOUSE_OUT = 'ON_VOLUME_CONTROL_MOUSE_OUT';
var ON_VOLUME_CONTROL_MOUSE_OVER = exports.ON_VOLUME_CONTROL_MOUSE_OVER = 'ON_VOLUME_CONTROL_MOUSE_OVER';
var ON_VOLUME_SLIDER_MOUSE_DOWN = exports.ON_VOLUME_SLIDER_MOUSE_DOWN = 'ON_VOLUME_SLIDER_MOUSE_DOWN';
var UPDATE_VOLUME_FROM_DRAG = exports.UPDATE_VOLUME_FROM_DRAG = 'UPDATE_VOLUME_FROM_DRAG';

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isType = exports.createActionCreator = undefined;

var _ramda = __webpack_require__(173);

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var createActionCreator = exports.createActionCreator = function createActionCreator(type) {
    return function (payload) {
        return {
            type: type,
            payload: payload
        };
    };
};

var isType = exports.isType = R.curry(function (type, action) {
    return R.ifElse(R.complement(R.is(Object)), R.F, R.propEq('type', type))(action);
});

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AD_COUNTDOWN = exports.AD_COUNTDOWN = 'ASAdCountdown';
var CAPTIONS_BUTTON = exports.CAPTIONS_BUTTON = 'ASCaptionsButton';
var CLOSE_BUTTON = exports.CLOSE_BUTTON = 'CloseButton';
var CURRENT_TIME_DISPLAY = exports.CURRENT_TIME_DISPLAY = 'currentTimeDisplay';
var FULLSCREEN_TOGGLE = exports.FULLSCREEN_TOGGLE = 'ASFullscreenToggle';
var MUTE_TOGGLE = exports.MUTE_TOGGLE = 'ASMuteToggle';
var MUTED_OVERLAY_BUTTON = exports.MUTED_OVERLAY_BUTTON = 'ASMutedOverlayButton';
var PLAY_TOGGLE = exports.PLAY_TOGGLE = 'ASPlayToggle';
var PROGRESS_CONTROL = exports.PROGRESS_CONTROL = 'progressControl';
var SHARE_CONTROL = exports.SHARE_CONTROL = 'ASShareControl';
var SHARE_OVERLAY = exports.SHARE_OVERLAY = 'ASShareOverlay';
var AD_CLICK_OVERLAY = exports.AD_CLICK_OVERLAY = 'ASAdClickOverlay';
var SUBTITLES_BUTTON = exports.SUBTITLES_BUTTON = 'ASSubtitlesButton';
var VOLUME_CONTROL = exports.VOLUME_CONTROL = 'volumeControl';
var VOLUME_PANEL = exports.VOLUME_PANEL = 'volumePanel';
var WATCH_BUTTON = exports.WATCH_BUTTON = 'ASWatchButton';

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AD_COMPLETE = exports.AD_COMPLETE = 'ad-complete';
var AD_START = exports.AD_START = 'ad-start';
var USER_INTERACTION = exports.USER_INTERACTION = 'user-interaction';
var VIDEO_BUFFER = exports.VIDEO_BUFFER = 'video-buffer';
var VIDEO_COMPLETE = exports.VIDEO_COMPLETE = 'video-complete';
var VIDEO_ENDED = exports.VIDEO_ENDED = 'video-ended';
var VIDEO_FIFTY = exports.VIDEO_FIFTY = 'video-fifty';
var VIDEO_MIDROLL_COMPLETE = exports.VIDEO_MIDROLL_COMPLETE = 'video-midroll-complete';
var VIDEO_MIDROLL_START = exports.VIDEO_MIDROLL_START = 'video-midroll-start';
var VIDEO_PAUSE = exports.VIDEO_PAUSE = 'video-pause';
var VIDEO_POSTROLL_COMPLETE = exports.VIDEO_POSTROLL_COMPLETE = 'video-postroll-complete';
var VIDEO_POSTROLL_START = exports.VIDEO_POSTROLL_START = 'video-postroll-start';
var VIDEO_PREROLL = exports.VIDEO_PREROLL = 'video-preroll';
var VIDEO_PROGRESS = exports.VIDEO_PROGRESS = 'video-progress';
var VIDEO_START = exports.VIDEO_START = 'video-start';

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 15.4 12\" enable-background=\"new 0 0 15.4 12\" xml:space=\"preserve\"><g><path class=\"control-svg\" d=\"M5.5,2.7c0-1-0.7-1.7-1.7-1.7C1.4,1,1.2,4.3,1.2,6.1c0,1.7,0.2,4.9,2.5,4.9c1.2,0,1.9-0.9,1.9-2h1.2 c-0.1,1.9-1.3,3-3.2,3C0.5,12,0,8.5,0,6.1C0,3.5,0.5,0,3.8,0c1.6,0,2.8,1.1,2.9,2.7H5.5z\"></path><path class=\"control-svg\" d=\"M14.1,2.7c0-1-0.7-1.7-1.7-1.7C10,1,9.8,4.3,9.8,6.1c0,1.7,0.2,4.9,2.5,4.9c1.2,0,1.9-0.9,1.9-2h1.2 c-0.1,1.9-1.3,3-3.2,3c-3.2,0-3.6-3.5-3.6-5.9C8.6,3.5,9.1,0,12.4,0c1.6,0,2.8,1.1,2.9,2.7H14.1z\"></path></g></svg>"

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(285);


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _Player = __webpack_require__(286);

__webpack_require__(983);

module.exports = _Player.Player;
module.exports.version = process.env.VERSION;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Player = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assign = __webpack_require__(46);

var _assign2 = _interopRequireDefault(_assign);

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _hls = __webpack_require__(170);

var _hls2 = _interopRequireDefault(_hls);

var _ismobilejs = __webpack_require__(171);

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

var _ActionCreators = __webpack_require__(30);

var ActionCreators = _interopRequireWildcard(_ActionCreators);

var _store = __webpack_require__(549);

var _ASPlayer = __webpack_require__(899);

var _VideoJS = __webpack_require__(900);

var _ADBP = __webpack_require__(901);

var _ADBP2 = _interopRequireDefault(_ADBP);

var _ASDebugger = __webpack_require__(918);

var _ASDebugger2 = _interopRequireDefault(_ASDebugger);

var _freewheel = __webpack_require__(919);

var _freewheel2 = _interopRequireDefault(_freewheel);

var _auditude = __webpack_require__(925);

var _auditude2 = _interopRequireDefault(_auditude);

var _HlsJSSourceHandler = __webpack_require__(927);

var _HlsJSSourceHandler2 = _interopRequireDefault(_HlsJSSourceHandler);

__webpack_require__(929);

__webpack_require__(930);

__webpack_require__(931);

__webpack_require__(933);

__webpack_require__(936);

__webpack_require__(937);

__webpack_require__(940);

__webpack_require__(943);

__webpack_require__(945);

__webpack_require__(946);

__webpack_require__(980);

__webpack_require__(981);

__webpack_require__(982);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Player = exports.Player = function () {
	function Player() {
		var elementID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'video-player';
		var videoID = arguments[1];
		var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		_classCallCheck(this, Player);

		if (typeof elementID !== 'string') {
			console.warn('The first argument for ASVP.Player should be a string of the ID of the video HTML element.  Defaulting to \'video-player\'');
			elementID = 'video-player';
		}

		// allows for new Player(element, 'id', {}) as well as new Player(element, {})
		if (arguments.length === 2) {
			options = videoID;
		}

		// if using all three args, set the videoID in options to the second arg
		if (arguments.length === 3) {
			if (typeof arguments[1] === 'string') options.videoID = videoID;
		}

		this._elementID = elementID;
		this._options = (0, _assign2.default)({}, _ASPlayer.AS_PLAYER_DEFAULTS, options);

		this._videoElement = document.getElementById(this._elementID);

		if (this._videoElement.tagName !== 'VIDEO') {
			console.error('Element for ASVP.Player must be a video tag.');
			return false;
		}

		this._debug = (0, _ASDebugger2.default)(this._options.debug || false);

		this._originalVideoTagParent = document.getElementById(this._elementID).parentNode; // get the original parent of the video element
		this._originalVideoTag = document.getElementById(this._elementID).cloneNode(true); // clone the original video element and it's children

		// attaches hls.js as source handler for html playback
		this._attachHlsSourceHandler();

		var videoJSOptions = (0, _assign2.default)({}, _VideoJS.VIDEO_JS_DEFAULTS, this._options.videoJS || {});
		this._player = (0, _video2.default)(this._elementID, videoJSOptions);
		this._player.detectKeyboardFocus();

		this._player.addClass('adult-swim-video-player');
		this._player.addClass(_ismobilejs2.default.any ? 'mobile' : 'not-mobile');
		this._player.addClass(_ismobilejs2.default.android.device ? 'mobile--android' : 'not-mobile--android');
		this._player.addClass(_ismobilejs2.default.apple.device ? 'mobile--apple' : 'not-mobile--apple');
		this._player.addClass(_ismobilejs2.default.phone ? 'mobile--phone' : 'not-mobile--phone');
		this._player.addClass(_ismobilejs2.default.tablet ? 'mobile--tablet' : 'not-mobile--tablet');

		this._ads = this._options.ads ? new _freewheel2.default(this._player, this._options.ads) : null;
		this._auditude = this._options.ads ? new _auditude2.default(this._player, this._options.auditude) : null;

		this._store = (0, _store.configureStore)(this._getInitialState(), {
			player: this._player,
			options: this._options,
			debug: this._debug,
			analytics: _ADBP2.default,
			ads: this._ads,
			auditude: this._auditude
		}, this._options.debug);
		this._store.dispatch(ActionCreators.init());
	}

	_createClass(Player, [{
		key: '_getInitialState',
		value: function _getInitialState() {
			return {};
		}

		// if hls is supported through hls.js (and doesn't have native hls), attach HLJ.js as source handler on VideoJS

	}, {
		key: '_attachHlsSourceHandler',
		value: function _attachHlsSourceHandler() {
			var _this = this;

			if (_hls2.default.isSupported()) {
				_video2.default.getTech('Html5').registerSourceHandler({
					canHandleSource: function canHandleSource(source) {
						var hlsTypeRE = /^application\/x-mpegURL$/i;
						var hlsExtRE = /\.m3u8/i;
						var result = void 0;

						if (hlsTypeRE.test(source.type)) {
							result = 'probably';
						} else if (hlsExtRE.test(source.src)) {
							result = 'maybe';
						} else {
							result = '';
						}

						// if there's a native hls player, use it
						if (document.createElement('video').canPlayType('application/vnd.apple.mpegURL')) result = false;

						return result;
					},

					handleSource: function handleSource(source, tech) {
						if (tech.hlsProvider) tech.hlsProvider.dispose();

						tech.hlsProvider = new _HlsJSSourceHandler2.default(source, tech, _this._options.hlsJS);

						return tech.hlsProvider;
					}

				}, 0);
			}
		}

		// registers player event listening
		// use html5 video player event names - progress, loadstart, end, etc

	}, {
		key: 'on',
		value: function on(eventName, callback) {
			if (arguments.length !== 2) {
				console.error('Missing one or more arguments in registerEvent call.  Needs both eventName and callback function in that order.');
				return false;
			}

			this._player.on(eventName, callback);

			return this.off.bind(this, eventName, callback);
		}
		// alias for on

	}, {
		key: 'registerEvent',
		value: function registerEvent(eventName, callback) {
			return this.on(eventName, callback);
		}

		/**
      * deregisters player event listening
      */

	}, {
		key: 'off',
		value: function off(eventName, func) {
			if (!arguments.length) {
				console.error('Missing a required argument in deregisterEvent call.  Needs eventName passed in.');
				return false;
			}

			this._player.off(eventName, func);
		}
		// alias for off

	}, {
		key: 'deregisterEvent',
		value: function deregisterEvent(eventName, func) {
			this.off(eventName, func);
		}

		/**
   * returns the video.js player instance for manipulating playback methods
   */

	}, {
		key: 'getPlayer',
		value: function getPlayer() {
			if (!this._player) {
				console.error('ASVideoPlayer not created yet.  Cannot retrieve player.');
				return false;
			}

			return this._player;
		}
	}, {
		key: 'share',
		value: function share() {
			var action = this._store.getState().player.share ? ActionCreators.onShareControlClose() : ActionCreators.onShareControlClick();
			this._store.dispatch(action);
		}

		/* 	videoID (string) , accessToken (object)
  	use to set a new video (using unicron ids)
  	will clear out current video and request new one
  	can optionally set accessToken before playback */

	}, {
		key: 'setVideo',
		value: function setVideo(videoID, accessToken) {
			if (!arguments.length) {
				console.error('No arguments passed to setVideo.  It needs a unicron video ID to retrieve video assets.');
				return false;
			}

			if (accessToken) this._store.dispatch(ActionCreators.receiveAccessToken(accessToken));
			this._store.dispatch(ActionCreators.setVideoID(videoID));
		}

		/* 	accessToken (object)
  	use to set a new access token */

	}, {
		key: 'setAccessToken',
		value: function setAccessToken(accessToken) {
			if (!arguments.length) {
				console.error('No arguments passed to setAccessToken.  It needs a token object to set properly.');
				return false;
			}

			this._store.dispatch(ActionCreators.receiveAccessToken(accessToken));
		}

		// enables ads dynamically after initialization

	}, {
		key: 'enableAds',
		value: function enableAds() {
			this._store.dispatch(ActionCreators.enableAds());
		}

		// disables ads from playing

	}, {
		key: 'disableAds',
		value: function disableAds() {
			this._store.dispatch(ActionCreators.disableAds());
		}

		// destroys everything - video.js, events, video tag

	}, {
		key: 'destroy',
		value: function destroy() {
			var destroyVideoTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			// destroy hls.js and video.js
			if (this._player.tech_) this._player.tech_.dispose();
			this._player.dispose();

			if (!destroyVideoTag) {
				this._originalVideoTagParent.appendChild(this._originalVideoTag);
			}

			this._store.dispatch(ActionCreators.destroy());
		}
	}]);

	return Player;
}();

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateVolumeFromDrag = exports.onVolumeControlMouseOver = exports.onVolumeControlMouseOut = exports.onVolumeSliderMouseDown = exports.onTimecodeInputChange = exports.onTimecodeSelectionChange = exports.onCopyClick = exports.onShareSocial = exports.onShareControlClose = exports.onShareControlClick = exports.onDocumentMouseUp = exports.onDocumentMouseMove = exports.disableAds = exports.enableAds = exports.adsPostrollEnd = exports.adsMidrollEnd = exports.adsPrerollEnd = exports.adsStartPreroll = exports.adsEventClick = exports.adsEventError = exports.adsEventImpressionEnded = exports.adsEventImpressionStarted = exports.adsEventSlotEnded = exports.adsEventSlotStarted = exports.adsEventRequestComplete = exports.trackPostrollEnd = exports.trackPostrollStart = exports.trackMidrollEnd = exports.trackMidrollStart = exports.trackPreroll = exports.trackVideoFifty = exports.trackVideoProgress = exports.trackVideoPause = exports.trackVideoStart = exports.trackVideoComplete = exports.trackVideoBuffering = exports.trackUserInteraction = exports.retryPlainStream = exports.setStreamBlocked = exports.clearCurrentAdPod = exports.clearCurrentAd = exports.setAdClickHandler = exports.setAdEndTime = exports.setCurrentAdTimeRemaining = exports.setAdTimeRemaining = exports.setCurrentAdEndTime = exports.setCurrentAdPod = exports.setCurrentAd = exports.setPlaybackURL = exports.setVideoProgressState = exports.setQueryParamTimecodeSeekedState = exports.setAdsReturnMidrollTimeState = exports.setAdSlots = exports.setAdPlayingState = exports.setWaitingState = exports.setIsVolumeDraggingState = exports.setVolumeState = exports.startContent = exports.setVideoID = exports.setStartedState = exports.setPlayingState = exports.setPlayState = exports.setPauseState = exports.setMuteState = exports.setLiveState = exports.setFirstTimeState = exports.setErrorState = exports.setDurationState = exports.setCurrentTimeState = exports.reconnectStream = exports.fetchVideoSourceError = exports.receiveVideoPlayerData = exports.receiveAccessToken = exports.receiveCDNTokenSource = exports.receiveMediaSource = exports.receiveVideoSource = exports.hlsFragChanged = exports.hlsEventLoadError = exports.hlsEventManifestParsed = exports.hlsEventLevelLoaded = exports.hlsEventMediaAttached = exports.playerEventWaiting = exports.playerEventVolumeChange = exports.playerEventTimeUpdate = exports.playerEventReady = exports.playerEventPlaying = exports.playerEventPlay = exports.playerEventPause = exports.playerEventLoadedData = exports.playerEventFullscreenChange = exports.playerEventError = exports.playerEventEnded = exports.playerEventDurationChange = exports.playerEventCanPlayThrough = exports.destroy = exports.init = undefined;

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _ActionUtils = __webpack_require__(172);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var init = exports.init = (0, _ActionUtils.createActionCreator)(ActionTypes.INIT);
var destroy = exports.destroy = (0, _ActionUtils.createActionCreator)(ActionTypes.DESTROY);

var playerEventCanPlayThrough = exports.playerEventCanPlayThrough = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_CAN_PLAY_THROUGH);
var playerEventDurationChange = exports.playerEventDurationChange = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_DURATION_CHANGE);
var playerEventEnded = exports.playerEventEnded = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_ENDED);
var playerEventError = exports.playerEventError = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_ERROR);
var playerEventFullscreenChange = exports.playerEventFullscreenChange = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_FULLSCREEN_CHANGE);
var playerEventLoadedData = exports.playerEventLoadedData = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_LOADED_DATA);
var playerEventPause = exports.playerEventPause = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_PAUSE);
var playerEventPlay = exports.playerEventPlay = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_PLAY);
var playerEventPlaying = exports.playerEventPlaying = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_PLAYING);
var playerEventReady = exports.playerEventReady = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_READY);
var playerEventTimeUpdate = exports.playerEventTimeUpdate = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_TIME_UPDATE);
var playerEventVolumeChange = exports.playerEventVolumeChange = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_VOLUME_CHANGE);
var playerEventWaiting = exports.playerEventWaiting = (0, _ActionUtils.createActionCreator)(ActionTypes.PLAYER_EVENT_WAITING);

var hlsEventMediaAttached = exports.hlsEventMediaAttached = (0, _ActionUtils.createActionCreator)(ActionTypes.HLS_EVENT_MEDIA_ATTACHED);
var hlsEventLevelLoaded = exports.hlsEventLevelLoaded = (0, _ActionUtils.createActionCreator)(ActionTypes.HLS_EVENT_LEVEL_LOADED);
var hlsEventManifestParsed = exports.hlsEventManifestParsed = (0, _ActionUtils.createActionCreator)(ActionTypes.HLS_EVENT_MANIFEST_PARSED);
var hlsEventLoadError = exports.hlsEventLoadError = (0, _ActionUtils.createActionCreator)(ActionTypes.HLS_EVENT_LOAD_ERROR);
var hlsFragChanged = exports.hlsFragChanged = (0, _ActionUtils.createActionCreator)(ActionTypes.HLS_FRAG_CHANGED);

var receiveVideoSource = exports.receiveVideoSource = (0, _ActionUtils.createActionCreator)(ActionTypes.RECEIVE_VIDEO_SOURCE);
var receiveMediaSource = exports.receiveMediaSource = (0, _ActionUtils.createActionCreator)(ActionTypes.RECEIVE_MEDIA_SOURCE);
var receiveCDNTokenSource = exports.receiveCDNTokenSource = (0, _ActionUtils.createActionCreator)(ActionTypes.RECEIVE_CDN_TOKEN_SOURCE);
var receiveAccessToken = exports.receiveAccessToken = (0, _ActionUtils.createActionCreator)(ActionTypes.RECEIVE_ACCESS_TOKEN);
var receiveVideoPlayerData = exports.receiveVideoPlayerData = (0, _ActionUtils.createActionCreator)(ActionTypes.RECEIVE_VIDEO_PLAYER_DATA);
var fetchVideoSourceError = exports.fetchVideoSourceError = (0, _ActionUtils.createActionCreator)(ActionTypes.FETCH_VIDEO_SOURCE_ERROR);
var reconnectStream = exports.reconnectStream = (0, _ActionUtils.createActionCreator)(ActionTypes.RECONNECT_STREAM);

var setCurrentTimeState = exports.setCurrentTimeState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_CURRENT_TIME_STATE);
var setDurationState = exports.setDurationState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_DURATION_STATE);
var setErrorState = exports.setErrorState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_ERROR_STATE);
var setFirstTimeState = exports.setFirstTimeState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_FIRST_TIME_STATE);
var setLiveState = exports.setLiveState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_LIVE_STATE);
var setMuteState = exports.setMuteState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_MUTE_STATE);
var setPauseState = exports.setPauseState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_PAUSE_STATE);
var setPlayState = exports.setPlayState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_PLAYING_STATE);
var setPlayingState = exports.setPlayingState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_PLAYING_STATE);
var setStartedState = exports.setStartedState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_STARTED_STATE);
var setVideoID = exports.setVideoID = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_VIDEO_ID);
var startContent = exports.startContent = (0, _ActionUtils.createActionCreator)(ActionTypes.START_CONTENT);
var setVolumeState = exports.setVolumeState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_VOLUME_STATE);
var setIsVolumeDraggingState = exports.setIsVolumeDraggingState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_VOLUME_DRAG_STATE);
var setWaitingState = exports.setWaitingState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_WAITING_STATE);
var setAdPlayingState = exports.setAdPlayingState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_AD_PLAYING_STATE);
var setAdSlots = exports.setAdSlots = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_AD_SLOTS);
var setAdsReturnMidrollTimeState = exports.setAdsReturnMidrollTimeState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_ADS_RETURN_MIDROLL_TIME_STATE);
var setQueryParamTimecodeSeekedState = exports.setQueryParamTimecodeSeekedState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_QUERY_PARAM_TIMECODE_SEEKED_STATE);
var setVideoProgressState = exports.setVideoProgressState = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_VIDEO_PROGRESS_STATE);
var setPlaybackURL = exports.setPlaybackURL = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_PLAYBACK_URL);
var setCurrentAd = exports.setCurrentAd = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_CURRENT_AD);
var setCurrentAdPod = exports.setCurrentAdPod = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_CURRENT_AD_POD);
var setCurrentAdEndTime = exports.setCurrentAdEndTime = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_CURRENT_AD_END_TIME);
var setAdTimeRemaining = exports.setAdTimeRemaining = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_AD_TIME_REMAINING);
var setCurrentAdTimeRemaining = exports.setCurrentAdTimeRemaining = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_CURRENT_AD_TIME_REMAINING);
var setAdEndTime = exports.setAdEndTime = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_AD_END_TIME);
var setAdClickHandler = exports.setAdClickHandler = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_AD_CLICK_HANDLER);
var clearCurrentAd = exports.clearCurrentAd = (0, _ActionUtils.createActionCreator)(ActionTypes.CLEAR_CURRENT_AD);
var clearCurrentAdPod = exports.clearCurrentAdPod = (0, _ActionUtils.createActionCreator)(ActionTypes.CLEAR_CURRENT_AD_POD);
var setStreamBlocked = exports.setStreamBlocked = (0, _ActionUtils.createActionCreator)(ActionTypes.SET_STREAM_BLOCKED);
var retryPlainStream = exports.retryPlainStream = (0, _ActionUtils.createActionCreator)(ActionTypes.RETRY_PLAIN_STREAM);

var trackUserInteraction = exports.trackUserInteraction = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_USER_INTERACTION);
var trackVideoBuffering = exports.trackVideoBuffering = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_VIDEO_BUFFERING);
var trackVideoComplete = exports.trackVideoComplete = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_VIDEO_COMPLETE);
var trackVideoStart = exports.trackVideoStart = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_VIDEO_START);
var trackVideoPause = exports.trackVideoPause = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_VIDEO_PAUSE);
var trackVideoProgress = exports.trackVideoProgress = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_VIDEO_PROGRESS);
var trackVideoFifty = exports.trackVideoFifty = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_VIDEO_FIFTY);
var trackPreroll = exports.trackPreroll = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_PREROLL);
var trackMidrollStart = exports.trackMidrollStart = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_MIDROLL_START);
var trackMidrollEnd = exports.trackMidrollEnd = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_MIDROLL_END);
var trackPostrollStart = exports.trackPostrollStart = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_POSTROLL_START);
var trackPostrollEnd = exports.trackPostrollEnd = (0, _ActionUtils.createActionCreator)(ActionTypes.TRACK_POSTROLL_END);

var adsEventRequestComplete = exports.adsEventRequestComplete = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_EVENT_REQUEST_COMPLETE);
var adsEventSlotStarted = exports.adsEventSlotStarted = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_EVENT_SLOT_STARTED);
var adsEventSlotEnded = exports.adsEventSlotEnded = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_EVENT_SLOT_ENDED);
var adsEventImpressionStarted = exports.adsEventImpressionStarted = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_EVENT_IMPRESSION_STARTED);
var adsEventImpressionEnded = exports.adsEventImpressionEnded = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_EVENT_IMPRESSION_ENDED);
var adsEventError = exports.adsEventError = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_EVENT_ERROR);
var adsEventClick = exports.adsEventClick = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_EVENT_CLICK);
var adsStartPreroll = exports.adsStartPreroll = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_START_PREROLL);
var adsPrerollEnd = exports.adsPrerollEnd = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_PREROLL_END);
var adsMidrollEnd = exports.adsMidrollEnd = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_MIDROLL_END);
var adsPostrollEnd = exports.adsPostrollEnd = (0, _ActionUtils.createActionCreator)(ActionTypes.ADS_POSTROLL_END);
var enableAds = exports.enableAds = (0, _ActionUtils.createActionCreator)(ActionTypes.ENABLE_ADS);
var disableAds = exports.disableAds = (0, _ActionUtils.createActionCreator)(ActionTypes.DISABLE_ADS);

var onDocumentMouseMove = exports.onDocumentMouseMove = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_DOCUMENT_MOUSE_MOVE);
var onDocumentMouseUp = exports.onDocumentMouseUp = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_DOCUMENT_MOUSE_UP);
var onShareControlClick = exports.onShareControlClick = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_SHARE_CONTROL_CLICK);
var onShareControlClose = exports.onShareControlClose = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_SHARE_CONTROL_CLOSE);
var onShareSocial = exports.onShareSocial = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_SHARE_SOCIAL);
var onCopyClick = exports.onCopyClick = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_COPY_CLICK);
var onTimecodeSelectionChange = exports.onTimecodeSelectionChange = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_TIMECODE_SELECTION_CHANGE);
var onTimecodeInputChange = exports.onTimecodeInputChange = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_TIMECODE_INPUT_CHANGE);
var onVolumeSliderMouseDown = exports.onVolumeSliderMouseDown = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_VOLUME_SLIDER_MOUSE_DOWN);
var onVolumeControlMouseOut = exports.onVolumeControlMouseOut = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_VOLUME_CONTROL_MOUSE_OUT);
var onVolumeControlMouseOver = exports.onVolumeControlMouseOver = (0, _ActionUtils.createActionCreator)(ActionTypes.ON_VOLUME_CONTROL_MOUSE_OVER);
var updateVolumeFromDrag = exports.updateVolumeFromDrag = (0, _ActionUtils.createActionCreator)(ActionTypes.UPDATE_VOLUME_FROM_DRAG);

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeHostname = exports.getMedia = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isHLSSupported = isHLSSupported;
exports.inIframe = inIframe;
exports.serialize = serialize;
exports.timecodeFromSeconds = timecodeFromSeconds;
exports.secondsFromTimecode = secondsFromTimecode;
exports.handleErrors = handleErrors;
exports.assignDefined = assignDefined;
exports.modernizrDetect = modernizrDetect;

var _rxjs = __webpack_require__(29);

var _lodash = __webpack_require__(41);

__webpack_require__(848);

function isHLSSupported() {
    var mediaSourceSupported = typeof window.MediaSource !== 'undefined';
    var canPlayNativeHLS = !!document.createElement('video').canPlayType('application/vnd.apple.mpegURL');

    return mediaSourceSupported || canPlayNativeHLS;
}

function inIframe() {
    var checkDomain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    try {
        if (checkDomain) return !document.referrer.includes('adultswim.com') && window.self !== window.top;else return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function serialize(obj, prefix) {
    var str = [];
    for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + '[' + p + ']' : p,
                v = obj[p];
            str.push((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? serialize(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v));
        }
    }
    return str.join('&');
}

var getMedia = exports.getMedia = function getMedia(data) {
    return (0, _lodash.get)(data, 'media.desktop.unprotected') || (0, _lodash.get)(data, 'media.desktop.bulkaes');
};

var removeHostname = exports.removeHostname = function removeHostname(url) {
    return url.replace(/^.*\/\/[^\/]+/, '');
};

function timecodeFromSeconds(time) {
    var minutes = Math.floor(time / 60);
    var seconds = Math.floor(time - minutes * 60);
    return minutes + ':' + (new Array(3).join('0') + seconds).slice(-2);
}

function secondsFromTimecode(time) {
    var timeArray = time.split(':'); // optimized
    var parsed = timeArray.length > 1 ? parseInt(timeArray[0], 10) * 60 + parseInt(timeArray[1], 10) : parseInt(timeArray[0], 10);

    return parsed || 0;
}

function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}

function assignDefined(target) {
    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var source = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(source)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var key = _step2.value;

                    var val = source[key];
                    if (val !== undefined) {
                        target[key] = val;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return target;
}

function modernizrDetect(feature) {
    return _rxjs.Observable.create(function (observer) {
        Modernizr.on(feature, function (result) {
            observer.next(result);
            observer.complete();
        });
    }).catch(function () {
        return _rxjs.Observable.of(false);
    });
}

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_CONTENT_URL = exports.DEFAULT_CONTENT_URL = 'https://pmd.cdn.turner.com/xslo/cvp/assets/video/blank.mp4';
var DEFAULT_MIME_TYPE = exports.DEFAULT_MIME_TYPE = 'video/mp4';
var DEFAULT_POSTER = exports.DEFAULT_POSTER = 'https://i.cdn.turner.com/adultswim/big/video/mainstream/liveStream.jpg';
var DEFAULT_VIDEO_ID = exports.DEFAULT_VIDEO_ID = '';
var EMBED_CODE_L = exports.EMBED_CODE_L = '<iframe width=\'560\' height=\'315\' src=\'';
var EMBED_CODE_R = exports.EMBED_CODE_R = '\' frameborder=\'0\' allowfullscreen></iframe>';
var EMBED_URL = exports.EMBED_URL = 'https://www.adultswim.com/player/embed/';
var ERROR_FETCHING_SOURCE_SLATE = exports.ERROR_FETCHING_SOURCE_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/04/03/ERROR_slate.jpg';
var FACEBOOK_SHARE_URL = exports.FACEBOOK_SHARE_URL = 'https://facebook.com/sharer.php?u=';
var FORBIDDEN_SLATE = exports.FORBIDDEN_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/03/11/blocked_slate.jpg';
var HLS_MIME_TYPE = exports.HLS_MIME_TYPE = 'application/x-mpegURL';
var LIVE_STREAM_ID = exports.LIVE_STREAM_ID = 'r0xw2u30R3GchW27yVqlug';
var LOCALSTORAGE_MUTED = exports.LOCALSTORAGE_MUTED = 'as-player:muted';
var NOT_FOUND_SLATE = exports.NOT_FOUND_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/04/03/ERROR_slate.jpg';
var PROBLEM_SLATE = exports.PROBLEM_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/03/11/stream_problem_slate.jpg';
var RECONNECTING_SLATE = exports.RECONNECTING_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/04/03/please_stay_tuned_slate.jpg';
var STREAMS_SITE_URL = exports.STREAMS_SITE_URL = 'https://www.adultswim.com/streams';
var TUMBLR_SHARE_URL = exports.TUMBLR_SHARE_URL = 'https://www.tumblr.com/share/link?url=';
var TWITTER_SHARE_URL = exports.TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet?url=';
var UNSUPPORTED_CSS_CLASS = exports.UNSUPPORTED_CSS_CLASS = 'your-browser-sux';
var ERROR_CSS_CLASS = exports.ERROR_CSS_CLASS = 'error';
var VIDEO_SOURCE_QUERY_PARAMS = exports.VIDEO_SOURCE_QUERY_PARAMS = { 'fields': 'title,type,duration,collection_title,poster,stream,segments,title_id,auth,media_id,launch_date,auth_launch_date,disable_ads' };
var VIDEO_SOURCE_URL = exports.VIDEO_SOURCE_URL = window.location.hostname.includes('adultswim.com') ? '/api/shows/v1/videos/' : '//www.adultswim.com/api/shows/v1/videos/';
var MEDIA_JSON_SOURCE_URL = exports.MEDIA_JSON_SOURCE_URL = window.location.hostname.includes('adultswim.com') ? '/api/shows/v1/media/' : '//www.adultswim.com/api/shows/v1/media/';
var VIDEOS_SITE_URL = exports.VIDEOS_SITE_URL = 'https://www.adultswim.com/videos';
var CDN_TOKEN_SERVICE_URL = exports.CDN_TOKEN_SERVICE_URL = 'https://token.ngtv.io/token/token_spe';
var CDN_TOKEN_APP_ID = exports.CDN_TOKEN_APP_ID = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6ImFzLXR2ZS1kZXNrdG9wLXB0enQ2bSIsInByb2R1Y3QiOiJ0dmUiLCJuZXR3b3JrIjoiYXMiLCJwbGF0Zm9ybSI6ImRlc2t0b3AiLCJpYXQiOjE1MzI3MDIyNzl9.BzSCk-WYOZ2GMCIaeVb8zWnzhlgnXuJTCu0jGp_VaZE';

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.configureStore = undefined;

var _redux = __webpack_require__(40);

var _reduxDevtoolsExtension = __webpack_require__(564);

var _reduxObservable = __webpack_require__(25);

var _reduxLogger = __webpack_require__(571);

var _reducers = __webpack_require__(572);

var _reducers2 = _interopRequireDefault(_reducers);

var _epics = __webpack_require__(871);

var _epics2 = _interopRequireDefault(_epics);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDev = "production" !== 'production';

var configureStore = exports.configureStore = function configureStore(initialState, dependencies) {
    var debug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isDev;

    var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)(_epics2.default, { dependencies: dependencies });
    var loggerMiddleware = (0, _reduxLogger.createLogger)({
        collapsed: true,
        colors: {
            action: function action() {
                return '#03A9F4';
            },
            error: function error() {
                return '#F20404';
            },
            nextState: function nextState() {
                return '#4CAF50';
            },
            prevState: function prevState() {
                return '#9E9E9E';
            },
            title: function title() {
                return '#0074D9';
            }
        },
        duration: true,
        predicate: function predicate(getState, action) {
            return action.type !== ActionTypes.PLAYER_EVENT_TIME_UPDATE && action.type !== ActionTypes.SET_CURRENT_TIME_STATE && action.type !== ActionTypes.ON_VOLUME_CONTROL_MOUSE_OUT && action.type !== ActionTypes.ON_VOLUME_CONTROL_MOUSE_OVER && action.type !== ActionTypes.HLS_EVENT_LEVEL_LOADED && action.type !== ActionTypes.SET_WAITING_STATE && action.type !== ActionTypes.PLAYER_EVENT_LOADED_DATA && action.type !== ActionTypes.PLAYER_EVENT_WAITING && action.type !== ActionTypes.SET_PAUSE_STATE && action.type !== ActionTypes.SET_PLAYING_STATE && action.type !== ActionTypes.SET_VIDEO_PROGRESS_STATE;
        }
    });
    var middleware = debug ? (0, _redux.applyMiddleware)(loggerMiddleware, epicMiddleware) : (0, _redux.applyMiddleware)(epicMiddleware);

    return (0, _redux.createStore)(_reducers2.default, initialState, debug ? (0, _reduxDevtoolsExtension.composeWithDevTools)(middleware) : middleware);
};

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(40);

var _reducer = __webpack_require__(573);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(574);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(849);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(850);

var _reducer8 = _interopRequireDefault(_reducer7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    player: _reducer2.default,
    videoSource: _reducer4.default,
    cdnToken: _reducer6.default,
    auditude: _reducer8.default
});

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.streamBlockedReducer = exports.levelURLReducer = exports.queryParamTimecodeSeekedReducer = exports.adReturnMidrollTimeReducer = exports.adRequestCompleteReducer = exports.adPlayingReducer = exports.adsEnabledReducer = exports.waitingReducer = exports.isLiveReducer = exports.isVolumeDraggingReducer = exports.volumeReducer = exports.videoIDReducer = exports.videoFiftyReachedReducer = exports.videoProgressReducer = exports.shareReducer = exports.playingReducer = exports.pauseReducer = exports.muteReducer = exports.startedReducer = exports.firstTimeReducer = exports.errorReducer = exports.durationReducer = exports.currentTimeReducer = undefined;

var _ramda = __webpack_require__(173);

var R = _interopRequireWildcard(_ramda);

var _redux = __webpack_require__(40);

var _lodash = __webpack_require__(41);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _ActionUtils = __webpack_require__(172);

var _constants = __webpack_require__(52);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var currentTimeReducer = exports.currentTimeReducer = function currentTimeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_CURRENT_TIME_STATE), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var durationReducer = exports.durationReducer = function durationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_DURATION_STATE), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var errorReducer = exports.errorReducer = function errorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_ERROR_STATE), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var firstTimeReducer = exports.firstTimeReducer = function firstTimeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.START_CONTENT), R.always(null)], [(0, _ActionUtils.isType)(ActionTypes.SET_FIRST_TIME_STATE), R.pipe(R.prop('payload'), parseInt)], [R.T, R.always(state)]])(action);
};

var startedReducer = exports.startedReducer = function startedReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.START_CONTENT), R.always(null)], [(0, _ActionUtils.isType)(ActionTypes.SET_STARTED_STATE), R.T], [R.T, R.always(state)]])(action);
};

var muteReducer = exports.muteReducer = function muteReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_MUTE_STATE), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var pauseReducer = exports.pauseReducer = function pauseReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_PAUSE_STATE), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var playingReducer = exports.playingReducer = function playingReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_PLAYING_STATE), R.prop('payload')], [(0, _ActionUtils.isType)(ActionTypes.PLAYER_EVENT_WAITING), R.F], [(0, _ActionUtils.isType)(ActionTypes.PLAYER_EVENT_PLAYING), R.T], [R.T, R.always(state)]])(action);
};

var shareReducer = exports.shareReducer = function shareReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.ON_SHARE_CONTROL_CLICK), R.always(!state)], [(0, _ActionUtils.isType)(ActionTypes.ON_SHARE_CONTROL_CLOSE), R.F], [(0, _ActionUtils.isType)(ActionTypes.START_CONTENT), R.F], [R.T, R.always(state)]])(action);
};

var videoProgressReducer = exports.videoProgressReducer = function videoProgressReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_VIDEO_PROGRESS_STATE), R.prop('payload')], [(0, _ActionUtils.isType)(ActionTypes.SET_VIDEO_ID), R.always(0)], // reset video fifty
    [(0, _ActionUtils.isType)(ActionTypes.TRACK_VIDEO_COMPLETE), R.always(0)], // reset video fifty
    [R.T, R.always(state)]])(action);
};

var videoFiftyReachedReducer = exports.videoFiftyReachedReducer = function videoFiftyReachedReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.TRACK_VIDEO_FIFTY), R.T], [(0, _ActionUtils.isType)(ActionTypes.SET_VIDEO_ID), R.F], // reset video fifty
    [R.T, R.always(state)]])(action);
};

var videoIDReducer = exports.videoIDReducer = function videoIDReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_VIDEO_ID;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_VIDEO_ID) && R.pipe(R.prop('payload'), function (volume) {
        return R.not(R.is(String, volume));
    }), R.always(state)], // filter out non-strings
    [(0, _ActionUtils.isType)(ActionTypes.SET_VIDEO_ID), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var volumeReducer = exports.volumeReducer = function volumeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_VOLUME_STATE) && R.pipe(R.prop('payload'), function (volume) {
        return R.not(R.is(Number, volume));
    }), R.always(state)], // filter out non numbers
    [(0, _ActionUtils.isType)(ActionTypes.SET_VOLUME_STATE), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var isVolumeDraggingReducer = exports.isVolumeDraggingReducer = function isVolumeDraggingReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_VOLUME_DRAG_STATE), R.prop('payload')], [(0, _ActionUtils.isType)(ActionTypes.ON_VOLUME_SLIDER_MOUSE_DOWN), R.T], [R.T, R.always(state)]])(action);
};

var isLiveReducer = exports.isLiveReducer = function isLiveReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_LIVE_STATE), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var waitingReducer = exports.waitingReducer = function waitingReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_WAITING_STATE), R.prop('payload')], [(0, _ActionUtils.isType)(ActionTypes.PLAYER_EVENT_WAITING), R.T], [(0, _ActionUtils.isType)(ActionTypes.PLAYER_EVENT_PLAYING), R.F], [R.T, R.always(state)]])(action);
};

var adsEnabledReducer = exports.adsEnabledReducer = function adsEnabledReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.ENABLE_ADS), R.T], [(0, _ActionUtils.isType)(ActionTypes.DISABLE_ADS), R.F], [R.T, R.always(state)]])(action);
};

var adPlayingReducer = exports.adPlayingReducer = function adPlayingReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_AD_PLAYING_STATE), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var adRequestCompleteReducer = exports.adRequestCompleteReducer = function adRequestCompleteReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_AD_SLOTS), R.T], [(0, _ActionUtils.isType)(ActionTypes.START_CONTENT), R.always(null)], [R.T, R.always(state)]])(action);
};

var adReturnMidrollTimeReducer = exports.adReturnMidrollTimeReducer = function adReturnMidrollTimeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_ADS_RETURN_MIDROLL_TIME_STATE), R.prop('payload')], [(0, _ActionUtils.isType)(ActionTypes.START_CONTENT), R.always(-1)], [R.T, R.always(state)]])(action);
};

var queryParamTimecodeSeekedReducer = exports.queryParamTimecodeSeekedReducer = function queryParamTimecodeSeekedReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return R.cond([[(0, _ActionUtils.isType)(ActionTypes.SET_QUERY_PARAM_TIMECODE_SEEKED_STATE), R.prop('payload')], [R.T, R.always(state)]])(action);
};

var levelURLReducer = exports.levelURLReducer = function levelURLReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.HLS_FRAG_CHANGED:
            return (0, _lodash.get)(action.payload, 'frag.baseurl', null);
        default:
            return state;
    }
};

var streamBlockedReducer = exports.streamBlockedReducer = function streamBlockedReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_STREAM_BLOCKED:
            return action.payload;
        default:
            return state;
    }
};

exports.default = (0, _redux.combineReducers)({
    adPlaying: adPlayingReducer,
    adRequestComplete: adRequestCompleteReducer,
    adReturnMidrollTime: adReturnMidrollTimeReducer,
    adsEnabled: adsEnabledReducer,
    currentTime: currentTimeReducer,
    duration: durationReducer,
    error: errorReducer,
    firstTime: firstTimeReducer,
    isLive: isLiveReducer,
    isVolumeDragging: isVolumeDraggingReducer,
    muted: muteReducer,
    pause: pauseReducer,
    playing: playingReducer,
    queryParamTimecodeSeeked: queryParamTimecodeSeekedReducer,
    share: shareReducer,
    started: startedReducer,
    videoFiftyReached: videoFiftyReachedReducer,
    videoID: videoIDReducer,
    videoProgress: videoProgressReducer,
    volume: volumeReducer,
    waiting: waitingReducer,
    levelURL: levelURLReducer,
    streamBlocked: streamBlockedReducer
});

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(40);

var _lodash = __webpack_require__(41);

var _ActionTypes = __webpack_require__(16);

var _ASVPUtils = __webpack_require__(42);

/* VIDEO SOURCE DATA */
// metadata about the video playing -- titles, types, ids, and images

var authReducer = function authReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.auth;
        default:
            return state;
    }
};

var collectionTitleReducer = function collectionTitleReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.collection_title;
        default:
            return state;
    }
};

var titleReducer = function titleReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.title;
        default:
            return state;
    }
};

var titleIdReducer = function titleIdReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_VIDEO_SOURCE:
            return (0, _lodash.get)(action.payload.data.video, 'title_id', null);
        default:
            return state;
    }
};

var launchDateReducer = function launchDateReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_VIDEO_SOURCE:
            var launchDate = action.payload.data.video.launch_date;
            var authLaunchDate = action.payload.data.video.auth_launch_date;

            return action.payload.data.video.auth ? authLaunchDate : launchDate;
        default:
            return state;
    }
};

var typeReducer = function typeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.type;
        default:
            return state;
    }
};

var idReducer = function idReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.id;
        default:
            return state;
    }
};

var posterReducer = function posterReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.poster;
        default:
            return state;
    }
};

var disableAdsReducer = function disableAdsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_VIDEO_SOURCE:
            return (0, _lodash.get)(action.payload.data.video, 'disable_ads', null);
        default:
            return state;
    }
};

/* MEDIA SOURCE DATA */
// Includes data about the media itself - duration, media url, whether or not it has captions, and whether it requires cdn token service for playback


var mediaIdReducer = function mediaIdReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_MEDIA_SOURCE:
            return action.payload.mediaId;
        default:
            return state;
    }
};

var durationReducer = function durationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_MEDIA_SOURCE:
            var media = (0, _ASVPUtils.getMedia)(action.payload);
            return media.totalRuntime;
        default:
            return state;
    }
};

var contentURLReducer = function contentURLReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_MEDIA_SOURCE:
            var media = (0, _ASVPUtils.getMedia)(action.payload);
            return media.secureUrl;
        default:
            return state;
    }
};

var hasCaptionsReducer = function hasCaptionsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_MEDIA_SOURCE:
            var media = (0, _ASVPUtils.getMedia)(action.payload);
            return !!media.captions && !!media.captions.length;
        default:
            return state;
    }
};

var playbackURLReducer = function playbackURLReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.SET_PLAYBACK_URL:
            return action.payload;
        default:
            return state;
    }
};

exports.default = (0, _redux.combineReducers)({
    auth: authReducer,
    collectionTitle: collectionTitleReducer,
    duration: durationReducer,
    id: idReducer,
    poster: posterReducer,
    contentURL: contentURLReducer,
    playbackURL: playbackURLReducer,
    title: titleReducer,
    titleId: titleIdReducer,
    mediaId: mediaIdReducer,
    launchDate: launchDateReducer,
    type: typeReducer,
    hasCaptions: hasCaptionsReducer,
    disableAds: disableAdsReducer
});

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(40);

var _lodash = __webpack_require__(41);

var _ASVPUtils = __webpack_require__(42);

var _ActionTypes = __webpack_require__(16);

var tokenReducer = function tokenReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_CDN_TOKEN_SOURCE:
            return (0, _lodash.get)(action.payload, 'auth.token', '');
        default:
            return state;
    }
};

var accessTokenReducer = function accessTokenReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_ACCESS_TOKEN:
            return (0, _lodash.get)(action, 'payload.accessToken', '');
        default:
            return state;
    }
};

var accessTokenTypeReducer = function accessTokenTypeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_ACCESS_TOKEN:
            return (0, _lodash.get)(action, 'payload.accessTokenType', '');
        default:
            return state;
    }
};

var mvpdReducer = function mvpdReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_ACCESS_TOKEN:
            return (0, _lodash.get)(action, 'payload.mvpd', '');
        default:
            return state;
    }
};

var cdnTokenContentPathReducer = function cdnTokenContentPathReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_MEDIA_SOURCE:
            var media = (0, _ASVPUtils.getMedia)(action.payload);
            return (0, _ASVPUtils.removeHostname)(media.secureUrl);
        default:
            return state;
    }
};

var requiresCDNTokenReducer = function requiresCDNTokenReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.RECEIVE_MEDIA_SOURCE:
            var bulkaesAsset = (0, _lodash.has)(action.payload, 'media.desktop.bulkaes');
            var unprotectedAsset = (0, _lodash.has)(action.payload, 'media.desktop.unprotected');
            return bulkaesAsset && !unprotectedAsset;
        default:
            return state;
    }
};

exports.default = (0, _redux.combineReducers)({
    token: tokenReducer,
    accessToken: accessTokenReducer,
    accessTokenType: accessTokenTypeReducer,
    mpvd: mvpdReducer,
    cdnTokenContentPath: cdnTokenContentPathReducer,
    requiresCDNToken: requiresCDNTokenReducer
});

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackingCallCompleteReducer = exports.trackingCallThirdQuartileReducer = exports.trackingCallMidpointReducer = exports.trackingCallFirstQuartileReducer = exports.getVMAPTrackingUrl = exports.trackingCallBreakEndReducer = exports.trackingCallBreakStartReducer = exports.adClickHandlerReducer = exports.adEndTimeReducer = exports.currentAdTimeRemainingReducer = exports.adTimeRemainingReducer = exports.currentAdEndTimeReducer = exports.currentAdPodReducer = exports.currentAdReducer = exports.adMarkersReducer = undefined;

var _redux = __webpack_require__(40);

var _lodash = __webpack_require__(41);

var _xmlJs = __webpack_require__(851);

var _xmlJs2 = _interopRequireDefault(_xmlJs);

var _atob = __webpack_require__(869);

var _atob2 = _interopRequireDefault(_atob);

var _objTraverse = __webpack_require__(870);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var adMarkersReducer = exports.adMarkersReducer = function adMarkersReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.HLS_FRAG_CHANGED:
            var tagList = (0, _lodash.get)(action.payload, 'frag.tagList', []);
            var markers = tagList.filter(function (tag) {
                return tag[0] === 'EXT-X-MARKER' ? tag[1] : false;
            });

            var markersData = markers.map(function (marker) {
                var markerArray = marker[1].split(',');

                return markerArray;
            });

            markersData = markersData.map(function (marker) {
                var keys = marker.map(function (prop) {
                    var test = prop.split(/\=(?=(?:[^"]*"[^"]*")*[^"]*$)/g); // match only = not inside double quotes
                    return test[0];
                });
                var values = marker.map(function (prop) {
                    var test = prop.split(/\=(?=(?:[^"]*"[^"]*")*[^"]*$)/g); // match only = not inside double quotes
                    return test[1];
                });

                return Object.assign.apply(Object, _toConsumableArray(keys.map(function (k, i) {
                    return _defineProperty({}, k.toLowerCase(), values[i]);
                })));
            });

            // normalize ad markers
            markersData.map(function (obj) {
                if (obj.breakdur) obj.breakdur = parseFloat(obj.breakdur);
                if (obj.offset) obj.offset = parseFloat(obj.offset);
                if (obj.duration) obj.duration = parseFloat(obj.duration);

                if (obj.data) {
                    try {
                        obj.data = obj.data.substring(0, obj.data.length - 1); // trim first char (don't want the quote)
                        obj.data = obj.data.substring(1, obj.data.length); // trim first char (don't want the quote)
                        obj.data = !!window && !!window.atob ? window.atob(obj.data) : (0, _atob2.default)(obj.data);
                    } catch (e) {
                        console.error(e);
                        obj.data = '<?xml version="1.0" encoding="UTF-8" standalone="no"?><empty></empty>';
                    }

                    try {
                        obj.data = JSON.parse(_xmlJs2.default.xml2json(obj.data));
                    } catch (e) {
                        console.error(e);
                        obj.data = {};
                    }

                    var clickThroughElements = (0, _objTraverse.findFirst)(obj.data, 'elements', { 'name': 'ClickThrough' });
                    var clickThroughElement = (0, _lodash.find)(clickThroughElements.elements, function (obj) {
                        return obj.type === 'text';
                    });

                    obj.clickThroughURL = (0, _lodash.get)(clickThroughElement, 'text');
                }

                return obj;
            });

            return markersData;
        default:
            return state;
    }
};

var currentAdReducer = exports.currentAdReducer = function currentAdReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return action.payload;
        case ActionTypes.CLEAR_CURRENT_AD:
            return null;
        default:
            return state;
    }
};

var currentAdPodReducer = exports.currentAdPodReducer = function currentAdPodReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_POD:
            return action.payload;
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
};

var currentAdEndTimeReducer = exports.currentAdEndTimeReducer = function currentAdEndTimeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_END_TIME:
            return action.payload;
        default:
            return state;
    }
};

var adTimeRemainingReducer = exports.adTimeRemainingReducer = function adTimeRemainingReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_AD_TIME_REMAINING:
            return action.payload;
        default:
            return state;
    }
};

var currentAdTimeRemainingReducer = exports.currentAdTimeRemainingReducer = function currentAdTimeRemainingReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_TIME_REMAINING:
            return action.payload;
        default:
            return state;
    }
};

var adEndTimeReducer = exports.adEndTimeReducer = function adEndTimeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_AD_END_TIME:
            return action.payload;
        default:
            return state;
    }
};

var adClickHandlerReducer = exports.adClickHandlerReducer = function adClickHandlerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_AD_CLICK_HANDLER:
            return action.payload;
        default:
            return state;
    }
};

var trackingCallBreakStartReducer = exports.trackingCallBreakStartReducer = function trackingCallBreakStartReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_POD:
            return (0, _lodash.get)(action.payload, 'data.elements[0].elements[0].elements[0].elements[0].elements[0].elements[0].elements[0].text');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
};

var trackingCallBreakEndReducer = exports.trackingCallBreakEndReducer = function trackingCallBreakEndReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_POD:
            return (0, _lodash.get)(action.payload, 'data.elements[0].elements[0].elements[0].elements[0].elements[0].elements[1].elements[0].text');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
};

var getVMAPTrackingUrl = exports.getVMAPTrackingUrl = function getVMAPTrackingUrl(payload, eventName) {
    var trackingFragments = (0, _lodash.get)(payload, 'data.elements[0].elements');
    var adTrackingWrapper = (0, _lodash.find)(trackingFragments, function (o) {
        return (0, _lodash.get)(o, 'elements[0].elements[0].elements[0].attributes.followAdditionalWrappers');
    });
    var adDetails = (0, _lodash.get)(adTrackingWrapper, 'elements[0].elements[0].elements[0].elements');
    var creatives = (0, _lodash.find)(adDetails, function (o) {
        return (0, _lodash.get)(o, 'name') === 'Creatives';
    });
    var adTrackingDetails = (0, _lodash.get)(creatives, 'elements[0].elements[0].elements');
    var trackingEvents = (0, _lodash.find)(adTrackingDetails, function (o) {
        return (0, _lodash.get)(o, 'name') === 'TrackingEvents';
    });
    var completeEvent = (0, _lodash.find)((0, _lodash.get)(trackingEvents, 'elements', []), function (o) {
        var event = (0, _lodash.get)(o, 'attributes.event');
        return event === eventName;
    });
    return (0, _lodash.get)(completeEvent, 'elements[0].text');
};

var trackingCallFirstQuartileReducer = exports.trackingCallFirstQuartileReducer = function trackingCallFirstQuartileReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return getVMAPTrackingUrl(action.payload, 'firstQuartile');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
};

var trackingCallMidpointReducer = exports.trackingCallMidpointReducer = function trackingCallMidpointReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return getVMAPTrackingUrl(action.payload, 'midpoint');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
};

var trackingCallThirdQuartileReducer = exports.trackingCallThirdQuartileReducer = function trackingCallThirdQuartileReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return getVMAPTrackingUrl(action.payload, 'thirdQuartile');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
};

var trackingCallCompleteReducer = exports.trackingCallCompleteReducer = function trackingCallCompleteReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return getVMAPTrackingUrl(action.payload, 'complete');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
};

exports.default = (0, _redux.combineReducers)({
    adMarkers: adMarkersReducer,
    currentAd: currentAdReducer,
    currentAdPod: currentAdPodReducer,
    currentAdEndTime: currentAdEndTimeReducer,
    adTimeRemaining: adTimeRemainingReducer,
    currentAdTimeRemaining: currentAdTimeRemainingReducer,
    adEndTime: adEndTimeReducer,
    adClickHandler: adClickHandlerReducer,
    trackingCallBreakStart: trackingCallBreakStartReducer,
    trackingCallBreakEnd: trackingCallBreakEndReducer,
    trackingCallFirstQuartile: trackingCallFirstQuartileReducer,
    trackingCallMidpoint: trackingCallMidpointReducer,
    trackingCallThirdQuartile: trackingCallThirdQuartileReducer,
    trackingCallComplete: trackingCallCompleteReducer
});

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reduxObservable = __webpack_require__(25);

var _epics = __webpack_require__(872);

var _epics2 = _interopRequireDefault(_epics);

var _epics3 = __webpack_require__(873);

var _epics4 = _interopRequireDefault(_epics3);

var _epics5 = __webpack_require__(880);

var _epics6 = _interopRequireDefault(_epics5);

var _epics7 = __webpack_require__(881);

var _epics8 = _interopRequireDefault(_epics7);

var _epics9 = __webpack_require__(882);

var _epics10 = _interopRequireDefault(_epics9);

var _epics11 = __webpack_require__(894);

var _epics12 = _interopRequireDefault(_epics11);

var _epics13 = __webpack_require__(895);

var _epics14 = _interopRequireDefault(_epics13);

var _epics15 = __webpack_require__(896);

var _epics16 = _interopRequireDefault(_epics15);

var _epics17 = __webpack_require__(897);

var _epics18 = _interopRequireDefault(_epics17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxObservable.combineEpics)(_epics2.default, _epics4.default, _epics6.default, _epics8.default, _epics10.default, _epics12.default, _epics14.default, _epics16.default, _epics18.default);

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxObservable = __webpack_require__(25);

var _rxjs = __webpack_require__(29);

var _ActionCreators = __webpack_require__(30);

var ActionCreators = _interopRequireWildcard(_ActionCreators);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// set up standard video event observables
var playerEventsEpic = function playerEventsEpic(action$, __, _ref) {
    var player = _ref.player;
    return _rxjs.Observable.merge( // fires each event in turn as it occurs
    _rxjs.Observable.fromEvent(player, 'canplaythrough').mapTo(ActionCreators.playerEventCanPlayThrough()), _rxjs.Observable.fromEvent(player, 'durationchange').mapTo(ActionCreators.playerEventDurationChange()), _rxjs.Observable.fromEvent(player, 'ended').mapTo(ActionCreators.playerEventEnded()), _rxjs.Observable.fromEvent(player, 'error').map(function (e, count) {
        return ActionCreators.playerEventError(count);
    }), _rxjs.Observable.fromEvent(player, 'fullscreenchange').mapTo(ActionCreators.playerEventFullscreenChange()), _rxjs.Observable.fromEvent(player, 'loadeddata').mapTo(ActionCreators.playerEventLoadedData()), _rxjs.Observable.fromEvent(player, 'pause').mapTo(ActionCreators.playerEventPause()), _rxjs.Observable.fromEvent(player, 'play').map(function (e, count) {
        return ActionCreators.playerEventPlay(count);
    }), _rxjs.Observable.fromEvent(player, 'playing').mapTo(ActionCreators.playerEventPlaying()), _rxjs.Observable.fromEvent(player, 'ready').mapTo(ActionCreators.playerEventReady()), _rxjs.Observable.fromEvent(player, 'timeupdate').mapTo(ActionCreators.playerEventTimeUpdate()), _rxjs.Observable.fromEvent(player, 'volumechange').mapTo(ActionCreators.playerEventVolumeChange()), _rxjs.Observable.fromEvent(player, 'waiting').mapTo(ActionCreators.playerEventWaiting()), _rxjs.Observable.fromEvent(player, 'streamBlocked').mapTo(ActionCreators.setStreamBlocked(true)), _rxjs.Observable.fromEvent(player, 'streamBlocked').mapTo(ActionCreators.retryPlainStream()), _rxjs.Observable.fromEvent(player.tech_, 'hlsMediaAttached', function (e, data) {
        return ActionCreators.hlsEventMediaAttached(data);
    }), _rxjs.Observable.fromEvent(player.tech_, 'hlsManifestParsed', function (e, data) {
        return ActionCreators.hlsEventManifestParsed(data);
    }), _rxjs.Observable.fromEvent(player.tech_, 'hlsLevelLoaded', function (e, data) {
        return ActionCreators.hlsEventLevelLoaded(data);
    }), _rxjs.Observable.fromEvent(player.tech_, 'hlsLoadError', function (e, data) {
        return ActionCreators.hlsEventLoadError(data);
    }), _rxjs.Observable.fromEvent(player.tech_, 'hlsFragChanged', function (e, data) {
        return ActionCreators.hlsFragChanged(data);
    }));
};

// set the current time to first time when a video starts playing
// only do this is first time hasn't been set
var setAutoplayEpic = function setAutoplayEpic(action$, __, _ref2) {
    var player = _ref2.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_PLAYING).filter(function () {
        return !player.autoplay();
    }) // only set if autoplay if off
    .do(function () {
        return player.autoplay(true);
    }) // sets autoplay to true so content starts right up after ads
    .ignoreElements();
}; // get current time and set it to first time


// listens for video end and fires custom finished event if no ads are up next
var triggerFinishedAfterEndEvent = function triggerFinishedAfterEndEvent(action$, store, _ref3) {
    var player = _ref3.player,
        ads = _ref3.ads;
    return action$.ofType(ActionTypes.PLAYER_EVENT_ENDED).filter(function () {
        return !store.getState().player.adPlaying;
    }) // only when ad isn't playing
    .filter(function () {
        return !ads || !ads.postrolls.length;
    }) // if no ads or no postrolls
    .map(function () {
        return store.getState().videoSource;
    }).do(function (videoSource) {
        return player.trigger('finished', videoSource);
    }) // fire finished event if no more ads to play
    .ignoreElements();
};

// listens for postroll end and fires custom finished event
var triggerFinishedAfterPostroll = function triggerFinishedAfterPostroll(action$, store, _ref4) {
    var player = _ref4.player;
    return action$.ofType(ActionTypes.ADS_POSTROLL_END).map(function () {
        return store.getState().videoSource;
    }).do(function (videoSource) {
        return player.trigger('finished', videoSource);
    }).ignoreElements();
};

// const onDestroyEpic = (action$, store, { player }) => action$
//     .ofType(ActionTypes.DESTROY)
//     .ignoreElements();


exports.default = (0, _reduxObservable.combineEpics)(playerEventsEpic, setAutoplayEpic, triggerFinishedAfterEndEvent, triggerFinishedAfterPostroll);

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxObservable = __webpack_require__(25);

var _rxjs = __webpack_require__(29);

var _queryString = __webpack_require__(152);

var _queryString2 = _interopRequireDefault(_queryString);

var _attempt = __webpack_require__(275);

var _attempt2 = _interopRequireDefault(_attempt);

var _lodash = __webpack_require__(41);

var _ActionCreators = __webpack_require__(30);

var ActionCreators = _interopRequireWildcard(_ActionCreators);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _constants = __webpack_require__(52);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

// if there's a muted state set to true in localstorage, mute player on init
var setInitialMuteStateEpic = function setInitialMuteStateEpic(action$, __, _ref) {
    var player = _ref.player;
    return action$.ofType(ActionTypes.INIT).map(function () {
        return (0, _attempt2.default)(function () {
            return !!JSON.parse(window.localStorage.getItem(_constants.LOCALSTORAGE_MUTED));
        });
    }).filter(function (muted) {
        return !!muted;
    }).do(function (muted) {
        return player.muted(muted);
    }).ignoreElements();
};

var setInitialVideoIDEpic = function setInitialVideoIDEpic(action$, __, _ref2) {
    var options = _ref2.options;
    return action$.ofType(ActionTypes.INIT).filter(function () {
        return !!options.videoID;
    }).map(function () {
        return options;
    }).pluck('videoID').map(function (videoID) {
        return ActionCreators.setVideoID(videoID);
    });
};

// enable or disable ads based on inital state of ads dependency
var setInitialAdsStateEpic = function setInitialAdsStateEpic(action$, __, _ref3) {
    var ads = _ref3.ads;
    return action$.ofType(ActionTypes.INIT).map(function () {
        return ads;
    }).switchMap(function (ads) {
        return _rxjs.Observable.of(!!ads ? ActionCreators.enableAds() : ActionCreators.disableAds());
    });
};

var setFirstTimeStateEpic = function setFirstTimeStateEpic(action$, store, _ref4) {
    var player = _ref4.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_PLAYING).filter(function () {
        return !store.getState().player.adPlaying;
    }) // only when ad isn't playing
    .filter(function () {
        return store.getState().player.firstTime === null;
    }) // only set if first time is null
    .map(function () {
        return player.currentTime();
    }).map(function (currentTime) {
        return ActionCreators.setFirstTimeState(currentTime);
    });
}; // get current time and set it to first time


// sets the video started state
// only applies when content starts, not ads
var setStartedStateEpic = function setStartedStateEpic(action$, store, _ref5) {
    _objectDestructuringEmpty(_ref5);

    return action$.ofType(ActionTypes.PLAYER_EVENT_PLAYING).filter(function () {
        return store.getState().player.started === null;
    }) // only set if first time is null
    .filter(function () {
        return !store.getState().player.adPlaying;
    }) // only when ad isn't playing
    .map(function () {
        return ActionCreators.setStartedState();
    });
}; // get current time and set it to first time


var setCurrentTimeEpic = function setCurrentTimeEpic(action$, __, _ref6) {
    var player = _ref6.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_TIME_UPDATE).map(function () {
        return player.currentTime();
    }).map(function (currentTime) {
        return ActionCreators.setCurrentTimeState(currentTime);
    });
};

var setPlayingStateEpic = function setPlayingStateEpic(action$, __, _ref7) {
    var player = _ref7.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_PLAYING).map(function () {
        return player.paused();
    }).switchMap(function (paused) {
        return _rxjs.Observable.of(ActionCreators.setPlayingState(!paused), ActionCreators.setPauseState(paused));
    });
};

var setPauseStateEpic = function setPauseStateEpic(action$, __, _ref8) {
    var player = _ref8.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_PAUSE).map(function () {
        return player.paused();
    }).switchMap(function (paused) {
        return _rxjs.Observable.of(ActionCreators.setPauseState(paused), ActionCreators.setPlayingState(!paused));
    });
};

// save the duration to the state
var setDurationStateEpic = function setDurationStateEpic(action$, __, _ref9) {
    var player = _ref9.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_DURATION_CHANGE).map(function () {
        return player.duration();
    }).filter(function (duration) {
        return !(0, _lodash.isNaN)(duration);
    }).map(function (duration) {
        return ActionCreators.setDurationState(duration);
    });
};

var setVolumeStateEpic = function setVolumeStateEpic(action$, __, _ref10) {
    var player = _ref10.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_VOLUME_CHANGE).map(function () {
        return player.muted();
    }) // get mute state from player
    .distinctUntilChanged() // stop here if the muted state hasn't changed
    .do(function (muted) {
        return window.localStorage.setItem(_constants.LOCALSTORAGE_MUTED, muted);
    }) // set the local storage mute state
    .switchMap(function (muted) {
        return _rxjs.Observable.of(ActionCreators.setMuteState(muted), muted ? ActionCreators.setVolumeState(0) : ActionCreators.setVolumeState(player.volume()));
    });
};

var setVideoProgressStateEpic = function setVideoProgressStateEpic(action$, store, _ref11) {
    _objectDestructuringEmpty(_ref11);

    return action$.ofType(ActionTypes.PLAYER_EVENT_TIME_UPDATE).throttleTime(1000).filter(function () {
        return !store.getState().player.adPlaying;
    }) // only when ad isn't playing
    .map(function () {
        return ActionCreators.setVideoProgressState(store.getState().player.videoProgress += 1);
    });
}; // add 1 to the seconds or time watched


// set live state to the hls stream type
var setLiveStateFromStream = function setLiveStateFromStream(action$, __, _ref12) {
    _objectDestructuringEmpty(_ref12);

    return action$.ofType(ActionTypes.HLS_EVENT_LEVEL_LOADED).pluck('payload', 'details', 'live').map(function (isLive) {
        return ActionCreators.setLiveState(isLive);
    });
};

// Save the error text from from the player to the state
var setErrorStateEpic = function setErrorStateEpic(action$, __, _ref13) {
    var player = _ref13.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_ERROR).map(function () {
        return ActionCreators.setErrorState(player.error());
    });
};

// handle query timecode
var handleQueryParamTimecodeEpic = function handleQueryParamTimecodeEpic(action$, store, _ref14) {
    var player = _ref14.player,
        options = _ref14.options;
    return action$.ofType(ActionTypes.PLAYER_EVENT_CAN_PLAY_THROUGH).filter(function () {
        return !!options.queryParamTimecode;
    }) // when query param timecode seeking is turned on
    .filter(function () {
        return !store.getState().player.queryParamTimecodeSeeked;
    }) // when timecode hasn't already been seeked to
    .filter(function () {
        return !store.getState().player.adPlaying;
    }) // when an ad is not playing
    .map(function () {
        return _queryString2.default.parse(location.search);
    }).map(function (queryParams) {
        return parseInt(queryParams.t);
    }) // map to timecode
    .filter(function (timecode) {
        return !(0, _lodash.isNaN)(timecode);
    }) // if not a number, stop
    .filter(function () {
        return (0, _lodash.isFinite)(player.duration());
    }) // if player is a live stream, stop
    .do(function (timecode) {
        return player.currentTime(timecode);
    }) // seek to the time
    .map(function () {
        return ActionCreators.setQueryParamTimecodeSeekedState(true);
    });
}; // save muted to state and fire event


exports.default = (0, _reduxObservable.combineEpics)(handleQueryParamTimecodeEpic, setCurrentTimeEpic, setDurationStateEpic, setErrorStateEpic, setFirstTimeStateEpic, setInitialAdsStateEpic, setInitialMuteStateEpic, setInitialVideoIDEpic, setLiveStateFromStream, setPauseStateEpic, setPlayingStateEpic, setStartedStateEpic, setVideoProgressStateEpic, setInitialVideoIDEpic, setVolumeStateEpic);

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxObservable = __webpack_require__(25);

var _rxjs = __webpack_require__(29);

var _ActionCreators = __webpack_require__(30);

var ActionCreators = _interopRequireWildcard(_ActionCreators);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _videoTypes = __webpack_require__(105);

var VideoTypes = _interopRequireWildcard(_videoTypes);

var _ASVPUtils = __webpack_require__(42);

var _constants = __webpack_require__(52);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

var setSourceFromVideoTagEpic = function setSourceFromVideoTagEpic(action$, store, _ref) {
    var player = _ref.player,
        options = _ref.options;
    return action$.ofType(ActionTypes.PLAYER_EVENT_READY).filter(function () {
        return !options.videoID;
    }).filter(function () {
        return !store.getState().player.videoID;
    }).map(function () {
        return player.tech('Html5').currentSrc();
    }).filter(function (src) {
        return !!src;
    }).do(function (src) {
        return player.src({ 'src': src });
    }).ignoreElements();
};

// when player is ready and/or video id is set -- fetch the data based on the videoID in the state
// the initial state might have the video id from how it's passed in on player creation (PLAYER_EVENT_READY)
// SET_VIDEO_ID will have set the video id to a new one.
var fetchVideoSourceEpic = function fetchVideoSourceEpic(action$, store, _ref2) {
    _objectDestructuringEmpty(_ref2);

    return action$.ofType(ActionTypes.SET_VIDEO_ID).map(function () {
        return store.getState().player.videoID;
    }).distinctUntilChanged() // stop here if the video id hasn't changed
    .filter(Boolean) // if video id exists
    .switchMap(function (videoID) {
        return _rxjs.Observable.fromPromise(fetch('' + _constants.VIDEO_SOURCE_URL + videoID + '?' + (0, _ASVPUtils.serialize)(_constants.VIDEO_SOURCE_QUERY_PARAMS)) // gets new video data from id
        .then(_ASVPUtils.handleErrors).then(function (res) {
            return res.json();
        }).then(function (response) {
            return ActionCreators.receiveVideoSource(response);
        }).catch(function (data) {
            return ActionCreators.fetchVideoSourceError(data);
        }));
    });
};

var fetchMediaSourceEpic = function fetchMediaSourceEpic(action$, store, _ref3) {
    _objectDestructuringEmpty(_ref3);

    return action$.ofType(ActionTypes.SET_VIDEO_ID).map(function () {
        return store.getState().player.videoID;
    }).distinctUntilChanged() // stop here if the video id hasn't changed
    .filter(Boolean) // if video id exists
    .switchMap(function (videoID) {
        return _rxjs.Observable.fromPromise(fetch('' + _constants.MEDIA_JSON_SOURCE_URL + videoID + '/desktop') // gets new video data from id
        .then(_ASVPUtils.handleErrors).then(function (res) {
            return res.json();
        }).then(function (response) {
            return ActionCreators.receiveMediaSource(response);
        }).catch(function (data) {
            return ActionCreators.fetchVideoSourceError(data);
        }));
    });
};

// sets slate for video source error
var fetchVideoSourceError = function fetchVideoSourceError(action$, __, _ref4) {
    var player = _ref4.player;
    return action$.ofType(ActionTypes.FETCH_VIDEO_SOURCE_ERROR).do(function (data) {
        return console.error('fetchVideoSourceError', data);
    }).do(function () {
        return player.addClass(_constants.ERROR_CSS_CLASS);
    }).do(function () {
        return player.pause();
    }).do(function () {
        return player.poster(_constants.ERROR_FETCHING_SOURCE_SLATE);
    }).ignoreElements();
};

// called when video and media source are finished processing
// because we need both sources for playback
var receiveVideoPlayerDataEpic = function receiveVideoPlayerDataEpic(action$, store, _ref5) {
    _objectDestructuringEmpty(_ref5);

    return action$.ofType(ActionTypes.SET_VIDEO_ID).map(function () {
        return store.getState().player.videoID;
    }).distinctUntilChanged() // stop here if the video id hasn't changed
    .filter(Boolean) // if video id exists
    .switchMap(function () {
        return _rxjs.Observable.combineLatest(action$.ofType(ActionTypes.RECEIVE_VIDEO_SOURCE), action$.ofType(ActionTypes.RECEIVE_MEDIA_SOURCE), action$.ofType(ActionTypes.RECEIVE_CDN_TOKEN_SOURCE)).take(1);
    }).map(function () {
        return ActionCreators.receiveVideoPlayerData();
    });
}; // get video source state from store


// sets the playback url either using the cdn token or the auditude url
var setPlaybackURLEpic = function setPlaybackURLEpic(action$, store, _ref6) {
    var auditude = _ref6.auditude;
    return action$.ofType(ActionTypes.RECEIVE_VIDEO_PLAYER_DATA).map(function () {
        return store.getState();
    }).switchMap(function (state) {
        var useSSAI = true;

        if (!state.player.adsEnabled || state.player.streamBlocked || state.videoSource.disableAds || state.videoSource.type !== VideoTypes.STREAM) {
            useSSAI = false;
        }

        return useSSAI ? _rxjs.Observable.of(ActionCreators.setPlaybackURL(auditude.buildURL(state.videoSource, state.cdnToken.token))) : _rxjs.Observable.of(ActionCreators.setPlaybackURL(state.videoSource.contentURL + '?hdnts=' + state.cdnToken.token));
    });
};

// set/unset unsupported css class if can't play media
var setUnsupportedClassEpic = function setUnsupportedClassEpic(action$, __, _ref7) {
    var player = _ref7.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_CAN_PLAY_THROUGH).do(function () {
        return player.currentType() === _constants.HLS_MIME_TYPE && !(0, _ASVPUtils.isHLSSupported)() ? player.addClass(_constants.UNSUPPORTED_CSS_CLASS) : player.removeClass(_constants.UNSUPPORTED_CSS_CLASS);
    }).ignoreElements();
};

// always initialize player with content url first (bug where ad won't unpause)
// if ads enabled don't start content yet
// otherwise, start content right away
var startContentEpic = function startContentEpic(action$, store, _ref8) {
    var player = _ref8.player;
    return action$.ofType(ActionTypes.SET_PLAYBACK_URL).map(function () {
        return store.getState();
    }) // get video source state from store
    .filter(function (state) {
        return !!state.videoSource.playbackURL;
    }).do(function (state) {
        return player.src({ 'type': _constants.HLS_MIME_TYPE, 'src': state.videoSource.playbackURL });
    }).switchMap(function (state) {
        return state.player.adsEnabled ? _rxjs.Observable.empty() : _rxjs.Observable.of(ActionCreators.startContent());
    });
};

// start content after preroll/midroll
var startContentAfterPrerollEpic = function startContentAfterPrerollEpic(action$, store, _ref9) {
    var player = _ref9.player;
    return action$.ofType(ActionTypes.ADS_PREROLL_END).map(function () {
        return store.getState().videoSource.playbackURL;
    }).filter(Boolean).do(function (playbackURL) {
        return player.src({ 'type': _constants.HLS_MIME_TYPE, 'src': playbackURL });
    }).map(function () {
        return ActionCreators.startContent();
    });
};

// reconnect content on force or when midroll ends
var reconnectStreamEpic = function reconnectStreamEpic(action$, store, _ref10) {
    var player = _ref10.player;
    return _rxjs.Observable.merge(action$.ofType(ActionTypes.ADS_MIDROLL_END), action$.ofType(ActionTypes.RECONNECT_STREAM)).map(function () {
        return store.getState().videoSource.playbackURL;
    }).filter(Boolean).do(function (playbackURL) {
        return player.src({ 'type': _constants.HLS_MIME_TYPE, 'src': playbackURL });
    }).ignoreElements();
};

exports.default = (0, _reduxObservable.combineEpics)(fetchMediaSourceEpic, fetchVideoSourceEpic, fetchVideoSourceError, receiveVideoPlayerDataEpic, setSourceFromVideoTagEpic, setPlaybackURLEpic, setUnsupportedClassEpic, startContentAfterPrerollEpic, startContentEpic, reconnectStreamEpic);

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxObservable = __webpack_require__(25);

var _rxjs = __webpack_require__(29);

var _ActionCreators = __webpack_require__(30);

var ActionCreators = _interopRequireWildcard(_ActionCreators);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _ASVPUtils = __webpack_require__(42);

var _constants = __webpack_require__(52);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

var getCDNTokenServiceParams = function getCDNTokenServiceParams(state) {
    return {
        format: 'json',
        appId: _constants.CDN_TOKEN_APP_ID,
        path: state.cdnToken.cdnTokenContentPath,
        accessTokenType: state.videoSource.auth ? state.cdnToken.accessTokenType : null,
        accessToken: state.videoSource.auth ? state.cdnToken.accessToken : null
    };
};

var setMVPDEpic = function setMVPDEpic(action$, __, _ref) {
    var ads = _ref.ads;
    return action$.ofType(ActionTypes.RECEIVE_ACCESS_TOKEN).pluck('payload', 'mvpd').filter(Boolean).do(function (mvpd) {
        return ads.setMVPD(mvpd);
    }).ignoreElements();
};

var setInitialAccessToken = function setInitialAccessToken(action$, __, _ref2) {
    var options = _ref2.options;
    return action$.ofType(ActionTypes.INIT).filter(function () {
        return !!options.accessToken;
    }).map(function () {
        return options;
    }).map(function (options) {
        return ActionCreators.receiveAccessToken(options.accessToken);
    });
};

var fetchCDNTokenServiceEpic = function fetchCDNTokenServiceEpic(action$, store, _ref3) {
    _objectDestructuringEmpty(_ref3);

    return action$.ofType(ActionTypes.SET_VIDEO_ID).switchMap(function () {
        return _rxjs.Observable.combineLatest(action$.ofType(ActionTypes.RECEIVE_VIDEO_SOURCE), action$.ofType(ActionTypes.RECEIVE_MEDIA_SOURCE)).take(1);
    }).map(function () {
        return store.getState();
    }).switchMap(function (state) {
        return state.cdnToken.requiresCDNToken ? _rxjs.Observable.fromPromise(fetch(_constants.CDN_TOKEN_SERVICE_URL + '?' + (0, _ASVPUtils.serialize)(getCDNTokenServiceParams(state))).then(_ASVPUtils.handleErrors).then(function (res) {
            return res.json();
        }).then(function (response) {
            return ActionCreators.receiveCDNTokenSource(response);
        }).catch(function (data) {
            return ActionCreators.fetchVideoSourceError(data);
        })) : _rxjs.Observable.of(ActionCreators.receiveCDNTokenSource({}));
    });
};

exports.default = (0, _reduxObservable.combineEpics)(fetchCDNTokenServiceEpic, setInitialAccessToken, setMVPDEpic);

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _reduxObservable = __webpack_require__(25);

var _rxjs = __webpack_require__(29);

var _assign = __webpack_require__(46);

var _assign2 = _interopRequireDefault(_assign);

var _kebabCase = __webpack_require__(276);

var _kebabCase2 = _interopRequireDefault(_kebabCase);

var _ActionCreators = __webpack_require__(30);

var ActionCreators = _interopRequireWildcard(_ActionCreators);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _videoTypes = __webpack_require__(105);

var VideoTypes = _interopRequireWildcard(_videoTypes);

var _ASVPUtils = __webpack_require__(42);

var _constants = __webpack_require__(52);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIDROLL_CLASSNAME = 'midroll-dot';

// initialization for share control
var shareControlInitEpic = function shareControlInitEpic(action$, store, _ref) {
    var player = _ref.player,
        options = _ref.options;
    return action$.ofType(ActionTypes.INIT).filter(function () {
        return Boolean(options.share);
    }) // don't show if options force no share
    .map(function () {
        return player && player.controlBar ? player.controlBar.getChild(Controls.SHARE_CONTROL) : null;
    }).switchMap(function (shareControl) {
        if (!shareControl) {
            return _rxjs.Observable.empty();
        }
        return _rxjs.Observable.fromEvent(shareControl, 'click').map(function () {
            return store.getState().player.share;
        }).map(function (share) {
            return share ? ActionCreators.onShareControlClose() : ActionCreators.onShareControlClick();
        });
    });
};

/* adult swim return home control */
var controlsAdultSwimReturnEpic = function controlsAdultSwimReturnEpic(action$, store, _ref2) {
    var player = _ref2.player;
    return action$.ofType(ActionTypes.START_CONTENT).filter(function () {
        return (0, _ASVPUtils.inIframe)();
    }).map(function () {
        if (!player || !player.controlBar) {
            return false;
        }
        return player.controlBar.getChild(Controls.WATCH_BUTTON) || player.controlBar.addChild(Controls.WATCH_BUTTON);
    }).filter(Boolean).do(function (control) {
        var _store$getState$video = store.getState().videoSource,
            collectionTitle = _store$getState$video.collectionTitle,
            title = _store$getState$video.title;

        var url = '' + _constants.VIDEOS_SITE_URL + (0, _kebabCase2.default)(collectionTitle) + '/' + (0, _kebabCase2.default)(title);
        control.url(url);
    }).ignoreElements();
};

/* AD countdown display */
var adCountdownEpic = function adCountdownEpic(action$, __, _ref3) {
    var player = _ref3.player,
        ads = _ref3.ads;
    return action$.ofType(ActionTypes.SET_AD_PLAYING_STATE).pluck('payload').distinctUntilChanged().do(function (adPlaying) {
        if (adPlaying) {
            var adCountdown = player.getChild(Controls.AD_COUNTDOWN) || player.addChild(Controls.AD_COUNTDOWN);
            adCountdown.slot(ads.getCurrentSlot());
        } else {
            player.removeChild(Controls.AD_COUNTDOWN);
        }
    }).ignoreElements();
};

/* AD Midroll points on progress bar */
var adMidrollPointsEpic = function adMidrollPointsEpic(action$, store, _ref4) {
    var player = _ref4.player,
        ads = _ref4.ads;
    return action$.ofType(ActionTypes.PLAYER_EVENT_LOADED_DATA).filter(function () {
        return !!store.getState().player.adsEnabled;
    }) // when ads are turned on
    .filter(function () {
        return !store.getState().player.adPlaying;
    }) // when an ad is not playing
    .filter(function () {
        return !!ads.midrolls.length;
    }) // only when there are midrolls
    .do(function () {
        var progressControl = player.controlBar ? player.controlBar.getChild(Controls.PROGRESS_CONTROL) : null;

        if (!progressControl) {
            return;
        }

        for (var i = 0; i < ads.midrolls.length; i++) {
            var slot = ads.midrolls[i];
            var slotTimePosition = slot.getTimePosition();
            var div = document.createElement('div');

            div.className = MIDROLL_CLASSNAME;
            div.style.left = slotTimePosition / store.getState().videoSource.duration * 100 + '%';
            progressControl.el().appendChild(div);
        }
    }).ignoreElements();
};

var removeAdMidrollPointsEpic = function removeAdMidrollPointsEpic(action$, store, _ref5) {
    var player = _ref5.player;
    return _rxjs.Observable.merge(action$.ofType(ActionTypes.START_CONTENT), action$.ofType(ActionTypes.ADS_MIDROLL_END)).filter(function () {
        return !!store.getState().player.adsEnabled;
    }) // when ads are turned on
    .do(function () {
        var progressControl = player.controlBar ? player.controlBar.getChild(Controls.PROGRESS_CONTROL) : null;

        if (progressControl) {
            var previousMidrolls = progressControl.el().getElementsByClassName(MIDROLL_CLASSNAME);
            while (previousMidrolls.length > 0) {
                // remove previous midrolls from previous content
                previousMidrolls[0].parentNode.removeChild(previousMidrolls[0]);
            }
        }
    }).ignoreElements();
};

// if the live state is newly changed and it's false but it should be a stream, throw up the reconnecting slate
var showReconnectingSlateEpic = function showReconnectingSlateEpic(action$, store, _ref6) {
    var player = _ref6.player;
    return action$.ofType(ActionTypes.SET_LIVE_STATE).pluck('payload').distinctUntilChanged().filter(function (isLive) {
        return isLive === false;
    }).map(function () {
        return store.getState().videoSource.type;
    }).filter(function (videoType) {
        return videoType === VideoTypes.STREAM;
    }).do(function () {
        return player.poster(_constants.RECONNECTING_SLATE);
    }) // set the poster
    .do(function () {
        return player.pause();
    }) // pause the content
    .delay(10000) // wait a few seconds
    .switchMapTo(_rxjs.Observable.of(ActionCreators.setLiveState(null), // reset live state so it knows to check again for a broken stream
    ActionCreators.reconnectStream() // try to reconnect the stream
    ));
};

var show403SlateEpic = function show403SlateEpic(action$, __, _ref7) {
    var player = _ref7.player;
    return action$.ofType(ActionTypes.HLS_EVENT_LOAD_ERROR).pluck('payload', 'networkDetails').filter(function (networkDetails) {
        return !!networkDetails;
    }).pluck('status').filter(function (status) {
        return status === 403;
    }).do(function () {
        return player.pause();
    }) // pause the content
    .do(function () {
        return player.poster(_constants.FORBIDDEN_SLATE);
    }).ignoreElements();
};

var show404SlateEpic = function show404SlateEpic(action$, __, _ref8) {
    var player = _ref8.player;
    return action$.ofType(ActionTypes.HLS_EVENT_LOAD_ERROR).pluck('payload', 'networkDetails').filter(function (networkDetails) {
        return !!networkDetails;
    }).pluck('status').filter(function (status) {
        return status === 404;
    }).do(function () {
        return player.pause();
    }) // pause the content
    .do(function () {
        return player.poster(_constants.NOT_FOUND_SLATE);
    }).ignoreElements();
};

var showProblemSlateEpic = function showProblemSlateEpic(action$, __, _ref9) {
    var player = _ref9.player;
    return action$.ofType(ActionTypes.HLS_EVENT_LOAD_ERROR).pluck('payload', 'networkDetails').filter(function (networkDetails) {
        return !!networkDetails;
    }).pluck('status').filter(function (status) {
        return status !== 404 && status !== 403;
    }).do(function () {
        return player.pause();
    }) // pause the content
    .do(function () {
        return player.poster(_constants.PROBLEM_SLATE);
    }).delay(10000) // wait a few seconds
    .map(function () {
        return ActionCreators.reconnectStream();
    });
};

var showProblemSlateNoDetailsEpic = function showProblemSlateNoDetailsEpic(action$, __, _ref10) {
    var player = _ref10.player;
    return action$.ofType(ActionTypes.HLS_EVENT_LOAD_ERROR).pluck('payload', 'networkDetails').filter(function (networkDetails) {
        return !networkDetails;
    }).do(function () {
        return player.pause();
    }) // pause the content
    .do(function () {
        return player.poster(_constants.PROBLEM_SLATE);
    }).delay(10000) // wait a few seconds
    .map(function () {
        return ActionCreators.reconnectStream();
    });
};

var showShareOverlayEpic = function showShareOverlayEpic(action$, store, _ref11) {
    var player = _ref11.player,
        options = _ref11.options;
    return action$.ofType(ActionTypes.ON_SHARE_CONTROL_CLICK).filter(function () {
        return store.getState().player.share;
    }).switchMap(function () {
        var _store$getState = store.getState(),
            playerState = _store$getState.player,
            videoSource = _store$getState.videoSource;

        player.addClass('as-sharing');

        var ShareOverlay = _video2.default.getComponent(Controls.SHARE_OVERLAY);

        var content = new ShareOverlay(player, (0, _assign2.default)({
            video: videoSource
        }, options));

        var modal = player.createModal(content.el(), {
            label: 'Share',
            pauseOnOpen: playerState.adPlaying || !store.getState().player.isLive
        });

        modal.addClass('as-share-modal-dialog');

        var modalClose$ = _rxjs.Observable.fromEvent(modal, 'modalclose').do(function () {
            content.dispose();
            player.removeClass('as-sharing');
        }).take(1).filter(function () {
            return store.getState().player.share;
        }).mapTo(ActionCreators.onShareControlClose());

        var close$ = action$.ofType(ActionTypes.ON_SHARE_CONTROL_CLOSE, ActionTypes.START_CONTENT).filter(function () {
            return modal && modal.opened();
        }).do(function () {
            return modal.close();
        }).ignoreElements();

        var userInteraction$ = _rxjs.Observable.fromEvent(content, 'userInteraction', function (event, data) {
            return data;
        }).takeUntil(_rxjs.Observable.fromEvent(content, 'dispose')).map(ActionCreators.trackUserInteraction);

        return _rxjs.Observable.merge(close$, modalClose$, userInteraction$);
    });
};

var setPosterEpic = function setPosterEpic(action$, store, _ref12) {
    var player = _ref12.player;
    return _rxjs.Observable.merge(action$.ofType(ActionTypes.RECEIVE_VIDEO_PLAYER_DATA), action$.ofType(ActionTypes.RECONNECT_STREAM), action$.ofType(ActionTypes.RETRY_PLAIN_STREAM)).map(function () {
        return store.getState().videoSource.poster;
    }).filter(Boolean).do(function (poster) {
        return player.poster(poster);
    }).ignoreElements();
};

// if browsers let the video autoplay and playsinline and it's not a touch device
// mute the player and show the muted overlay
var mutedOverlayEpic = function mutedOverlayEpic(action$, __, _ref13) {
    var player = _ref13.player;
    return action$.ofType(ActionTypes.INIT).take(1).filter(function () {
        return player.autoplay();
    }).switchMap(function () {
        return _rxjs.Observable.zip((0, _ASVPUtils.modernizrDetect)('videoautoplay'), (0, _ASVPUtils.modernizrDetect)('touchevents'));
    }).filter(function (_ref14) {
        var _ref15 = _slicedToArray(_ref14, 2),
            videoautoplay = _ref15[0],
            touchevents = _ref15[1];

        return !videoautoplay && !touchevents && player.playsinline();
    }).do(function () {
        return player.muted(true);
    }).switchMap(function () {
        return _rxjs.Observable.fromPromise(player.play()).mapTo(true).catch(function () {
            return _rxjs.Observable.of(false);
        });
    }).filter(Boolean).do(function () {
        return player.addChild(Controls.MUTED_OVERLAY_BUTTON, undefined, 1);
    }).ignoreElements();
};

exports.default = (0, _reduxObservable.combineEpics)(controlsAdultSwimReturnEpic, adCountdownEpic, adMidrollPointsEpic, removeAdMidrollPointsEpic, showReconnectingSlateEpic, showProblemSlateNoDetailsEpic, show403SlateEpic, show404SlateEpic, showProblemSlateEpic, shareControlInitEpic, showShareOverlayEpic, setPosterEpic, mutedOverlayEpic);

/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxObservable = __webpack_require__(25);

var _rxjs = __webpack_require__(29);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// show/hide captions buttons based on video source
var toggleCaptionsButtonEpic = function toggleCaptionsButtonEpic(action$, store, _ref) {
    var player = _ref.player;
    return action$.ofType(ActionTypes.RECEIVE_VIDEO_PLAYER_DATA).map(function () {
        return store.getState().videoSource;
    }) // get video source state from store
    .do(function (videoSource) {
        return player.toggleClass('has-captions', videoSource.hasCaptions);
    }).ignoreElements();
};

// add captions manually to menu select for captions embedded in live streams
var addCaptionsToMenuEpic = function addCaptionsToMenuEpic(action$, __, _ref2) {
    var player = _ref2.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_READY).switchMap(function () {
        return _rxjs.Observable.fromEvent(player.tech_.el().textTracks, 'addtrack');
    }).filter(function (_ref3) {
        var track = _ref3.track;
        return track.kind === 'captions';
    }).do(function (_ref4) {
        var track = _ref4.track;
        return player.tech_.remoteTextTracks().addTrack(track);
    }) // attach embedded cea 708 captions to videojs menu controls
    .ignoreElements();
};

exports.default = (0, _reduxObservable.combineEpics)(toggleCaptionsButtonEpic, addCaptionsToMenuEpic);

/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxObservable = __webpack_require__(25);

var _rxjs = __webpack_require__(29);

var _ActionCreators = __webpack_require__(30);

var ActionCreators = _interopRequireWildcard(_ActionCreators);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _ADBPEventType = __webpack_require__(277);

var ADBPEventType = _interopRequireWildcard(_ADBPEventType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

var trackShareSocialEpic = function trackShareSocialEpic(action$, __, _ref) {
    _objectDestructuringEmpty(_ref);

    return action$.ofType(ActionTypes.ON_SHARE_SOCIAL).pluck('payload', 'currentTarget').map(function (currentTarget) {
        return ActionCreators.trackUserInteraction(currentTarget.getAttribute('data-user-interaction'));
    });
};

var trackVideoProgressEpic = function trackVideoProgressEpic(action$, store, _ref2) {
    var options = _ref2.options;
    return action$.ofType(ActionTypes.SET_VIDEO_PROGRESS_STATE).filter(function () {
        return !!options.tracking;
    }).map(function () {
        return store.getState().player.videoProgress;
    }) // get progress
    .filter(function (progress) {
        return progress % 60 === 0 && progress > 0;
    }) // only fire every 60 seconds
    .map(function () {
        return ActionCreators.trackVideoProgress();
    });
}; // track duration


var trackVideoFiftyEpic = function trackVideoFiftyEpic(action$, store, _ref3) {
    var options = _ref3.options;
    return action$.ofType(ActionTypes.SET_VIDEO_PROGRESS_STATE).pluck('payload').filter(function () {
        return !!options.tracking;
    }).filter(function () {
        return !store.getState().player.videoFiftyReached;
    }) // don't fire if video fifty has been reached
    .filter(function () {
        return !!store.getState().videoSource.duration;
    }) // video needs a duration
    .filter(function (progress) {
        return progress > store.getState().videoSource.duration / 2;
    }) // only fire if progress has reached greater than half the duration
    .map(function () {
        return ActionCreators.trackVideoFifty();
    });
}; // track duration


// tracks when content starts
var trackVideoStartEpic = function trackVideoStartEpic(action$, __, _ref4) {
    _objectDestructuringEmpty(_ref4);

    return action$.ofType(ActionTypes.SET_STARTED_STATE).map(function () {
        return ActionCreators.trackVideoStart();
    });
};

// tracks whenever video is in a waiting state
var trackVideoCompleteEpic = function trackVideoCompleteEpic(action$, store, _ref5) {
    _objectDestructuringEmpty(_ref5);

    return action$.ofType(ActionTypes.PLAYER_EVENT_ENDED).filter(function () {
        return !store.getState().player.adPlaying;
    }) // only when ad isn't playing
    .map(function () {
        return ActionCreators.trackVideoComplete();
    });
};

// tracks whenever pause state is changed
// changes when video starts from a stopped state, on seek (pauses then unpauses if previously playing), or user pause/unpause
var trackVideoPauseEpic = function trackVideoPauseEpic(action$, __, _ref6) {
    _objectDestructuringEmpty(_ref6);

    return action$.ofType(ActionTypes.SET_PAUSE_STATE).map(function () {
        return ActionCreators.trackVideoPause();
    });
};

// tracks whenever video is in a waiting state
var trackVideoBufferingEpic = function trackVideoBufferingEpic(action$, __, _ref7) {
    _objectDestructuringEmpty(_ref7);

    return action$.ofType(ActionTypes.SET_WAITING_STATE).filter(function (data) {
        return !!data.payload;
    }).map(function () {
        return ActionCreators.trackVideoBuffering();
    });
};

var trackPrerollEpic = function trackPrerollEpic(action$, __, _ref8) {
    _objectDestructuringEmpty(_ref8);

    return action$.ofType(ActionTypes.ADS_EVENT_SLOT_STARTED).map(function (data) {
        return data.payload.slot.getTimePositionClass();
    }).filter(function (timePositionClass) {
        return timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL;
    }).map(function () {
        return ActionCreators.trackPreroll();
    });
};

var trackMidrollStartEpic = function trackMidrollStartEpic(action$, __, _ref9) {
    _objectDestructuringEmpty(_ref9);

    return action$.ofType(ActionTypes.ADS_EVENT_SLOT_STARTED).map(function (data) {
        return data.payload.slot.getTimePositionClass();
    }).filter(function (timePositionClass) {
        return timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL;
    }).map(function () {
        return ActionCreators.trackMidrollStart();
    });
};

var trackMidrollEndEpic = function trackMidrollEndEpic(action$, __, _ref10) {
    _objectDestructuringEmpty(_ref10);

    return action$.ofType(ActionTypes.ADS_EVENT_SLOT_ENDED).map(function (data) {
        return data.payload.slot.getTimePositionClass();
    }).filter(function (timePositionClass) {
        return timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL;
    }).map(function () {
        return ActionCreators.trackMidrollEnd();
    });
};

var trackPostrollStartEpic = function trackPostrollStartEpic(action$, __, _ref11) {
    _objectDestructuringEmpty(_ref11);

    return action$.ofType(ActionTypes.ADS_EVENT_SLOT_STARTED).map(function (data) {
        return data.payload.slot.getTimePositionClass();
    }).filter(function (timePositionClass) {
        return timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL;
    }).map(function () {
        return ActionCreators.trackPostrollStart();
    });
};

var trackPostrollEndEpic = function trackPostrollEndEpic(action$, __, _ref12) {
    _objectDestructuringEmpty(_ref12);

    return action$.ofType(ActionTypes.ADS_POSTROLL_END).map(function () {
        return ActionCreators.trackPostrollEnd();
    });
};

var ADBPUserInteraction = function ADBPUserInteraction(action$, store, _ref13) {
    var analytics = _ref13.analytics,
        debug = _ref13.debug;
    return action$.ofType(ActionTypes.TRACK_USER_INTERACTION).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).pluck('payload').do(function (interactionType) {
        var userInteractionData = analytics.getUserInteractionData(store.getState().videoSource, interactionType);
        analytics.trackUnauth(ADBPEventType.USER_INTERACTION, userInteractionData);
        debug.log(ADBPEventType.USER_INTERACTION, userInteractionData);
    }).ignoreElements();
};

var ADBPVideoStartEpic = function ADBPVideoStartEpic(action$, store, _ref14) {
    var analytics = _ref14.analytics,
        debug = _ref14.debug,
        player = _ref14.player;
    return action$.ofType(ActionTypes.TRACK_VIDEO_START).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).do(function () {
        var videoData = analytics.getVideoData(store.getState().videoSource, { duration: 0, autoplayed: player.autoplay() });
        var track = store.getState().videoSource.auth ? analytics.trackAuth : analytics.trackUnauth; // track either auth or unauth
        track(ADBPEventType.VIDEO_START, videoData);
        debug.log(ADBPEventType.VIDEO_START, videoData);
    }).ignoreElements();
};

var ADBPVideoPauseEpic = function ADBPVideoPauseEpic(action$, store, _ref15) {
    var analytics = _ref15.analytics,
        debug = _ref15.debug;
    return action$.ofType(ActionTypes.TRACK_VIDEO_PAUSE).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).do(function () {
        var videoData = analytics.getVideoData(store.getState().videoSource, { paused: store.getState().player.pause });
        var track = store.getState().videoSource.auth ? analytics.trackAuth : analytics.trackUnauth;
        track(ADBPEventType.VIDEO_PAUSE, videoData);
        debug.log(ADBPEventType.VIDEO_PAUSE, videoData);
    }).ignoreElements();
};

var ADBPVideoBufferingEpic = function ADBPVideoBufferingEpic(action$, store, _ref16) {
    var analytics = _ref16.analytics,
        debug = _ref16.debug;
    return action$.ofType(ActionTypes.TRACK_VIDEO_BUFFERING).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).do(function () {
        var videoData = analytics.getVideoData(store.getState().videoSource, { buffering: true });
        var track = store.getState().videoSource.auth ? analytics.trackAuth : analytics.trackUnauth;
        track(ADBPEventType.VIDEO_BUFFER, videoData);
        debug.log(ADBPEventType.VIDEO_BUFFER, videoData);
    }).ignoreElements();
};

var ADBPVideoProgressEpic = function ADBPVideoProgressEpic(action$, store, _ref17) {
    var analytics = _ref17.analytics,
        debug = _ref17.debug;
    return action$.ofType(ActionTypes.TRACK_VIDEO_PROGRESS).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).map(function () {
        return store.getState().player.videoProgress;
    }).do(function (progress) {
        var videoData = analytics.getVideoData(store.getState().videoSource, { duration: progress });
        var track = store.getState().videoSource.auth ? analytics.trackAuth : analytics.trackUnauth;
        track(ADBPEventType.VIDEO_PROGRESS, videoData);
        debug.log(ADBPEventType.VIDEO_PROGRESS, videoData);
    }).ignoreElements();
};

var ADBPVideoFiftyEpic = function ADBPVideoFiftyEpic(action$, store, _ref18) {
    var analytics = _ref18.analytics,
        debug = _ref18.debug;
    return action$.ofType(ActionTypes.TRACK_VIDEO_FIFTY).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).map(function () {
        return store.getState().player.videoProgress;
    }).do(function (progress) {
        var videoData = analytics.getVideoData(store.getState().videoSource, { duration: progress });
        var track = store.getState().videoSource.auth ? analytics.trackAuth : analytics.trackUnauth;
        track(ADBPEventType.VIDEO_FIFTY, videoData);
        debug.log(ADBPEventType.VIDEO_FIFTY, videoData);
    }).ignoreElements();
};

var ADBPVideoCompleteEpic = function ADBPVideoCompleteEpic(action$, store, _ref19) {
    var analytics = _ref19.analytics,
        debug = _ref19.debug;
    return action$.ofType(ActionTypes.TRACK_VIDEO_COMPLETE).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).do(function () {
        var videoData = analytics.getVideoData(store.getState().videoSource);
        var track = store.getState().videoSource.auth ? analytics.trackAuth : analytics.trackUnauth;
        track(ADBPEventType.VIDEO_COMPLETE, videoData);
        debug.log(ADBPEventType.VIDEO_COMPLETE, videoData);
    }).ignoreElements();
};

/* ADS */

var ADBPPrerollEpic = function ADBPPrerollEpic(action$, store, _ref20) {
    var analytics = _ref20.analytics,
        debug = _ref20.debug,
        ads = _ref20.ads;
    return action$.ofType(ActionTypes.TRACK_PREROLL).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).filter(function () {
        return ads.prerolls[0] && ads.prerolls[0].getAdCount() > 0;
    }) // prerolls can have object, but no ads in it
    .do(function () {
        var videoData = analytics.getVideoData(store.getState().videoSource, { adType: ads.currentPlayingSlotType, adDuration: ads.getCurrentSlot().getTotalDuration() });
        var track = store.getState().videoSource.auth ? analytics.trackAuth.bind(analytics) : analytics.trackUnauth.bind(analytics);
        track(ADBPEventType.VIDEO_PREROLL, videoData);
        debug.log(ADBPEventType.VIDEO_PREROLL, videoData);
    }).ignoreElements();
};

var ADBPMidrollStartEpic = function ADBPMidrollStartEpic(action$, store, _ref21) {
    var analytics = _ref21.analytics,
        debug = _ref21.debug,
        ads = _ref21.ads;
    return action$.ofType(ActionTypes.TRACK_MIDROLL_START).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).do(function () {
        var videoData = analytics.getVideoData(store.getState().videoSource, { adType: ads.currentPlayingSlotType, adDuration: ads.getCurrentSlot().getTotalDuration() });
        var track = store.getState().videoSource.auth ? analytics.trackAuth.bind(analytics) : analytics.trackUnauth.bind(analytics);
        track(ADBPEventType.VIDEO_MIDROLL_START, videoData);
        debug.log(ADBPEventType.VIDEO_MIDROLL_START, videoData);
    }).ignoreElements();
};

var ADBPMidrollEndEpic = function ADBPMidrollEndEpic(action$, store, _ref22) {
    var analytics = _ref22.analytics,
        debug = _ref22.debug,
        ads = _ref22.ads;
    return action$.ofType(ActionTypes.TRACK_MIDROLL_END).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).do(function () {
        var videoData = analytics.getVideoData(store.getState().videoSource, { adType: ads.currentPlayingSlotType, adDuration: ads.getCurrentSlot().getTotalDuration() });
        var track = store.getState().videoSource.auth ? analytics.trackAuth : analytics.trackUnauth;
        track(ADBPEventType.VIDEO_MIDROLL_COMPLETE, videoData);
        debug.log(ADBPEventType.VIDEO_MIDROLL_COMPLETE, videoData);
    }).ignoreElements();
};

var ADBPPostrollStartEpic = function ADBPPostrollStartEpic(action$, store, _ref23) {
    var analytics = _ref23.analytics,
        debug = _ref23.debug,
        ads = _ref23.ads;
    return action$.ofType(ActionTypes.TRACK_POSTROLL_START).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).do(function () {
        var videoData = analytics.getVideoData(store.getState().videoSource, { adType: ads.currentPlayingSlotType, adDuration: ads.getCurrentSlot().getTotalDuration() });
        var track = store.getState().videoSource.auth ? analytics.trackAuth : analytics.trackUnauth;
        track(ADBPEventType.VIDEO_POSTROLL_START, videoData);
        debug.log(ADBPEventType.VIDEO_POSTROLL_START, videoData);
    }).ignoreElements();
};

var ADBPPostrollEndEpic = function ADBPPostrollEndEpic(action$, store, _ref24) {
    var analytics = _ref24.analytics,
        debug = _ref24.debug,
        ads = _ref24.ads;
    return action$.ofType(ActionTypes.TRACK_POSTROLL_END).filter(function () {
        return !!store.getState().videoSource.id;
    }).filter(function () {
        return !!window.trackMetrics;
    }).do(function () {
        var videoData = analytics.getVideoData(store.getState().videoSource, { adType: ads.currentPlayingSlotType, adDuration: ads.getCurrentSlot().getTotalDuration() });
        var track = store.getState().videoSource.auth ? analytics.trackAuth : analytics.trackUnauth;
        track(ADBPEventType.VIDEO_POSTROLL_COMPLETE, videoData);
        debug.log(ADBPEventType.VIDEO_POSTROLL_COMPLETE, videoData);
    }).ignoreElements();
};

exports.default = (0, _reduxObservable.combineEpics)(ADBPUserInteraction, ADBPVideoProgressEpic, ADBPVideoFiftyEpic, ADBPVideoStartEpic, ADBPVideoBufferingEpic, ADBPVideoPauseEpic, ADBPVideoCompleteEpic, ADBPPrerollEpic, ADBPMidrollStartEpic, ADBPMidrollEndEpic, ADBPPostrollStartEpic, ADBPPostrollEndEpic, trackShareSocialEpic, trackVideoCompleteEpic, trackVideoStartEpic, trackVideoBufferingEpic, trackVideoPauseEpic, trackVideoFiftyEpic, trackVideoProgressEpic, trackPrerollEpic, trackMidrollStartEpic, trackMidrollEndEpic, trackPostrollStartEpic, trackPostrollEndEpic);

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.adsStartPostrollEpic = exports.adReturnFromMidrollEpic = exports.adsMonitorForMidrollsEpic = exports.adsStartPrerollEpic = exports.adsAutoStartPrerollEpic = exports.adsClickEpic = exports.adsErrorEpic = exports.adsImpressionEndedEpic = exports.adsImpressionStartedEpic = exports.adsPostrollEndedEpic = exports.adsMidrollEndedEpic = exports.adsPrerollEndedEpic = exports.adsSlotForceEnd = exports.adsSlotEndedEpic = exports.adsSlotStartedEpic = exports.adsRequestCompleteEpic = exports.adsInitializeEpic = undefined;

var _reduxObservable = __webpack_require__(25);

var _rxjs = __webpack_require__(29);

var _ActionCreators = __webpack_require__(30);

var ActionCreators = _interopRequireWildcard(_ActionCreators);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); } /* globals tv */


var adsInitializeEpic = exports.adsInitializeEpic = function adsInitializeEpic(action$, store, _ref) {
    var ads = _ref.ads;
    return action$.ofType(ActionTypes.RECEIVE_VIDEO_PLAYER_DATA).filter(function () {
        return !!store.getState().player.adsEnabled;
    }).filter(function () {
        return !store.getState().videoSource.disableAds;
    }).map(function () {
        return ads.setContext(store.getState().videoSource);
    }).switchMap(function (adsContext) {
        return _rxjs.Observable.merge(_rxjs.Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_AD_CLICK).map(function (event) {
            return ActionCreators.adsEventClick(event);
        }), _rxjs.Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_AD_IMPRESSION_END).map(function (event) {
            return ActionCreators.adsEventImpressionEnded(event);
        }), _rxjs.Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_AD_IMPRESSION).map(function (event) {
            return ActionCreators.adsEventImpressionStarted(event);
        }), _rxjs.Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_ERROR).map(function (event) {
            return ActionCreators.adsEventError(event);
        }), _rxjs.Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_REQUEST_COMPLETE).map(function (event) {
            return ActionCreators.adsEventRequestComplete(event);
        }), _rxjs.Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_SLOT_ENDED).map(function (event) {
            return ActionCreators.adsEventSlotEnded(event);
        }), _rxjs.Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_SLOT_STARTED).map(function (event) {
            return ActionCreators.adsEventSlotStarted(event);
        }));
    });
};

var adsRequestCompleteEpic = exports.adsRequestCompleteEpic = function adsRequestCompleteEpic(action$, store, _ref2) {
    var ads = _ref2.ads,
        player = _ref2.player;
    return action$.ofType(ActionTypes.ADS_EVENT_REQUEST_COMPLETE).filter(function (data) {
        return !!data.payload.success;
    }).do(function () {
        return ads.setSlots();
    }).do(function () {
        if (ads.prerolls.length) player.pause();
    }).map(function () {
        return ActionCreators.setAdSlots();
    });
};

var adsSlotStartedEpic = exports.adsSlotStartedEpic = function adsSlotStartedEpic(action$, store, _ref3) {
    var player = _ref3.player,
        ads = _ref3.ads;
    return action$.ofType(ActionTypes.ADS_EVENT_SLOT_STARTED).filter(function (data) {
        return !(data.payload.slot.getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY);
    }).map(function (data) {
        return data.payload.slot;
    }).do(function (adSlot) {
        ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_PAUSED);
        player.addClass('ad-loading');

        // trigger on player for external ad listeners
        player.trigger('ad-start', { slot: adSlot, adType: adSlot.getTimePositionClass().toLowerCase() });
    }).map(function () {
        return ActionCreators.setAdPlayingState(true);
    });
};

var adsSlotEndedEpic = exports.adsSlotEndedEpic = function adsSlotEndedEpic(action$, store, _ref4) {
    var player = _ref4.player;
    return action$.ofType(ActionTypes.ADS_EVENT_SLOT_ENDED).filter(function (data) {
        return !(data.payload.slot.getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY);
    }) // fired from display (sync units)
    .map(function (data) {
        return data.payload.slot;
    }).do(function (adSlot) {
        player.removeClass('ad-loading');

        // trigger on player for external ad listeners
        player.trigger('ad-complete', { slot: adSlot, adType: adSlot.getTimePositionClass().toLowerCase() });
    }).map(function () {
        return ActionCreators.setAdPlayingState(false);
    });
};

var adsSlotForceEnd = exports.adsSlotForceEnd = function adsSlotForceEnd(action$, store, _ref5) {
    var player = _ref5.player,
        ads = _ref5.ads;
    return action$.ofType(ActionTypes.START_CONTENT).filter(function () {
        return store.getState().player.adPlaying;
    }) // ad is playing
    .do(function () {
        return player.removeClass('ad-playing');
    }).do(function () {
        return player.removeClass('ad-loading');
    }).do(function () {
        return ads.skipAd();
    }).map(function () {
        return ActionCreators.setAdPlayingState(false);
    });
};

var adsPrerollEndedEpic = exports.adsPrerollEndedEpic = function adsPrerollEndedEpic(action$, store, _ref6) {
    var player = _ref6.player,
        ads = _ref6.ads;
    return action$.ofType(ActionTypes.ADS_EVENT_SLOT_ENDED).map(function (data) {
        return data.payload.slot.getTimePositionClass();
    }).filter(function (timePositionClass) {
        return timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL;
    }) // fired from display (sync units)
    .do(function () {
        ads.prerolls.splice(0, 1);
        if (ads.prerolls.length) {
            if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose(); // dispose of hls source handler to start ads faster
            ads.startPreroll();
        } else ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_PLAYING);
    }).map(function () {
        return ActionCreators.adsPrerollEnd();
    });
};

var adsMidrollEndedEpic = exports.adsMidrollEndedEpic = function adsMidrollEndedEpic(action$, store, _ref7) {
    var ads = _ref7.ads;
    return action$.ofType(ActionTypes.ADS_EVENT_SLOT_ENDED).map(function (data) {
        return data.payload.slot.getTimePositionClass();
    }).filter(function (timePositionClass) {
        return timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL;
    }).do(function () {
        ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_PLAYING);
    }).map(function () {
        return ActionCreators.adsMidrollEnd();
    });
};

var adsPostrollEndedEpic = exports.adsPostrollEndedEpic = function adsPostrollEndedEpic(action$, store, _ref8) {
    var player = _ref8.player,
        ads = _ref8.ads;
    return action$.ofType(ActionTypes.ADS_EVENT_SLOT_ENDED).map(function (data) {
        return data.payload.slot.getTimePositionClass();
    }).filter(function (timePositionClass) {
        return timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL;
    }).do(function () {
        ads.postrolls.splice(0, 1);
        if (ads.postrolls.length) {
            if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose(); // dispose of hls source handler to start ads faster
            ads.startPostroll();
        } else ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);
    }).map(function () {
        return ActionCreators.adsPostrollEnd();
    });
};

var adsImpressionStartedEpic = exports.adsImpressionStartedEpic = function adsImpressionStartedEpic(action$, store, _ref9) {
    var player = _ref9.player;
    return action$.ofType(ActionTypes.ADS_EVENT_IMPRESSION_STARTED).filter(function (data) {
        return !(data.payload.adInstance.getSlot().getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY);
    }).do(function (data) {
        player.addClass('ad-playing');
        player.removeClass('ad-loading');
    }).ignoreElements();
};

var adsImpressionEndedEpic = exports.adsImpressionEndedEpic = function adsImpressionEndedEpic(action$, store, _ref10) {
    var player = _ref10.player;
    return action$.ofType(ActionTypes.ADS_EVENT_IMPRESSION_ENDED).filter(function (data) {
        return !(data.payload.adInstance.getSlot().getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY);
    }).do(function () {
        return player.removeClass('ad-playing');
    }).ignoreElements();
};

var adsErrorEpic = exports.adsErrorEpic = function adsErrorEpic(action$, store, _ref11) {
    _objectDestructuringEmpty(_ref11);

    return action$.ofType(ActionTypes.ADS_EVENT_ERROR).ignoreElements();
};

var adsClickEpic = exports.adsClickEpic = function adsClickEpic(action$, store, _ref12) {
    _objectDestructuringEmpty(_ref12);

    return action$.ofType(ActionTypes.ADS_EVENT_CLICK).ignoreElements();
};

// starts preroll for autoplay = true
var adsAutoStartPrerollEpic = exports.adsAutoStartPrerollEpic = function adsAutoStartPrerollEpic(action$, store, _ref13) {
    var player = _ref13.player,
        ads = _ref13.ads;
    return action$.ofType(ActionTypes.SET_AD_SLOTS).filter(function () {
        return player.autoplay();
    }) // only start ads right away when autoplay is on
    .filter(function () {
        return !!ads.prerolls.length;
    }) // only start ads when there are ads from the request
    .do(function () {
        return ads.startPreroll();
    }).ignoreElements();
};

// starts preroll for autoplay = false
var adsStartPrerollEpic = exports.adsStartPrerollEpic = function adsStartPrerollEpic(action$, store, _ref14) {
    var player = _ref14.player,
        ads = _ref14.ads;
    return action$.ofType(ActionTypes.PLAYER_EVENT_PLAY).filter(function () {
        return store.getState().player.adRequestComplete;
    }) // check if ad request is complete
    .filter(function () {
        return !player.autoplay();
    }) // only applies when autoplay is turned off
    .filter(function () {
        return !!ads.prerolls.length;
    }) // only start ads when there are ads from the request
    .filter(function () {
        return ads.prerolls[0] && ads.prerolls[0].getAdCount() > 0;
    }) // prerolls can have object, but no ads in it
    .do(function () {
        if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose(); // dispose of hls source handler to start ads faster
        ads.startPreroll();
    }).ignoreElements();
};

var adsMonitorForMidrollsEpic = exports.adsMonitorForMidrollsEpic = function adsMonitorForMidrollsEpic(action$, store, _ref15) {
    var player = _ref15.player,
        ads = _ref15.ads;
    return action$.ofType(ActionTypes.PLAYER_EVENT_TIME_UPDATE).throttleTime(100).filter(function () {
        return !!store.getState().player.adsEnabled;
    }).filter(function () {
        return !store.getState().player.adPlaying;
    }) // only when an ad isn't playing
    .filter(function () {
        return store.getState().player.adReturnMidrollTime === -1;
    }) // only when return to midroll time is not set
    .filter(function () {
        return !!ads.midrolls.length;
    }) // only start ads when there are ads from the request
    .map(function () {
        return player.currentTime();
    }).map(function (currentTime) {
        return { midroll: ads.getMidroll(currentTime), currentTime: currentTime };
    }).filter(function (payload) {
        return !!payload.midroll;
    }) // don't continue if no slot to play yet
    .do(function (payload) {
        if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose(); // dispose of hls source handler to start ads faster
        ads.startMidroll(payload.midroll);
    }).map(function (payload) {
        return ActionCreators.setAdsReturnMidrollTimeState(payload.currentTime);
    });
};

var adReturnFromMidrollEpic = exports.adReturnFromMidrollEpic = function adReturnFromMidrollEpic(action$, store, _ref16) {
    var player = _ref16.player,
        ads = _ref16.ads,
        options = _ref16.options;
    return action$.ofType(ActionTypes.PLAYER_EVENT_CAN_PLAY_THROUGH).filter(function () {
        return !!store.getState().player.adsEnabled;
    }) // only applies when ads are on
    .filter(function () {
        return !store.getState().player.adPlaying;
    }).filter(function () {
        return store.getState().player.adReturnMidrollTime > 0;
    }).delay(50).do(function () {
        player.currentTime(store.getState().player.adReturnMidrollTime);
    }).map(function () {
        return player.currentTime();
    }).filter(function (currentTime) {
        return currentTime >= store.getState().player.adReturnMidrollTime;
    }).map(function () {
        return ActionCreators.setAdsReturnMidrollTimeState(-1);
    });
};

var adsStartPostrollEpic = exports.adsStartPostrollEpic = function adsStartPostrollEpic(action$, store, _ref17) {
    var player = _ref17.player,
        ads = _ref17.ads;
    return action$.ofType(ActionTypes.PLAYER_EVENT_ENDED).filter(function () {
        return !!store.getState().player.adsEnabled;
    }) // only applies when ads are on
    .filter(function () {
        return !store.getState().player.adPlaying;
    }) // when ad not playing
    .filter(function () {
        return !!ads.postrolls.length;
    }) // only start ads when there are ads from the request
    .do(function () {
        if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose(); // dispose of hls source handler to start ads faster
        ads.startPostroll();
    }).ignoreElements();
};

exports.default = (0, _reduxObservable.combineEpics)(adsInitializeEpic, adsRequestCompleteEpic, adsAutoStartPrerollEpic, adsSlotStartedEpic, adsStartPrerollEpic, adsStartPostrollEpic, adsSlotEndedEpic, adsPrerollEndedEpic, adsMidrollEndedEpic, adsPostrollEndedEpic, adsImpressionStartedEpic, adsImpressionEndedEpic, adsErrorEpic, adsClickEpic, adsMonitorForMidrollsEpic, adReturnFromMidrollEpic, adsSlotForceEnd);

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackCompleteEpic = exports.trackThirdQuartileEpic = exports.trackMidpointEpic = exports.trackFirstQuartileEpic = exports.trackBreakEnd = exports.trackBreakStart = exports.adCountdownClearEpic = exports.adCountdownUpdateEpic = exports.adCountdownSetEpic = exports.setCurrentAdTimeRemainingEpic = exports.setAdTimeRemainingEpic = exports.setCurrentAdEndTimeEpic = exports.setAdEndTimeEpic = exports.setAdClickHandler = exports.setAuditudeAdPodEnded = exports.setAuditudeAdPodBegin = exports.setAuditudeAdPlaying = exports.retryPlainStreamEpic = exports.setStreamBlockedEpic = exports.blockedStreamError = undefined;

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _reduxObservable = __webpack_require__(25);

var _rxjs = __webpack_require__(29);

var _lodash = __webpack_require__(41);

__webpack_require__(898);

var _ActionCreators = __webpack_require__(30);

var ActionCreators = _interopRequireWildcard(_ActionCreators);

var _ActionTypes = __webpack_require__(16);

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _videoTypes = __webpack_require__(105);

var VideoTypes = _interopRequireWildcard(_videoTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

var blockedStreamError = exports.blockedStreamError = function blockedStreamError(action$, __, _ref) {
    _objectDestructuringEmpty(_ref);

    return action$.ofType(ActionTypes.HLS_EVENT_LOAD_ERROR).pluck('payload', 'networkDetails').filter(function (networkDetails) {
        return !!networkDetails;
    }).pluck('status').filter(function (status) {
        return status === 0;
    }).take(1).switchMap(function () {
        return _rxjs.Observable.of(ActionCreators.setStreamBlocked(true), ActionCreators.retryPlainStream());
    });
};

// if fuckAdBlock sees that there's an adblocker on, set streamBlocked
var setStreamBlockedEpic = exports.setStreamBlockedEpic = function setStreamBlockedEpic(action$, store, _ref2) {
    var player = _ref2.player;
    return action$.ofType(ActionTypes.INIT).map(function () {
        return store.getState();
    }).filter(function (state) {
        return state.player.adsEnabled;
    }).do(function () {
        fuckAdBlock = new FuckAdBlock({
            checkOnLoad: true
        });
        fuckAdBlock.onDetected(function () {
            return player.trigger('streamBlocked', {});
        });
    }).ignoreElements();
};

var retryPlainStreamEpic = exports.retryPlainStreamEpic = function retryPlainStreamEpic(action$, store, _ref3) {
    _objectDestructuringEmpty(_ref3);

    return action$.ofType(ActionTypes.RETRY_PLAIN_STREAM).map(function () {
        return store.getState();
    }).filter(function (state) {
        return state.player.streamBlocked;
    }).map(function (state) {
        return ActionCreators.setPlaybackURL(state.videoSource.contentURL + '?hdnts=' + state.cdnToken.token);
    });
};

var setAuditudeAdPlaying = exports.setAuditudeAdPlaying = function setAuditudeAdPlaying(action$, store, _ref4) {
    _objectDestructuringEmpty(_ref4);

    return action$.ofType(ActionTypes.HLS_FRAG_CHANGED).map(function () {
        return store.getState().auditude.adMarkers;
    }).filter(function (adMarkers) {
        return !!adMarkers.length;
    }).map(function (adMarkers) {
        return (0, _lodash.find)(adMarkers, function (adMarker) {
            return adMarker.type === 'AdBegin';
        });
    }).filter(function (ad) {
        return !!ad;
    }).map(function (ad) {
        return ActionCreators.setCurrentAd(ad);
    });
};

var setAuditudeAdPodBegin = exports.setAuditudeAdPodBegin = function setAuditudeAdPodBegin(action$, store, _ref5) {
    _objectDestructuringEmpty(_ref5);

    return action$.ofType(ActionTypes.HLS_FRAG_CHANGED).map(function () {
        return store.getState().auditude.adMarkers;
    }).filter(function (adMarkers) {
        return !!adMarkers.length;
    }).map(function (adMarkers) {
        return (0, _lodash.find)(adMarkers, function (adMarker) {
            return adMarker.type === 'PodBegin';
        });
    }).filter(function (adPod) {
        return !!adPod;
    }).map(function (adPod) {
        return ActionCreators.setCurrentAdPod(adPod);
    });
};

var setAuditudeAdPodEnded = exports.setAuditudeAdPodEnded = function setAuditudeAdPodEnded(action$, store, _ref6) {
    _objectDestructuringEmpty(_ref6);

    return action$.ofType(ActionTypes.HLS_FRAG_CHANGED).map(function () {
        return store.getState().auditude.adMarkers;
    }).filter(function (adMarkers) {
        return !!adMarkers.length;
    }).map(function (adMarkers) {
        return (0, _lodash.find)(adMarkers, function (adMarker) {
            return adMarker.type === 'PodEnd';
        });
    }).filter(function (ad) {
        return !!ad;
    }).switchMap(function (ad) {
        return _rxjs.Observable.of(ad).delay(ad.offset * 1000 || 0).switchMap(function () {
            return _rxjs.Observable.of(ActionCreators.clearCurrentAd(), ActionCreators.clearCurrentAdPod());
        });
    });
};

// if ad has a clickthrough url, set up click handler
var setAdClickHandler = exports.setAdClickHandler = function setAdClickHandler(action$, store, _ref7) {
    var player = _ref7.player,
        auditude = _ref7.auditude;
    return action$.ofType(ActionTypes.SET_CURRENT_AD).pluck('payload').map(function (ad) {
        return ad.clickThroughURL;
    }).filter(Boolean).switchMap(function (clickThroughURL) {
        var modal$ = _rxjs.Observable.create(function () {
            var clickHandler = auditude.onAdClick.bind(null, clickThroughURL, player);
            var AdClickOverlay = _video2.default.getComponent(Controls.AD_CLICK_OVERLAY);
            var content = new AdClickOverlay(clickHandler);
            var modal = player.createModal(content.el(), {
                label: 'Ad Clickthrough',
                pauseOnOpen: false
            });

            modal.addClass('as-ad-click-modal-dialog');

            return function () {
                if (modal.opened()) modal.close();
                content.dispose();
            };
        });

        return modal$.takeUntil(action$.ofType(ActionTypes.CLEAR_CURRENT_AD_POD)).ignoreElements();
    });
};

var setAdEndTimeEpic = exports.setAdEndTimeEpic = function setAdEndTimeEpic(action$, __, _ref8) {
    var player = _ref8.player;
    return action$.ofType(ActionTypes.SET_CURRENT_AD_POD).pluck('payload').map(function (adPod) {
        return ActionCreators.setAdEndTime(player.currentTime() + adPod.breakdur);
    });
};

var setCurrentAdEndTimeEpic = exports.setCurrentAdEndTimeEpic = function setCurrentAdEndTimeEpic(action$, __, _ref9) {
    var player = _ref9.player;
    return action$.ofType(ActionTypes.SET_CURRENT_AD).pluck('payload').map(function (ad) {
        return ActionCreators.setCurrentAdEndTime(player.currentTime() + ad.duration);
    });
};

var setAdTimeRemainingEpic = exports.setAdTimeRemainingEpic = function setAdTimeRemainingEpic(action$, store, _ref10) {
    var player = _ref10.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_TIME_UPDATE).map(function () {
        return store.getState().auditude;
    }).filter(function (auditude) {
        return !!auditude.currentAdPod && auditude.adEndTime !== null;
    }).map(function (auditude) {
        return ActionCreators.setAdTimeRemaining(auditude.adEndTime - player.currentTime());
    });
};

var setCurrentAdTimeRemainingEpic = exports.setCurrentAdTimeRemainingEpic = function setCurrentAdTimeRemainingEpic(action$, store, _ref11) {
    var player = _ref11.player;
    return action$.ofType(ActionTypes.PLAYER_EVENT_TIME_UPDATE).map(function () {
        return store.getState().auditude;
    }).filter(function (auditude) {
        return !!auditude.currentAd && auditude.currentAdEndTime !== null;
    }).map(function (auditude) {
        return ActionCreators.setCurrentAdTimeRemaining(auditude.currentAdEndTime - player.currentTime());
    });
};

var adCountdownSetEpic = exports.adCountdownSetEpic = function adCountdownSetEpic(action$, store, _ref12) {
    var player = _ref12.player;
    return action$.ofType(ActionTypes.SET_CURRENT_AD_POD).map(function () {
        return store.getState().auditude.adTimeRemaining;
    }).do(function (adTimeRemaining) {
        var adCountdown = player.getChild(Controls.AD_COUNTDOWN) || player.addChild(Controls.AD_COUNTDOWN);
        adCountdown.timeRemaining(adTimeRemaining);
    }).ignoreElements();
};

var adCountdownUpdateEpic = exports.adCountdownUpdateEpic = function adCountdownUpdateEpic(action$, store, _ref13) {
    var player = _ref13.player;
    return action$.ofType(ActionTypes.SET_AD_TIME_REMAINING).map(function () {
        return store.getState().auditude;
    }).do(function (auditude) {
        var adCountdown = player.getChild(Controls.AD_COUNTDOWN) || player.addChild(Controls.AD_COUNTDOWN);
        adCountdown.timeRemaining(auditude.adTimeRemaining);
    }).ignoreElements();
};

var adCountdownClearEpic = exports.adCountdownClearEpic = function adCountdownClearEpic(action$, __, _ref14) {
    var player = _ref14.player;
    return action$.ofType(ActionTypes.CLEAR_CURRENT_AD).do(function () {
        return player.removeChild(Controls.AD_COUNTDOWN);
    }).ignoreElements();
};

var trackBreakStart = exports.trackBreakStart = function trackBreakStart(action$, store, _ref15) {
    _objectDestructuringEmpty(_ref15);

    return action$.ofType(ActionTypes.SET_CURRENT_AD_POD).map(function () {
        return store.getState().auditude.trackingCallBreakStart;
    }).switchMap(function (trackingCallBreakStart) {
        return _rxjs.Observable.fromPromise(fetch('' + trackingCallBreakStart).catch(function () {
            return _rxjs.Observable.empty();
        }));
    }).ignoreElements();
};

var trackBreakEnd = exports.trackBreakEnd = function trackBreakEnd(action$, store, _ref16) {
    _objectDestructuringEmpty(_ref16);

    return action$.ofType(ActionTypes.HLS_FRAG_CHANGED).map(function () {
        return store.getState().auditude.adMarkers;
    }).filter(function (adMarkers) {
        return !!adMarkers.length;
    }).map(function (adMarkers) {
        return (0, _lodash.find)(adMarkers, function (adMarker) {
            return adMarker.type === 'PodEnd';
        });
    }).filter(function (ad) {
        return !!ad;
    }).map(function () {
        return store.getState().auditude.trackingCallBreakEnd;
    }).switchMap(function (trackingCallBreakEnd) {
        return _rxjs.Observable.fromPromise(fetch('' + trackingCallBreakEnd).catch(function () {
            return _rxjs.Observable.empty();
        }));
    }).ignoreElements();
};

var trackFirstQuartileEpic = exports.trackFirstQuartileEpic = function trackFirstQuartileEpic(action$, store, _ref17) {
    var player = _ref17.player;
    return action$.ofType(ActionTypes.SET_CURRENT_AD).switchMap(function () {
        return action$.ofType(ActionTypes.SET_CURRENT_AD_TIME_REMAINING).map(function () {
            var auditude = store.getState().auditude;
            var currentAdDuration = auditude.currentAd.duration;
            var currentAdTimeRemaining = auditude.currentAdTimeRemaining;
            return currentAdTimeRemaining / currentAdDuration;
        }).first(function (remaining) {
            return remaining < 0.75;
        }).map(function () {
            return store.getState().auditude.trackingCallFirstQuartile;
        }).switchMap(function (trackingCallFirstQuartile) {
            return _rxjs.Observable.fromPromise(fetch('' + trackingCallFirstQuartile)).catch(function () {
                return _rxjs.Observable.empty();
            });
        });
    }).ignoreElements();
};

var trackMidpointEpic = exports.trackMidpointEpic = function trackMidpointEpic(action$, store, _ref18) {
    var player = _ref18.player;
    return action$.ofType(ActionTypes.SET_CURRENT_AD).switchMap(function () {
        return action$.ofType(ActionTypes.SET_CURRENT_AD_TIME_REMAINING).map(function () {
            var auditude = store.getState().auditude;
            var currentAdDuration = auditude.currentAd.duration;
            var currentAdTimeRemaining = auditude.currentAdTimeRemaining;
            return currentAdTimeRemaining / currentAdDuration;
        }).first(function (remaining) {
            return remaining < 0.5;
        }).map(function () {
            return store.getState().auditude.trackingCallMidpoint;
        }).switchMap(function (trackingCallMidpoint) {
            return _rxjs.Observable.fromPromise(fetch('' + trackingCallMidpoint)).catch(function () {
                return _rxjs.Observable.empty();
            });
        });
    }).ignoreElements();
};

var trackThirdQuartileEpic = exports.trackThirdQuartileEpic = function trackThirdQuartileEpic(action$, store, _ref19) {
    var player = _ref19.player;
    return action$.ofType(ActionTypes.SET_CURRENT_AD).switchMap(function () {
        return action$.ofType(ActionTypes.SET_CURRENT_AD_TIME_REMAINING).map(function () {
            var auditude = store.getState().auditude;
            var currentAdDuration = auditude.currentAd.duration;
            var currentAdTimeRemaining = auditude.currentAdTimeRemaining;
            return currentAdTimeRemaining / currentAdDuration;
        }).first(function (remaining) {
            return remaining < 0.25;
        }).map(function () {
            return store.getState().auditude.trackingCallThirdQuartile;
        }).switchMap(function (trackingCallThirdQuartile) {
            return _rxjs.Observable.fromPromise(fetch('' + trackingCallThirdQuartile)).catch(function () {
                return _rxjs.Observable.empty();
            });
        });
    }).ignoreElements();
};

var trackCompleteEpic = exports.trackCompleteEpic = function trackCompleteEpic(action$, store, _ref20) {
    var player = _ref20.player;
    return action$.ofType(ActionTypes.SET_CURRENT_AD).switchMap(function () {
        return action$.ofType(ActionTypes.SET_CURRENT_AD_TIME_REMAINING).map(function () {
            var auditude = store.getState().auditude;
            var currentAdDuration = auditude.currentAd.duration;
            var currentAdTimeRemaining = auditude.currentAdTimeRemaining;
            return currentAdTimeRemaining / currentAdDuration;
        }).first(function (remaining) {
            return remaining < 0.05;
        }).map(function () {
            return store.getState().auditude.trackingCallComplete;
        }).switchMap(function (trackingCallComplete) {
            return _rxjs.Observable.fromPromise(fetch('' + trackingCallComplete)).catch(function () {
                return _rxjs.Observable.empty();
            });
        });
    }).ignoreElements();
};

exports.default = (0, _reduxObservable.combineEpics)(blockedStreamError, retryPlainStreamEpic, setStreamBlockedEpic, setAuditudeAdPlaying, setAuditudeAdPodBegin, setAuditudeAdPodEnded, setAdEndTimeEpic, setCurrentAdEndTimeEpic, setAdTimeRemainingEpic, setCurrentAdTimeRemainingEpic, setAdClickHandler, adCountdownSetEpic, adCountdownUpdateEpic, adCountdownClearEpic, trackBreakStart, trackBreakEnd, trackFirstQuartileEpic, trackMidpointEpic, trackThirdQuartileEpic, trackCompleteEpic);

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var AS_PLAYER_DEFAULTS = exports.AS_PLAYER_DEFAULTS = {
    'share': {
        // 'url': 'https://www.adultswim.com/special-link', // used to fully override share url as a whole
        //// Used to override pieces of the share url individually
        // 'basePath': 'https://www.adultswim.com/',
        // 'collectionSlug': 'streams',
        // 'videoSlug': 'special',
    },
    'tracking': true,

    'debug': false,
    'ads': true,

    'queryParamTimecode': true
};

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VIDEO_JS_DEFAULTS = undefined;

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var VIDEO_JS_DEFAULTS = exports.VIDEO_JS_DEFAULTS = {
    'controls': true,
    'autoplay': true,
    'preload': 'auto',
    'poster': '',
    'loop': false,

    // Default order of fallback technology
    'techOrder': ['html5'],

    'html5': {},

    // Default of web browser is 300x150. Should rely on source width/height.
    'width': '100%',
    'height': 0,
    // defaultVolume: 0.85, // doesn't seem to do anything

    // default playback rates
    'playbackRates': [],

    // default inactivity timeout
    'inactivityTimeout': 500,

    // Included control sets
    'children': ['mediaLoader', 'bigPlayButton', 'loadingSpinner', 'posterImage', {
        name: 'controlBar',
        children: [Controls.PLAY_TOGGLE, {
            name: Controls.VOLUME_PANEL,
            children: [Controls.MUTE_TOGGLE, Controls.VOLUME_CONTROL]
        }, Controls.PROGRESS_CONTROL, Controls.CURRENT_TIME_DISPLAY, Controls.CAPTIONS_BUTTON, Controls.SHARE_CONTROL, Controls.FULLSCREEN_TOGGLE]
    }],

    'language': document.getElementsByTagName('html')[0].getAttribute('lang') || navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language || 'en',

    // locales and their language translations
    'languages': {},

    // Default message to show when a video cannot be played.
    'notSupportedMessage': 'No compatible source was found for this video.'
};

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _format = __webpack_require__(902);

var _format2 = _interopRequireDefault(_format);

var _videoTypes = __webpack_require__(105);

var VideoType = _interopRequireWildcard(_videoTypes);

var _ADBPVideoType = __webpack_require__(916);

var ADBPVideoType = _interopRequireWildcard(_ADBPVideoType);

var _ADBPEventType = __webpack_require__(277);

var ADBPEventType = _interopRequireWildcard(_ADBPEventType);

var _ADBPAdType = __webpack_require__(917);

var ADBPAdType = _interopRequireWildcard(_ADBPAdType);

var _ASVPUtils = __webpack_require__(42);

var _attempt = __webpack_require__(275);

var _attempt2 = _interopRequireDefault(_attempt);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TRACKING_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

var ADBP = function () {
    function ADBP() {
        _classCallCheck(this, ADBP);

        if (!window.trackMetrics) return false;
    }

    _createClass(ADBP, null, [{
        key: 'getVideoData',
        value: function getVideoData(videoSourceData) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (!videoSourceData) return {};

            var type = ADBP.getVideoType(videoSourceData.type);
            var duration = options.duration ? options.duration : videoSourceData.duration;

            var trackingDataObject = {
                adDuration: options.adDuration,
                adType: ADBP.getAdType(options.adType),
                buffering: options.buffering,
                paused: options.paused,
                contentId: videoSourceData.mediaId,
                franchise: videoSourceData.collectionTitle,
                headline: videoSourceData.title,
                id: videoSourceData.mediaId,
                lastAirDate: (0, _format2.default)(new Date(videoSourceData.launchDate * 1000), TRACKING_DATE_FORMAT),
                media: {
                    duration: duration
                },
                mediaId: videoSourceData.mediaId,
                title: videoSourceData.title,
                tveMode: type === ADBPVideoType.STREAM ? 'linear' : 'C4',
                trt: duration,
                type: type
            };

            var videoData = { video: {
                    id: videoSourceData.id,
                    title: ADBP.getCombinedVideoTitle(videoSourceData),
                    type: type,
                    offsite: (0, _ASVPUtils.inIframe)(true),
                    player_ad: undefined,
                    segment_id: 1,
                    duration: duration,
                    buffering: options.buffering,
                    autoplayed: options.autoplayed,
                    paused: options.paused
                } };

            return Object.assign({}, trackingDataObject, videoData);
        }
    }, {
        key: 'getUserInteractionData',
        value: function getUserInteractionData(sourceData) {
            var interactionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user-interaction';

            if (!sourceData) return {};

            return {
                interaction: interactionType,
                title: ADBP.getCombinedVideoTitle(sourceData)
            };
        }
    }, {
        key: 'getVideoType',
        value: function getVideoType(type) {
            switch (type) {
                case VideoType.CLIP:
                    return ADBPVideoType.CLIP;
                case VideoType.EPISODE:
                    return ADBPVideoType.EPISODE;
                case VideoType.MARATHON:
                    return ADBPVideoType.MARATHON;
                case VideoType.STREAM:
                    return ADBPVideoType.STREAM;
                default:
                    return ADBPVideoType.CLIP;
            }
        }
    }, {
        key: 'getAdType',
        value: function getAdType(type) {
            switch (type) {
                case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:
                    return ADBPAdType.PREROLL;
                case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:
                    return ADBPAdType.MIDROLL;
                case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:
                    return ADBPAdType.POSTROLL;
            }
        }
    }, {
        key: 'getAuthTrackingType',
        value: function getAuthTrackingType(type) {
            switch (type) {
                case ADBPEventType.VIDEO_PREROLL:
                case ADBPEventType.VIDEO_MIDROLL_START:
                case ADBPEventType.VIDEO_POSTROLL_START:
                    return ADBPEventType.AD_START;
                case ADBPEventType.VIDEO_MIDROLL_COMPLETE:
                case ADBPEventType.VIDEO_POSTROLL_COMPLETE:
                    return ADBPEventType.AD_COMPLETE;
                default:
                    return type;
            }
        }
    }, {
        key: 'getCombinedVideoTitle',
        value: function getCombinedVideoTitle(videoData) {
            return videoData.type === VideoType.STREAM && !videoData.auth ? 'streams:' + videoData.title : videoData.collectionTitle + ':' + videoData.title;
        }
    }, {
        key: 'trackUnauth',
        value: function trackUnauth(type, data) {
            if (!data) return;
            return (0, _attempt2.default)(function () {
                return window.trackMetrics({ type: type, data: data });
            });
        }
    }, {
        key: 'trackAuth',
        value: function trackAuth(type, data) {
            if (!data) return;
            var authTrackingType = ADBP.getAuthTrackingType(type);
            return (0, _attempt2.default)(function () {
                return window.sendVideoEvent(authTrackingType, data);
            });
        }
    }, {
        key: 'getClassName',
        value: function getClassName() {
            return 'analytics';
        }
    }]);

    return ADBP;
}();

exports.default = ADBP;
;

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLIP = exports.CLIP = 'CLI';
var EPISODE = exports.EPISODE = 'EPI';
var MARATHON = exports.MARATHON = 'STR';
var STREAM = exports.STREAM = 'STR';

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREROLL = exports.PREROLL = 'preroll';
var MIDROLL = exports.MIDROLL = 'midroll';
var POSTROLL = exports.POSTROLL = 'postroll';

/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ASDebugger = function ASDebugger(gState) {
    var klass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var debug = {};
    if (!window.console) return function () {};
    if (gState) {
        for (var m in console) {
            if (typeof console[m] == 'function') {
                var prepend = 'AS Player :';
                prepend += klass && klass.getClassName ? ' ' + klass.getClassName() + ' :' : '';
                debug[m] = console[m].bind(window.console, prepend);
            }
        }
    } else {
        for (var m in console) {
            if (typeof console[m] == 'function') debug[m] = function () {};
        }
    }
    return debug;
};

exports.default = ASDebugger;

/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* globals tv */


__webpack_require__(920);

var _Freewheel = __webpack_require__(921);

var _Freewheel2 = _interopRequireDefault(_Freewheel);

var _ismobilejs = __webpack_require__(171);

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

var _assign = __webpack_require__(46);

var _assign2 = _interopRequireDefault(_assign);

var _queryString = __webpack_require__(152);

var _queryString2 = _interopRequireDefault(_queryString);

var _md = __webpack_require__(922);

var _md2 = _interopRequireDefault(_md);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Freewheel = function () {
    function Freewheel() {
        var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Freewheel);

        this.config = this.getConfig(config);
        this.siteSectionID = this.getSiteSectionID();
        this.theContext = null;
        this.prerolls = [];
        this.midrolls = [];
        this.postrolls = [];
        this.currentPlayingSlot = null;
        this.currentPlayingSlotType = null;
        this.showPreroll = this.config.preroll;
        this.showMidroll = this.config.midroll;
        this.showPostroll = this.config.postroll;
        this.mvpd = null;

        this.ASPlayer = player;
        this.asPlayerWrapperID = this.ASPlayer.el().getAttribute('id');

        this.theAdManager = new tv.freewheel.SDK.AdManager();
        this.theAdManager.setNetwork(this.config.networkID);
        this.theAdManager.setServer(this.config.serverURL);
        if (this.config.debug) tv.freewheel.SDK.setLogLevel(tv.freewheel.SDK.LOG_LEVEL_DEBUG);else tv.freewheel.SDK.setLogLevel(tv.freewheel.SDK.LOG_LEVEL_QUIET);

        this.configureShortcuts();
    }

    _createClass(Freewheel, [{
        key: 'getConfig',
        value: function getConfig(config) {
            var qs = _queryString2.default.parse(location.search);
            var qsConfig = {};
            if (qs.adServerRootUrl && qs.adServerRootUrl === 'dev') qsConfig.serverURL = '//bea4.v.fwmrm.net/ad/g/1'; // set dev server url if dev flag is set in query string
            return (0, _assign2.default)({}, _Freewheel2.default, config, qsConfig);
        }
    }, {
        key: 'getSiteSectionID',
        value: function getSiteSectionID() {
            var videoData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (window.AS_FW_SSID) return window.AS_FW_SSID;

            var prefix = videoData.auth === true ? this.config.siteSectionAuthIDPrefix : this.config.siteSectionUnauthIDPrefix;
            var platform = _ismobilejs2.default.any ? _ismobilejs2.default.apple.device ? 'ios' : _ismobilejs2.default.android.device ? 'android' : 'other' : 'desktop';
            return prefix + '-' + platform;
        }
    }, {
        key: 'getFreewheelVideoID',
        value: function getFreewheelVideoID(videoData) {
            if (!videoData) return _Freewheel2.default.videoAssetID;
            if (videoData.titleId) {
                return _Freewheel2.default.fwVideoIDPrefix + videoData.titleId;
            } else {
                return _Freewheel2.default.fwVideoIDPrefix + videoData.id;
            }
        }
    }, {
        key: 'setContext',
        value: function setContext(videoData) {
            var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var videoAssetID = this.getFreewheelVideoID(videoData); // gets the freewheel id and sets it as the videoAssetID
            var videoDuration = videoData.duration ? videoData.duration : 86400; // gets the duration from the current video and passes it to the FW context

            if (this.theContext) {
                this.theContext.dispose();
                this.theContext = null;
            }

            this.theContext = this.theAdManager.newContext();
            this.theContext.setProfile(this.config.profileID);
            this.theContext.setVideoAsset(videoAssetID, videoDuration, this.config.networkID);

            // set new site section
            this.siteSectionID = this.getSiteSectionID(videoData);
            this.theContext.setSiteSection(this.siteSectionID, this.config.serverURL);

            this.theContext.registerVideoDisplayBase(this.asPlayerWrapperID);

            // mvpd and auth state for freewheel
            this.theContext.addKeyValue('_fw_ae', this.mvpd || 'd41d8cd98f00b204e9800998ecf8427e');
            this.theContext.addKeyValue('_fw_ar', videoData.auth ? '1' : '0');

            this.theContext.submitRequest();

            return this.theContext;
        }
    }, {
        key: 'setContextVideoState',
        value: function setContextVideoState(state) {
            this.theContext.setVideoState(state);
        }
    }, {
        key: 'setMVPD',
        value: function setMVPD(mvpd) {
            var md5MVPD = (0, _md2.default)(mvpd.toLowerCase());
            this.mvpd = md5MVPD;

            if (this.theContext) {
                this.theContext.addKeyValue('_fw_ae', this.mvpd);
            }
        }
    }, {
        key: 'setSlots',
        value: function setSlots() {
            this.prerolls = [];
            this.midrolls = [];
            this.postrolls = [];

            var fwTemporalSlots = this.theContext.getTemporalSlots();
            for (var i = 0; i < fwTemporalSlots.length; i++) {
                var slot = fwTemporalSlots[i];
                switch (slot.getTimePositionClass()) {
                    case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:
                        if (this.showPreroll) this.prerolls.push(slot);
                        break;
                    case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:
                        // case tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY:
                        if (this.showMidroll) this.midrolls.push(slot);
                        break;
                    case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:
                        if (this.showPostroll) this.postrolls.push(slot);
                        break;
                }
            }

            // sort midrolls
            this.midrolls.sort(function (x, y) {
                return x.getTimePosition() > y.getTimePosition();
            });
        }
    }, {
        key: 'getMidroll',
        value: function getMidroll(currentTime) {
            var validMidrolls = [];
            for (var i = 0; i < this.midrolls.length; i++) {
                var slot = this.midrolls[i];
                var slotTimePosition = slot.getTimePosition();

                if (currentTime - slotTimePosition >= 0) validMidrolls.push(slot);
            }

            if (validMidrolls.length) {
                // remove the midroll from the main array
                this.midrolls.splice(0, validMidrolls.length);
                // only play the last midroll in the group (in case the user seeked ahead past more than one midroll)
                return validMidrolls[validMidrolls.length - 1];
            } else return null;
        }
    }, {
        key: 'startPreroll',
        value: function startPreroll(slot) {
            slot = slot ? slot : this.prerolls[0];

            this.currentPlayingSlot = slot;
            this.currentPlayingSlotType = slot.getTimePositionClass();
            slot.play();
        }
    }, {
        key: 'startMidroll',
        value: function startMidroll(slot) {
            slot = slot ? slot : this.midrolls[0];

            this.currentPlayingSlot = slot;
            this.currentPlayingSlotType = slot.getTimePositionClass();
            slot.play();
        }
    }, {
        key: 'startPostroll',
        value: function startPostroll(slot) {
            slot = slot ? slot : this.postrolls[0];

            this.currentPlayingSlot = slot;
            this.currentPlayingSlotType = slot.getTimePositionClass();
            slot.play();
        }
    }, {
        key: 'configureShortcuts',
        value: function configureShortcuts() {
            var _this = this;

            var isCtrl = false;

            var onKeyDown = function onKeyDown(e) {
                // ctrl+s - skip current ad
                if (e.keyCode == 17) isCtrl = true;
                if (e.keyCode == 83 && isCtrl == true) {
                    _this.skipAd();
                }
            };

            var onKeyUp = function onKeyUp(e) {
                if (e.keyCode == 17) isCtrl = false;
            };

            document.onkeydown = onKeyDown;
            document.onkeyup = onKeyUp;
        }
    }, {
        key: 'skipAd',
        value: function skipAd() {
            if (this.currentPlayingSlot) this.currentPlayingSlot.skipCurrentAd();
        }
    }, {
        key: 'getCurrentSlot',
        value: function getCurrentSlot() {
            return this.currentPlayingSlot;
        }
    }]);

    return Freewheel;
}();

exports.default = Freewheel;

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FREEWHEEL_DEFAULTS = {
    fwVideoIDPrefix: 'as-', // prepended to the videoAssetID for all videos

    // Adult Swim Prod config values
    networkID: 48804,
    serverURL: 'https://bea4.v.fwmrm.net/ad/g/1',
    profileID: '48804:turner_html5_pem2',

    videoAssetID: 'DemoVideoGroup.01',
    siteSectionID: false, // pass in to ads config to always set this siteSectionID as this value no matter the platform
    siteSectionUnauthIDPrefix: 'as.com-unauthenticated', // if siteSectionID is not set, this + the plaform is used to set siteSectionID
    siteSectionAuthIDPrefix: 'as.com-authenticated',

    preroll: true, // set to false to never show preroll even if ads are enabled and it wants to serve one
    midroll: true, // set to false to never show midroll even if ads are enabled and it wants to serve one
    postroll: true, // set to false to never show postroll even if ads are enabled and it wants to serve one

    debug: false
};

// Adult Swim Dev config values
// "networkID": 42448,
// "serverURL": "http://bea4.adultswim.com/ad/g/1",
// "profile": "42448:turner_jsam_live",
// "siteSectionID": 'as.com-unauthenticated-' + (deviceProfile.isMobile() ? (deviceProfile.isIOS() ? 'ios' : (deviceProfile.isAndroid() ? 'android' : 'other')) : 'desktop'),


// Freewheel Demo config values
// networkID: 96749,
// serverURL: 'http://demo.v.fwmrm.net/ad/g/1',
// profileID: 'global-js',
// videoAssetID: 'DemoVideoGroup.01',
// siteSectionID : 'DemoSiteGroup.01',

exports.default = FREEWHEEL_DEFAULTS;

/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Auditude = __webpack_require__(926);

var _Auditude2 = _interopRequireDefault(_Auditude);

var _queryString = __webpack_require__(152);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Auditude = function () {
    function Auditude() {
        var player = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Auditude);

        this.config = this.getConfig(config);
        this.ASPlayer = player;
    }

    _createClass(Auditude, [{
        key: 'getConfig',
        value: function getConfig(config) {
            return Object.assign({}, _Auditude2.default, config.auditude);
        }
    }, {
        key: 'buildURL',
        value: function buildURL(videoSource, cdnToken) {
            var base64ContentURL = btoa(videoSource.contentURL + '?hdnts=' + cdnToken);
            var contentID = '' + videoSource.mediaId;
            var baseURL = this.config.basePath + '/' + contentID + '/' + base64ContentURL + '.' + this.config.manifestType;
            var queryParams = {
                g: this.config.clientType,
                z: this.config.zoneID,
                u: this.config.assetTag,
                pttrackingversion: this.config.ptTrackingVersion,
                pttoken: this.config.ptToken,
                ptcueformat: this.config.ptCueFormat,
                ptassetid: contentID,
                // pttrackingmode: this.config.ptTrackingMode,
                ptdebug: this.config.ptDebug,
                live: videoSource.type === 'stream' ? true : false,
                // pttimeline: this.config.ptLiveTimeline, // only works for live streams (vod needs a constructed timeline - change this is ever doing VOD SSAI)
                __sid__: contentID + ':' + Date.now(),
                k: 'udid=desktop;_fw_ae=725bd42fc9c9394e790b9a73610da431;stream=' + this.config.adobeStreamID + ';caid=' + contentID + ';vdur=0;_fw_ar=0;idfa=' + this.config.advertisingID + ';'
            };

            return baseURL + '?' + _queryString2.default.stringify(queryParams, { encode: false });
        }
    }, {
        key: 'buildTrackingURL',
        value: function buildTrackingURL(levelURL, programDateTime) {
            var parsedURL = _queryString2.default.parseUrl(levelURL);

            parsedURL.url = parsedURL.url.replace('.m3u8', '.json');
            parsedURL.query = Object.assign({}, parsedURL.query, { pttrackingposition: programDateTime });

            return parsedURL.url + '?' + _queryString2.default.stringify(parsedURL.query, { encode: false });
        }
    }, {
        key: 'onAdClick',
        value: function onAdClick(clickThroughURL, player) {
            player.pause();

            var adPage = window.open(clickThroughURL, '_blank');
            adPage.focus();
        }
    }]);

    return Auditude;
}();

exports.default = Auditude;

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var AUDITUDE_DEFAULTS = {
    basePath: 'https://manifest.auditude.com/auditude/variant',
    zoneID: '131829',
    clientType: '1000015',
    manifestType: 'm3u8',
    assetTag: 'ac217921a4a853e52310ebc459eef367', // md5 hash of 'vast_Comedy'
    ptCueFormat: 'turner',
    ptToken: true,
    ptTrackingMode: 'simplesstm',
    ptTrackingVersion: 'v2',
    ptDebug: true,
    ptLiveTimeline: 'B,60.0,1,p;',
    adobeStreamID: 'AS-desktop-streams',
    advertisingID: '084D2F97-D6A5-41C6-90BB-4CDDE192ACBB'
};

exports.default = AUDITUDE_DEFAULTS;

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _hls = __webpack_require__(170);

var _hls2 = _interopRequireDefault(_hls);

var _assign = __webpack_require__(46);

var _assign2 = _interopRequireDefault(_assign);

var _HlsJS = __webpack_require__(928);

var _HlsJS2 = _interopRequireDefault(_HlsJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HlsJsSourceHandler = function () {
    function HlsJsSourceHandler(source, tech, options) {
        _classCallCheck(this, HlsJsSourceHandler);

        this._player = tech;
        this._options = (0, _assign2.default)({}, _HlsJS2.default, options);
        this._errorCounts = {};
        this._video = this._player.el();

        this._hls = new _hls2.default(this._options);
        this._hls.on(_hls2.default.Events.ERROR, this._onError.bind(this));
        this._hls.on(_hls2.default.Events.MANIFEST_PARSED, this._onManifestParsed.bind(this));
        this._hls.on(_hls2.default.Events.LEVEL_LOADED, this._onLevelLoaded.bind(this));
        this._hls.on(_hls2.default.Events.MEDIA_ATTACHED, this._onMediaAttached.bind(this, source));
        this._hls.on(_hls2.default.Events.FRAG_CHANGED, this._onFragChanged.bind(this));

        this._hls.attachMedia(this._video);

        this._player.hlsJS = this._hls; // access on player with player.tech_.hlsJS
        this.dispose = this._dispose; // access on player with player.tech_.dispose();
        this.duration = this._duration;
    }

    _createClass(HlsJsSourceHandler, [{
        key: '_dispose',
        value: function _dispose() {
            this._hls.detachMedia();
            this._hls.destroy();
        }
    }, {
        key: '_duration',
        value: function _duration() {
            return this._duration || this._video.duration || 0;
        }
    }, {
        key: '_load',
        value: function _load(source) {
            this._hls.loadSource(source.src);
        }
    }, {
        key: '_onLevelLoaded',
        value: function _onLevelLoaded(event, data) {
            this._duration = data.details.live ? Infinity : data.details.totalduration;

            this._player.trigger('hlsLevelLoaded', data);
        }
    }, {
        key: '_onMediaAttached',
        value: function _onMediaAttached(source, name, data) {
            this._player.trigger('hlsMediaAttached', data);

            this._load(source);
        }
    }, {
        key: '_onManifestParsed',
        value: function _onManifestParsed(event, data) {
            var _this = this;

            var cleanTracklist = [];

            if (data.levels.length > 1) {
                var autoLevel = {
                    id: -1,
                    label: 'auto',
                    selected: -1 === this._hls.manualLevel
                };
                cleanTracklist.push(autoLevel);
            }

            data.levels.forEach(function (level, index) {
                var quality = {
                    id: index,
                    selected: index === _this._hls.manualLevel,
                    label: _levelLabel(level)
                };

                cleanTracklist.push(quality);
            });

            var payload = {
                qualityData: { video: cleanTracklist },
                qualitySwitchCallback: this._switchQuality
            };

            this._player.trigger('hlsLoadedQualityData', payload);

            this._player.trigger('hlsManifestParsed', data);

            function _levelLabel(level) {
                if (level.height) return level.height + 'p';else if (level.width) return Math.round(level.width * 9 / 16) + 'p';else if (level.bitrate) return level.bitrate / 1000 + 'kbps';else return 0;
            }
        }
    }, {
        key: '_onFragChanged',
        value: function _onFragChanged(event, data) {
            this._player.trigger('hlsFragChanged', data);
        }
    }, {
        key: '_switchQuality',
        value: function _switchQuality(qualityId, trackType) {
            this._hls.nextLevel = qualityId;
        }
    }, {
        key: '_onError',
        value: function _onError(event, data) {
            var error = {
                message: 'HLS.js error: ' + data.type + ' || fatal: ' + data.fatal + ' || details: ' + data.details
            };

            // increment/set error count
            this._errorCounts[data.type] ? this._errorCounts[data.type] += 1 : this._errorCounts[data.type] = 1;

            if (data.fatal) {
                switch (data.type) {
                    case _hls2.default.ErrorTypes.NETWORK_ERROR:
                        error.response = data.response;
                        this._player.error = function () {
                            return error;
                        };
                        this._player.trigger('error', error);
                        break;

                    case _hls2.default.ErrorTypes.MEDIA_ERROR:
                        if (this._errorCounts[_hls2.default.ErrorTypes.MEDIA_ERROR] === 1) {
                            console.info('trying to recover media error');
                            this._hls.recoverMediaError();
                        } else if (this._errorCounts[_hls2.default.ErrorTypes.MEDIA_ERROR] === 2) {
                            console.info('2nd try to recover media error (by swapping audio codec');
                            this._hls.swapAudioCodec();
                            this._hls.recoverMediaError();
                        } else if (this._errorCounts[_hls2.default.ErrorTypes.MEDIA_ERROR] > 2) {
                            this._player.error = function () {
                                return error;
                            };
                            this._player.trigger('error');
                        }
                        break;

                    default:
                        // cannot recover
                        this._dispose();
                        this._player.error = function () {
                            return error;
                        };
                        this._player.trigger('error', error);
                        break;
                }
            }

            // trigger hls specific error details
            switch (data.details) {
                case _hls2.default.ErrorDetails.MANIFEST_LOAD_ERROR:
                case _hls2.default.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
                case _hls2.default.ErrorDetails.MANIFEST_PARSING_ERROR:
                case _hls2.default.ErrorDetails.LEVEL_LOAD_ERROR:
                case _hls2.default.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                case _hls2.default.ErrorDetails.LEVEL_SWITCH_ERROR:
                case _hls2.default.ErrorDetails.FRAG_LOAD_ERROR:
                    this._player.trigger('hlsLoadError', data);
                    break;
                case _hls2.default.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
                case _hls2.default.ErrorDetails.FRAG_LOAD_TIMEOUT:
                case _hls2.default.ErrorDetails.FRAG_PARSING_ERROR:
                case _hls2.default.ErrorDetails.BUFFER_APPEND_ERROR:
                case _hls2.default.ErrorDetails.BUFFER_APPENDING_ERROR:
                    // do nothing for now
                    break;
                default:
                    break;

            }
        }
    }]);

    return HlsJsSourceHandler;
}();

exports.default = HlsJsSourceHandler;

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HLS_JS_DEFAULTS = {
    // debug: false,
    enableWebVTT: false,
    enableCEA708Captions: true
    // autoStartLoad: true,
};

exports.default = HLS_JS_DEFAULTS;

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeDisplay = _video2.default.getComponent('TimeDisplay');

var ASAdCountdown = function (_TimeDisplay) {
    _inherits(ASAdCountdown, _TimeDisplay);

    function ASAdCountdown() {
        _classCallCheck(this, ASAdCountdown);

        return _possibleConstructorReturn(this, (ASAdCountdown.__proto__ || Object.getPrototypeOf(ASAdCountdown)).apply(this, arguments));
    }

    _createClass(ASAdCountdown, [{
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return ('as-ad-countdown vjs-ad-countdown ' + _get(ASAdCountdown.prototype.__proto__ || Object.getPrototypeOf(ASAdCountdown.prototype), 'buildCSSClass', this).call(this)).trim();
        }
    }, {
        key: 'slot',
        value: function slot(_slot) {
            if (_slot === undefined) {
                return this.slot_ || undefined;
            }
            this.slot_ = _slot || undefined;
        }
    }, {
        key: 'timeRemaining',
        value: function timeRemaining(_timeRemaining) {
            if (_timeRemaining === undefined) {
                return this.timeRemaining_ || undefined;
            }
            this.timeRemaining_ = _timeRemaining || undefined;
        }
    }, {
        key: 'updateContent',
        value: function updateContent(event) {
            if (this.slot_) {
                if (this.slot_.getTotalDuration) {
                    var totalAdDuration = Math.round(this.slot_.getTotalDuration());
                    var timeRemaining = totalAdDuration - Math.round(this.slot_.getPlayheadTime());
                    this.updateFormattedTime_(timeRemaining);
                }
            }
            if (this.timeRemaining_) {
                this.updateFormattedTime_(this.timeRemaining_);
            }
        }
    }]);

    return ASAdCountdown;
}(TimeDisplay);

ASAdCountdown.prototype.labelText_ = 'Ad:';
ASAdCountdown.prototype.controlText_ = 'Ad';

_video2.default.registerComponent(Controls.AD_COUNTDOWN, ASAdCountdown);

exports.default = ASAdCountdown;

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _cc = __webpack_require__(281);

var _cc2 = _interopRequireDefault(_cc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextTrackButton = _video2.default.getComponent('TextTrackButton');
var CaptionsButton = _video2.default.getComponent('CaptionsButton');

var ccIcon = _video2.default.dom.createEl('span', {
    innerHTML: _cc2.default,
    className: 'vjs-icon vjs-icon--cc'
}, {
    'aria-hidden': 'true'
});

var ASCaptionsButton = function (_CaptionsButton) {
    _inherits(ASCaptionsButton, _CaptionsButton);

    function ASCaptionsButton(player, options) {
        _classCallCheck(this, ASCaptionsButton);

        var _this = _possibleConstructorReturn(this, (ASCaptionsButton.__proto__ || Object.getPrototypeOf(ASCaptionsButton)).call(this, player, options));

        _this.menuButton_.el_.appendChild(ccIcon);

        _this.handleTextTrackChange = _this.handleTextTrackChange.bind(_this);
        _this.playerTextTracks_ = player.tech_.el().textTracks;
        _this.playerTextTracks_.addEventListener('change', _this.handleTextTrackChange);
        return _this;
    }

    _createClass(ASCaptionsButton, [{
        key: 'createItems',
        value: function createItems() {
            return TextTrackButton.prototype.createItems.call(this);
        }
    }, {
        key: 'dispose',
        value: function dispose() {
            _get(ASCaptionsButton.prototype.__proto__ || Object.getPrototypeOf(ASCaptionsButton.prototype), 'dispose', this).call(this);
            this.playerTextTracks_.removeEventListener('change', this.handleTextTrackChange);
            this.playerTextTracks_ = null;
        }
    }, {
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return 'as-captions-button ' + _get(ASCaptionsButton.prototype.__proto__ || Object.getPrototypeOf(ASCaptionsButton.prototype), 'buildCSSClass', this).call(this);
        }
    }, {
        key: 'buildWrapperCSSClass',
        value: function buildWrapperCSSClass() {
            return 'as-captions-button-wrapper ' + _get(ASCaptionsButton.prototype.__proto__ || Object.getPrototypeOf(ASCaptionsButton.prototype), 'buildWrapperCSSClass', this).call(this);
        }
    }, {
        key: 'handleTextTrackChange',
        value: function handleTextTrackChange(event, data) {
            var tracks = event.target;
            var showing = 0; // Start at 1 (captions off), 0 is hidden settings menu

            for (var i = tracks.length; i >= 0; --i) {
                var track = tracks[i];
                if (track && track.mode === 'showing') {
                    showing = i + 1;
                    break;
                }
            }

            this.items.forEach(function (menuItem, i) {
                menuItem.toggleClass('vjs-selected', i === showing);
            });
        }
    }]);

    return ASCaptionsButton;
}(CaptionsButton);

_video2.default.registerComponent(Controls.CAPTIONS_BUTTON, ASCaptionsButton);

exports.default = ASCaptionsButton;

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _close = __webpack_require__(932);

var _close2 = _interopRequireDefault(_close);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CloseButton = _video2.default.getComponent('CloseButton');

var ASCloseButton = function (_CloseButton) {
    _inherits(ASCloseButton, _CloseButton);

    function ASCloseButton() {
        _classCallCheck(this, ASCloseButton);

        return _possibleConstructorReturn(this, (ASCloseButton.__proto__ || Object.getPrototypeOf(ASCloseButton)).apply(this, arguments));
    }

    _createClass(ASCloseButton, [{
        key: 'createEl',
        value: function createEl() {
            var el = _get(ASCloseButton.prototype.__proto__ || Object.getPrototypeOf(ASCloseButton.prototype), 'createEl', this).apply(this, arguments);

            var closeIcon = _video2.default.dom.createEl('span', {
                innerHTML: _close2.default,
                className: 'vjs-icon vjs-icon--close'
            }, {
                'aria-hidden': 'true'
            });

            el.appendChild(closeIcon);

            return el;
        }
    }, {
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return 'as-close-button ' + _get(ASCloseButton.prototype.__proto__ || Object.getPrototypeOf(ASCloseButton.prototype), 'buildCSSClass', this).call(this);
        }
    }]);

    return ASCloseButton;
}(CloseButton);

_video2.default.registerComponent(Controls.CLOSE_BUTTON, ASCloseButton);

exports.default = ASCloseButton;

/***/ }),

/***/ 932:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 14.4 12.3\" enable-background=\"new 0 0 14.4 12.3\" xml:space=\"preserve\" title=\"Close\"><polygon points=\"14.4,0 12.3,0 7.2,5.1 2.1,0 0,0 6.2,6.2 0,12.3 2.1,12.3 7.2,7.2 12.3,12.3 14.4,12.3 8.3,6.2 \"></polygon></svg>"

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _fullscreen = __webpack_require__(934);

var _fullscreen2 = _interopRequireDefault(_fullscreen);

var _exitFullscreen = __webpack_require__(935);

var _exitFullscreen2 = _interopRequireDefault(_exitFullscreen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenToggle = _video2.default.getComponent('FullscreenToggle');

var ASFullscreenToggle = function (_FullscreenToggle) {
    _inherits(ASFullscreenToggle, _FullscreenToggle);

    function ASFullscreenToggle() {
        _classCallCheck(this, ASFullscreenToggle);

        return _possibleConstructorReturn(this, (ASFullscreenToggle.__proto__ || Object.getPrototypeOf(ASFullscreenToggle)).apply(this, arguments));
    }

    _createClass(ASFullscreenToggle, [{
        key: 'createEl',
        value: function createEl() {
            var el = _get(ASFullscreenToggle.prototype.__proto__ || Object.getPrototypeOf(ASFullscreenToggle.prototype), 'createEl', this).apply(this, arguments);

            el.appendChild(_video2.default.dom.createEl('span', {
                innerHTML: _fullscreen2.default,
                className: 'vjs-icon vjs-icon--fullscreen'
            }, {
                'aria-hidden': 'true'
            }));

            el.appendChild(_video2.default.dom.createEl('span', {
                innerHTML: _exitFullscreen2.default,
                className: 'vjs-icon vjs-icon--exit-fullscreen'
            }, {
                'aria-hidden': 'true'
            }));

            return el;
        }
    }, {
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return 'as-fullscreen-control ' + _get(ASFullscreenToggle.prototype.__proto__ || Object.getPrototypeOf(ASFullscreenToggle.prototype), 'buildCSSClass', this).call(this);
        }
    }]);

    return ASFullscreenToggle;
}(FullscreenToggle);

_video2.default.registerComponent(Controls.FULLSCREEN_TOGGLE, ASFullscreenToggle);

exports.default = ASFullscreenToggle;

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 20.9 20.9\" enable-background=\"new 0 0 20.9 20.9\" xml:space=\"preserve\"><rect class=\"control-svg\" x=\"5.9\" y=\"5.9\" width=\"9\" height=\"9\"></rect><polygon class=\"control-svg\" points=\"5.1,4.4 1.7,1 4,1 4,0 1,0 0,0 0,1 0,4 1,4 1,1.7 4.4,5.1 \"></polygon><polygon class=\"control-svg\" points=\"15.8,4.4 19.2,1 16.9,1 16.9,0 19.9,0 20.9,0 20.9,1 20.9,4 19.9,4 19.9,1.7 16.5,5.1 \"></polygon><polygon class=\"control-svg\" points=\"5.1,16.5 1.7,19.9 4,19.9 4,20.9 1,20.9 0,20.9 0,19.9 0,16.9 1,16.9 1,19.2 4.4,15.8 \"></polygon><polygon class=\"control-svg\" points=\"15.8,16.5 19.2,19.9 16.9,19.9 16.9,20.9 19.9,20.9 20.9,20.9 20.9,19.9 20.9,16.9 19.9,16.9 19.9,19.2 16.5,15.8 \"></polygon></svg>"

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 20.9 20.9\" enable-background=\"new 0 0 20.9 20.9\" xml:space=\"preserve\"><rect class=\"control-svg\" x=\"5.9\" y=\"5.9\" width=\"9\" height=\"9\"></rect><polygon class=\"control-svg\" points=\"0,0.7 3.4,4.1 1.1,4.1 1.1,5.1 4.1,5.1 5.1,5.1 5.1,4.1 5.1,1.1 4.1,1.1 4.1,3.4 0.7,0 \"></polygon><polygon class=\"control-svg\" points=\"20.9,0.7 17.5,4.1 19.8,4.1 19.8,5.1 16.8,5.1 15.8,5.1 15.8,4.1 15.8,1.1 16.8,1.1 16.8,3.4 20.2,0 \"></polygon><polygon class=\"control-svg\" points=\"0,20.2 3.4,16.8 1.1,16.8 1.1,15.8 4.1,15.8 5.1,15.8 5.1,16.8 5.1,19.8 4.1,19.8 4.1,17.5 0.7,20.9 \"></polygon><polygon class=\"control-svg\" points=\"20.9,20.2 17.5,16.8 19.8,16.8 19.8,15.8 16.8,15.8 15.8,15.8 15.8,16.8 15.8,19.8 16.8,19.8 16.8,17.5 20.2,20.9 \"></polygon></svg>"

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = _video2.default.getComponent('Button');

var ASMutedOverlayButton = function (_Button) {
    _inherits(ASMutedOverlayButton, _Button);

    function ASMutedOverlayButton(player, options) {
        _classCallCheck(this, ASMutedOverlayButton);

        var _this = _possibleConstructorReturn(this, (ASMutedOverlayButton.__proto__ || Object.getPrototypeOf(ASMutedOverlayButton)).call(this, player, options));

        _this.one('tap', _this.handleClick);
        _this.on(player, 'volumechange', _this.handleVolumeChange);
        return _this;
    }

    _createClass(ASMutedOverlayButton, [{
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return 'as-muted-overlay-button';
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            this.player_.muted(false);
            this.removeMe();
        }
    }, {
        key: 'handleVolumeChange',
        value: function handleVolumeChange() {
            var vol = this.player_.volume();

            if (vol > 0 || !this.player_.muted()) {
                this.removeMe();
            }
        }
    }, {
        key: 'removeMe',
        value: function removeMe() {
            this.player_.removeChild(this);
            this.dispose();
        }
    }]);

    return ASMutedOverlayButton;
}(Button);

ASMutedOverlayButton.prototype.controlText_ = 'Unmute';

_video2.default.registerComponent(Controls.MUTED_OVERLAY_BUTTON, ASMutedOverlayButton);

exports.default = ASMutedOverlayButton;

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _muted = __webpack_require__(938);

var _muted2 = _interopRequireDefault(_muted);

var _volume = __webpack_require__(939);

var _volume2 = _interopRequireDefault(_volume);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MuteToggle = _video2.default.getComponent('MuteToggle');

var ASMuteToggle = function (_MuteToggle) {
    _inherits(ASMuteToggle, _MuteToggle);

    function ASMuteToggle() {
        _classCallCheck(this, ASMuteToggle);

        return _possibleConstructorReturn(this, (ASMuteToggle.__proto__ || Object.getPrototypeOf(ASMuteToggle)).apply(this, arguments));
    }

    _createClass(ASMuteToggle, [{
        key: 'createEl',
        value: function createEl() {
            var el = _get(ASMuteToggle.prototype.__proto__ || Object.getPrototypeOf(ASMuteToggle.prototype), 'createEl', this).apply(this, arguments);

            var volumeIcon = _video2.default.dom.createEl('span', {
                innerHTML: _volume2.default,
                className: 'vjs-icon vjs-icon--volume'
            }, {
                'aria-hidden': 'true'
            });

            var mutedIcon = _video2.default.dom.createEl('span', {
                innerHTML: _muted2.default,
                className: 'vjs-icon vjs-icon--muted'
            }, {
                'aria-hidden': 'true'
            });

            el.appendChild(volumeIcon);
            el.appendChild(mutedIcon);

            return el;
        }
    }, {
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return 'as-mute-control ' + _get(ASMuteToggle.prototype.__proto__ || Object.getPrototypeOf(ASMuteToggle.prototype), 'buildCSSClass', this).call(this);
        }
    }]);

    return ASMuteToggle;
}(MuteToggle);

_video2.default.registerComponent(Controls.MUTE_TOGGLE, ASMuteToggle);

exports.default = ASMuteToggle;

/***/ }),

/***/ 938:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 18.5 15.1\" enable-background=\"new 0 0 18.5 15.1\" xml:space=\"preserve\"><polygon class=\"control-svg\" points=\"9.6,0 4.3,4.2 0,4.2 0,10.9 4.3,10.9 9.6,15.1 \"></polygon><g><path class=\"control-svg\" d=\"M18.4,4.4l-2.1,3.1l2.2,3.3h-1.3l-1.1-1.5c-0.2-0.3-0.4-0.6-0.6-1.1l0,0c-0.2,0.3-0.4,0.7-0.6,1.1l-1,1.5 h-1.4l2.2-3.3l-2.1-3.1H14l0.9,1.4c0.2,0.3,0.4,0.6,0.6,1.1l0,0c0.2-0.4,0.4-0.7,0.6-1.1l1-1.4H18.4z\"></path></g></svg>"

/***/ }),

/***/ 939:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 18.5 15.1\" enable-background=\"new 0 0 18.5 15.1\" xml:space=\"preserve\"><polygon class=\"control-svg\" points=\"9.639,0 4.324,4.175 0,4.175 0,10.925 4.324,10.925 9.639,15.099 \"></polygon><g><defs><rect class=\"control-svg\" id=\"SVGID_1_\" width=\"17.559\" height=\"15.099\"></rect></defs><clipPath class=\"control-svg\" id=\"SVGID_2_\"><use xlink:href=\"#SVGID_1_\" overflow=\"visible\"></use></clipPath><path class=\"control-svg\" clip-path=\"url(#SVGID_2_)\" d=\"M13.27,4.25c-0.243,0.243-0.485,0.486-0.727,0.726 c0.665,0.84,1.079,1.886,1.079,3.037c0,1.042-0.331,2.006-0.885,2.802l0.715,0.717c0.73-0.985,1.17-2.2,1.17-3.519 C14.622,6.584,14.114,5.273,13.27,4.25\"></path><path class=\"control-svg\" clip-path=\"url(#SVGID_2_)\" d=\"M15.383,2.135c-0.214,0.214-0.455,0.455-0.707,0.707 c1.172,1.373,1.884,3.149,1.884,5.092c0,1.872-0.661,3.593-1.759,4.944l0.712,0.712c1.276-1.536,2.047-3.508,2.047-5.656 C17.56,5.716,16.734,3.691,15.383,2.135\"></path></g></svg>"

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _play = __webpack_require__(941);

var _play2 = _interopRequireDefault(_play);

var _pause = __webpack_require__(942);

var _pause2 = _interopRequireDefault(_pause);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayToggle = _video2.default.getComponent('PlayToggle');

var ASPlayToggle = function (_PlayToggle) {
    _inherits(ASPlayToggle, _PlayToggle);

    function ASPlayToggle() {
        _classCallCheck(this, ASPlayToggle);

        return _possibleConstructorReturn(this, (ASPlayToggle.__proto__ || Object.getPrototypeOf(ASPlayToggle)).apply(this, arguments));
    }

    _createClass(ASPlayToggle, [{
        key: 'createEl',
        value: function createEl(tag, props, attrs) {
            var el = _get(ASPlayToggle.prototype.__proto__ || Object.getPrototypeOf(ASPlayToggle.prototype), 'createEl', this).call(this, tag, props, attrs);

            el.appendChild(_video2.default.dom.createEl('span', {
                innerHTML: _play2.default,
                className: 'vjs-icon vjs-icon--play'
            }, {
                'aria-hidden': 'true'
            }));
            el.appendChild(_video2.default.dom.createEl('span', {
                innerHTML: _pause2.default,
                className: 'vjs-icon vjs-icon--pause'
            }, {
                'aria-hidden': 'true'
            }));

            return el;
        }
    }, {
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return 'as-play-control ' + _get(ASPlayToggle.prototype.__proto__ || Object.getPrototypeOf(ASPlayToggle.prototype), 'buildCSSClass', this).call(this);
        }
    }]);

    return ASPlayToggle;
}(PlayToggle);

_video2.default.registerComponent(Controls.PLAY_TOGGLE, ASPlayToggle);

exports.default = ASPlayToggle;

/***/ }),

/***/ 941:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 9.6 15.1\" enable-background=\"new 0 0 9.6 15.1\" xml:space=\"preserve\"><polygon class=\"control-svg\" points=\"9.6,7.5 0,15.1 0,0 \"></polygon></svg>"

/***/ }),

/***/ 942:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 12.6 15.1\" enable-background=\"new 0 0 12.6 15.1\" xml:space=\"preserve\"><rect class=\"control-svg\" x=\"7.8\" y=\"0\" width=\"4.8\" height=\"15.1\"></rect><rect class=\"control-svg\" x=\"0\" y=\"0\" width=\"4.8\" height=\"15.1\"></rect></svg>"

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _as = __webpack_require__(944);

var _as2 = _interopRequireDefault(_as);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = _video2.default.getComponent('Button');

var ASWatchButton = function (_Button) {
    _inherits(ASWatchButton, _Button);

    function ASWatchButton(player, options) {
        _classCallCheck(this, ASWatchButton);

        var _this = _possibleConstructorReturn(this, (ASWatchButton.__proto__ || Object.getPrototypeOf(ASWatchButton)).call(this, player, options));

        _this.on('click', _this.handleClick);
        return _this;
    }

    _createClass(ASWatchButton, [{
        key: 'createEl',
        value: function createEl(tag) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var el = _get(ASWatchButton.prototype.__proto__ || Object.getPrototypeOf(ASWatchButton.prototype), 'createEl', this).call(this, tag, props, attrs);

            el.appendChild(_video2.default.dom.createEl('span', {
                innerHTML: _as2.default,
                className: 'vjs-icon vjs-icon--as'
            }, {
                'aria-hidden': 'true'
            }));

            return el;
        }
    }, {
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return 'as-watch-button vjs-watch-button ' + _get(ASWatchButton.prototype.__proto__ || Object.getPrototypeOf(ASWatchButton.prototype), 'buildCSSClass', this).call(this);
        }
    }, {
        key: 'url',
        value: function url(_url) {
            if (_url === undefined) {
                return this.url_ || '';
            }
            this.url_ = typeof _url === 'string' ? _url : '';
        }
    }, {
        key: 'handleClick',
        value: function handleClick(event) {
            if (!this.url_) {
                return;
            }

            var player = this.player_;
            var currentTime = player.currentTime();
            var duration = player.duration();
            var timecode = currentTime !== duration ? Math.round(currentTime) : 0;
            var url = this.url_ + (timecode ? '?t=' + timecode : '');

            player.pause();

            window.open(url, '_blank');
        }
    }]);

    return ASWatchButton;
}(Button);

ASWatchButton.prototype.controlText_ = 'Watch on Adult Swim dot com';

_video2.default.registerComponent(Controls.WATCH_BUTTON, ASWatchButton);

exports.default = ASWatchButton;

/***/ }),

/***/ 944:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 30.7 19\" enable-background=\"new 0 0 30.7 19\" xml:space=\"preserve\"><path d=\"M9.1,11.6c0-0.6,0.2-1,0.5-1.3c0.3-0.3,0.8-0.3,1.9-0.8c0,0.5,0,1.1,0,2c0,1.1-0.7,1.6-1.4,1.6 C9.4,13.1,9.1,12.5,9.1,11.6z M9.1,7.2c0-1,0.3-1.6,1.3-1.6c0.8,0,1.1,0.4,1.1,1.1c0,0.9-0.2,1-1.2,1.3C9.3,8.4,8,8.6,7.1,9 C6.3,9.5,5.8,10.6,5.8,12c0,2.5,1.1,3.5,3.1,3.5c1.1,0,2.2-0.6,2.7-1.6h0c0,0.4,0.1,0.9,0.2,1.3H15c-0.4-0.5-0.4-1.6-0.4-2.5V6.8 c0-2.4-1.2-3.4-4.1-3.4c-1.4,0-2.4,0.2-3.2,0.7C6.6,4.7,6.1,5.6,6.1,7.2H9.1z\"></path><path d=\"M19.7,11.5c0,0.5,0.1,1,0.2,1.3c0.2,0.3,0.5,0.5,1.1,0.5c0.8,0,1.2-0.5,1.2-1.2c0-0.5-0.3-1-1.3-1.4 c-2.8-1-4.2-1.5-4.2-3.9c0-2.3,1.6-3.5,4.4-3.5c3.2,0,4.2,1.6,4.2,3.2V7h-3.1V6.8c0-1-0.4-1.3-1.1-1.3c-0.9,0-1.2,0.4-1.2,1.1 c0,2,5.5,0.7,5.5,5.1c0,2.3-1.5,3.7-4.4,3.7c-3.1,0-4.4-1.1-4.4-3.4v-0.5H19.7z\"></path><path d=\"M0,0h5.4v2.4H3.2v14.3h2.2V19H0V0z\"></path><path d=\"M25.4,16.7h2.2V2.4h-2.2V0h5.4v19h-5.4V16.7z\"></path></svg>"

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = _video2.default.getComponent('Button');

var ASShareButton = function (_Button) {
    _inherits(ASShareButton, _Button);

    function ASShareButton() {
        _classCallCheck(this, ASShareButton);

        return _possibleConstructorReturn(this, (ASShareButton.__proto__ || Object.getPrototypeOf(ASShareButton)).apply(this, arguments));
    }

    _createClass(ASShareButton, [{
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return 'as-share-button vjs-share-button ' + _get(ASShareButton.prototype.__proto__ || Object.getPrototypeOf(ASShareButton.prototype), 'buildCSSClass', this).call(this);
        }
    }]);

    return ASShareButton;
}(Button);

ASShareButton.prototype.controlText_ = 'Share';

_video2.default.registerComponent(Controls.SHARE_CONTROL, ASShareButton);

exports.default = ASShareButton;

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _get2 = __webpack_require__(947);

var _get3 = _interopRequireDefault(_get2);

var _has = __webpack_require__(973);

var _has2 = _interopRequireDefault(_has);

var _kebabCase = __webpack_require__(276);

var _kebabCase2 = _interopRequireDefault(_kebabCase);

var _assign = __webpack_require__(46);

var _assign2 = _interopRequireDefault(_assign);

var _throttle = __webpack_require__(976);

var _throttle2 = _interopRequireDefault(_throttle);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _ASVPUtils = __webpack_require__(42);

var _constants = __webpack_require__(52);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = _video2.default.getComponent('Component');

var COPY_TEXT = '&nbsp;Copy&nbsp;';
var HAS_CLIPBOARD = 'clipboard' in navigator && typeof navigator.clipboard.writeText === 'function';
var HAS_EXEC_COMMAND = typeof document.execCommand === 'function';
var CAN_COPY = HAS_CLIPBOARD || HAS_EXEC_COMMAND;

// get the base path from the share config options if set, else use VIDEOS_SITE_URL
var getBasePath = function getBasePath(videoSource, options) {
    if ((0, _has2.default)(options, 'share.basePath')) {
        return (0, _get3.default)(options, 'share.basePath');
    }

    if (videoSource.type === 'stream') {
        return _constants.STREAMS_SITE_URL;
    }

    return _constants.VIDEOS_SITE_URL;
};

// get the collection slug from the share config options if set, else use kebabCase(videoSource.collectionTitle)
var getCollectionSlug = function getCollectionSlug(videoSource, options) {
    if ((0, _has2.default)(options, 'share.collectionSlug')) {
        return (0, _get3.default)(options, 'share.collectionSlug');
    }

    if (videoSource.type === 'stream') {
        return '';
    }

    return (0, _kebabCase2.default)(videoSource.collectionTitle);
};

// get the video slug from the share config options if set, else use kebabCase(videoSource.title)
var getVideoSlug = function getVideoSlug(videoSource, options) {
    if ((0, _has2.default)(options, 'share.videoSlug')) {
        return (0, _get3.default)(options, 'share.videoSlug');
    }

    if (videoSource.type === 'stream' && videoSource.id === _constants.LIVE_STREAM_ID) {
        return '';
    }

    return (0, _kebabCase2.default)(videoSource.title);
};

// the adultswim.com url of the video
var dataURL = function dataURL(videoSource, options) {
    return [getBasePath(videoSource, options), getCollectionSlug(videoSource, options), getVideoSlug(videoSource, options)].filter(Boolean).join('/');
};

// set the custom share parameter (?s=//adultswim.com/special-url) if the share url override is set in the options (this is used by the embed route in /app to reinsert the url for future embeds)
var shareParam = function shareParam(options) {
    return (0, _get3.default)(options, 'share.url', undefined);
};

// set the time param as seconds (?t=53) if the timecode is defined
var timeParam = function timeParam(timecode) {
    if (!timecode) return undefined;
    return (0, _ASVPUtils.secondsFromTimecode)(timecode);
};

// constructs the serialize params for the sharing
var getURLParams = function getURLParams(params) {
    var result = (0, _ASVPUtils.serialize)((0, _ASVPUtils.assignDefined)({}, { s: params.s, t: params.t }));
    return result ? '?' + result : '';
};

// the final link to display on the share overlay (if share link override in options, use that, otherwise use dataURL)
var getDirectLink = function getDirectLink(videoSource, options, timecode) {
    var params = getURLParams({ t: timeParam(timecode) });
    var url = (0, _has2.default)(options, 'share.url') ? '' + (0, _get3.default)(options, 'share.url') + params : '' + dataURL(videoSource, options) + params;

    return url.replace(/\/$/, '');
};

// the embed code for the video
var getEmbedCode = function getEmbedCode(videoSource, options, timecode) {
    var params = getURLParams({
        s: shareParam(options),
        t: timeParam(timecode)
    });
    return videoSource.type === 'clip' ? '' + _constants.EMBED_CODE_L + _constants.EMBED_URL + videoSource.id + params + _constants.EMBED_CODE_R : null;
};

// gets the timecode value from the current seconds of the player (if the type of video can support it)
var getTimecode = function getTimecode(videoSource, currentTime) {
    if (videoSource.type === 'stream') return null;

    return (0, _ASVPUtils.timecodeFromSeconds)(currentTime);
};

var ASShareOverlay = function (_Component) {
    _inherits(ASShareOverlay, _Component);

    function ASShareOverlay(player, options) {
        _classCallCheck(this, ASShareOverlay);

        var _this = _possibleConstructorReturn(this, (ASShareOverlay.__proto__ || Object.getPrototypeOf(ASShareOverlay)).call(this, player, options));

        _this.copyButtons_ = _this.el().querySelectorAll('.copy-button');
        _this.socialButtons_ = _this.el().querySelectorAll('a[data-user-interaction]');
        _this.timeCheckbox_ = _this.el().querySelector('#timecode-selection');
        _this.timeCheckboxLabel_ = _this.el().querySelector('.timecode-selection label');
        _this.timeInput_ = _this.el().querySelector('#timecode-input');
        _this.timeText_ = _this.el().querySelector('.timecode');
        _this.embedCodeInput_ = _this.el().querySelector('#embed-code-input');
        _this.directLinkInput_ = _this.el().querySelector('#direct-link-input');

        if (CAN_COPY) {
            _this.copyButtons_.forEach(function (button) {
                return _this.on(button, 'click', _this.handleCopy);
            });
        }

        _this.socialButtons_.forEach(function (button) {
            return _this.on(button, 'click', _this.handleSocialClick);
        });

        if (_this.timeCheckbox_) {
            _this.on(_this.timeCheckbox_, 'change', _this.handleTimecodeCheckboxChange);
            _this.on(player, 'timeupdate', (0, _throttle2.default)(function () {
                if (!_this.timeCheckbox_.checked) _this.updateInputs();
            }, 100));
        }

        if (_this.timeInput_) {
            _this.on(_this.timeInput_, 'keyup', _this.handleTimecodeInputKeyup);
        }

        if (_this.timeCheckboxLabel_) {
            _this.on(_this.timeCheckboxLabel_, 'keydown', _this.handleTimecodeLabelKeydown);
        }
        return _this;
    }

    _createClass(ASShareOverlay, [{
        key: 'dispose',
        value: function dispose() {
            _get(ASShareOverlay.prototype.__proto__ || Object.getPrototypeOf(ASShareOverlay.prototype), 'dispose', this).call(this);
            this.copyButtons_ = null;
            this.socialButtons_ = null;
            this.timeCheckbox_ = null;
            this.timeCheckboxLabel_ = null;
            this.timeInput_ = null;
            this.timeText_ = null;
            this.embedCodeInput_ = null;
            this.directLinkInput_ = null;
        }
    }, {
        key: 'createEl',
        value: function createEl(_, props, attrs) {
            props = (0, _assign2.default)({
                innerHTML: this.content(),
                className: 'as-share-overlay'
            }, props);

            return _get(ASShareOverlay.prototype.__proto__ || Object.getPrototypeOf(ASShareOverlay.prototype), 'createEl', this).call(this, 'div', props, attrs);
        }
    }, {
        key: 'content',
        value: function content() {
            var options = this.options_;
            var currentTime = this.player_.currentTime();
            var timecode = getTimecode(options.video, currentTime);
            var embedCode = getEmbedCode(options.video, options);
            var directLink = getDirectLink(options.video, options);

            return '\n            <div class="share-overlay-content">\n                <h2 class="share-heading">Share</h2>\n\n                <ul class="share-icons">\n                    <li class="facebook-icon">\n                        <a href="' + _constants.FACEBOOK_SHARE_URL + directLink + '" data-user-interaction="click:share:facebook" target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook">\n                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 27.6 27.6" enable-background="new 0 0 27.6 27.6" xml:space="preserve" aria-hidden="true">\n                            <path d="M13.8,27.6c7.6,0,13.8-6.2,13.8-13.8S21.4,0,13.8,0C6.2,0,0,6.2,0,13.8S6.2,27.6,13.8,27.6z M9.6,11.7h2.5\n                                V9.4c0,0-0.1-1.5,1-2.6c1.1-1.1,2.6-1,4.8-0.8v2.5h-1.6c0,0-0.7,0-1,0.3c-0.3,0.4-0.3,0.9-0.3,1v1.8h2.8l-0.4,2.8h-2.4v7.3h-2.9\n                                v-7.3H9.6V11.7z"/>\n                            </svg>\n                        </a>\n                    </li>\n                    <li class="twitter-icon">\n                        <a href="' + _constants.TWITTER_SHARE_URL + directLink + '" data-user-interaction="click:share:twitter" target="_blank" rel="noopener noreferrer" aria-label="Share on Twitter">\n                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 27.6 27.6" enable-background="new 0 0 27.6 27.6" xml:space="preserve" aria-hidden="true">\n                            <path d="M13.8,27.6c7.6,0,13.8-6.2,13.8-13.8S21.4,0,13.8,0S0,6.2,0,13.8S6.2,27.6,13.8,27.6z M10.5,17.5\n                                c0,0-2.4,0-3.1-2.3c0,0,1.2,0.1,1.4-0.1c0,0-2.6-0.6-2.6-3.3c0,0,0.8,0.4,1.5,0.4c0,0-2.5-1.8-1-4.5c0,0,2.5,3.3,6.8,3.5\n                                c0,0-0.6-2,1.2-3.5c1.8-1.5,4-0.2,4.5,0.3c0,0,1.3-0.2,2.2-0.8c0,0-0.3,1.1-1.4,1.8c0,0,1.3-0.2,1.8-0.5c0,0-0.6,1-1.7,1.7\n                                c0,0,0.4,4.1-3.1,7.5c-3.6,3.4-9.4,2.7-11.5,0.9C5.7,18.9,8.5,19.2,10.5,17.5z"/>\n                            </svg>\n                        </a>\n                    </li>\n                    <li class="tumblr-icon">\n                        <a href="' + _constants.TUMBLR_SHARE_URL + directLink + '" data-user-interaction="click:share:tumblr" target="_blank" rel="noopener noreferrer" aria-label="Share on Tumblr">\n                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 27.6 27.6" enable-background="new 0 0 27.6 27.6" xml:space="preserve" aria-hidden="true">\n                            <path d="M13.8,0C6.2,0,0,6.2,0,13.8s6.2,13.8,13.8,13.8c7.6,0,13.8-6.2,13.8-13.8S21.4,0,13.8,0z M17.9,20.7\n                                c0,0-1.6,0.4-2.6,0.4c-1,0-3.7-0.1-4.2-2.9v-6H9.6V9.7h0.4c0,0,1.3-0.3,1.8-1.3c0.6-1,0.5-1.8,0.5-1.8h2.1v3.2h3.3v2.5h-3.2v4.1\n                                c0,0,0,0.7,0.1,0.9c0.1,0.3,0.6,0.9,1.4,0.9c0.8,0,2-0.5,2-0.5V20.7z"/>\n                            </svg>\n                        </a>\n                    </li>\n                </ul>\n\n                <div class="copy-field">\n                    <label for="direct-link-input">Direct Link:</label>\n                    <div class="copy-input-wrapper">\n                        <input id="direct-link-input" type="text" value="' + directLink + '" onclick="this.setSelectionRange(0, this.value.length);" readonly />\n                        ' + (CAN_COPY ? '<button class="copy-button" data-copy-target="#direct-link-input">' + COPY_TEXT + '</button>' : '') + '\n                    </div>\n                </div>\n\n                ' + (!!embedCode ? '\n                <div class="copy-field">\n                    <label for="embed-code-input">Embed:</label>\n                    <div class="copy-input-wrapper">\n                        <input id="embed-code-input" type="text" value="' + embedCode + '" onclick="this.setSelectionRange(0, this.value.length);" readonly />\n                        ' + (CAN_COPY ? '<button class="copy-button" data-copy-target="#embed-code-input">' + COPY_TEXT + '</button>' : '') + '\n                    </div>\n                </div>' : '') + '\n\n                ' + (!!timecode ? '\n                <div class="timecode-selection">\n                    <div class="checkbox-wrapper">\n                        <input type="checkbox" id="timecode-selection" />\n                        <label tabindex="0" for="timecode-selection">Start at</label>\n                        <input type="text" id="timecode-input" value="' + timecode + '" readonly />\n                    </div>\n                </div>' : '') + '\n\n            </div>\n        ';
        }
    }, {
        key: 'updateInputs',
        value: function updateInputs(currentTime) {
            if (!this.timeCheckbox_) {
                return;
            }

            if (typeof currentTime === 'undefined') {
                currentTime = (0, _ASVPUtils.timecodeFromSeconds)(this.player_.currentTime());
            }

            var options = this.options_;
            var checked = this.timeCheckbox_.checked;

            var directLink = getDirectLink(options.video, options, checked ? currentTime : undefined);

            if (this.embedCodeInput_) {
                var embedCode = getEmbedCode(options.video, options, checked ? currentTime : undefined);
                this.embedCodeInput_.value = embedCode;
            }

            if (this.directLinkInput_) {
                this.directLinkInput_.value = directLink;
            }

            if (this.timeInput_ && !checked) {
                this.timeInput_.value = currentTime;
            }

            this.socialButtons_.forEach(function (a) {
                var href = a.getAttribute('href').split('=')[0];
                a.setAttribute('href', href + '=' + directLink);
            });
        }
    }, {
        key: 'handleCopy',
        value: function handleCopy(event) {
            if (!CAN_COPY) {
                return;
            }

            var button = event.target;
            var input = this.el().querySelector(button.dataset.copyTarget);

            if (!input || !input.value) {
                return;
            }

            input.focus();
            input.select();

            var done = function done() {
                button.innerHTML = 'Copied';
                setTimeout(function () {
                    try {
                        button.innerHTML = COPY_TEXT;
                    } catch (e) {}
                }, 2000);
            };

            if (HAS_CLIPBOARD) {
                navigator.clipboard.writeText(input.value).then(done).catch(function () {});
            } else if (HAS_EXEC_COMMAND) {
                if (document.execCommand('copy') === true) {
                    done();
                }
            }
        }
    }, {
        key: 'handleSocialClick',
        value: function handleSocialClick(event) {
            this.trigger('userInteraction', event.currentTarget.dataset.userInteraction);
        }
    }, {
        key: 'handleTimecodeCheckboxChange',
        value: function handleTimecodeCheckboxChange() {
            if (!this.timeCheckbox_) {
                return;
            }

            if (this.timeInput_) {
                this.timeInput_.readOnly = !this.timeCheckbox_.checked;
                this.timeInput_.value = (0, _ASVPUtils.timecodeFromSeconds)(this.player_.currentTime());
            }

            this.updateInputs();
        }
    }, {
        key: 'handleTimecodeInputKeyup',
        value: function handleTimecodeInputKeyup(event) {
            var value = event.target.value;
            event.target.value = value.replace(/[^0-9\:]+/, '');
            this.updateInputs(value);
        }
    }, {
        key: 'handleTimecodeLabelKeydown',
        value: function handleTimecodeLabelKeydown(event) {
            if (event.key === ' ' || event.key === 'Enter') {
                event.target.click();
            }
        }
    }]);

    return ASShareOverlay;
}(Component);

_video2.default.registerComponent(Controls.SHARE_OVERLAY, ASShareOverlay);

exports.default = ASShareOverlay;

/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _assign = __webpack_require__(46);

var _assign2 = _interopRequireDefault(_assign);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = _video2.default.getComponent('Component');

var ASAdClickOverlay = function (_Component) {
    _inherits(ASAdClickOverlay, _Component);

    function ASAdClickOverlay(clickHandler) {
        _classCallCheck(this, ASAdClickOverlay);

        var _this = _possibleConstructorReturn(this, (ASAdClickOverlay.__proto__ || Object.getPrototypeOf(ASAdClickOverlay)).call(this, clickHandler));

        _this.clickHandler_ = clickHandler;
        _this.adClickOverlay_ = _this.el().querySelector('.ad-click-overlay-content');

        _this.on(_this.adClickOverlay_, 'click', _this.clickHandler_);
        return _this;
    }

    _createClass(ASAdClickOverlay, [{
        key: 'dispose',
        value: function dispose() {
            _get(ASAdClickOverlay.prototype.__proto__ || Object.getPrototypeOf(ASAdClickOverlay.prototype), 'dispose', this).call(this);
            this.off(this.adClickOverlay_, 'click', this.clickHandler_);
            this.adClickOverlay_ = null;
            this.clickHandler_ = null;
        }
    }, {
        key: 'createEl',
        value: function createEl(_, props, attrs) {
            props = (0, _assign2.default)({
                innerHTML: this.content(),
                className: 'as-ad-click-overlay'
            }, props);

            return _get(ASAdClickOverlay.prototype.__proto__ || Object.getPrototypeOf(ASAdClickOverlay.prototype), 'createEl', this).call(this, 'div', props, attrs);
        }
    }, {
        key: 'content',
        value: function content() {
            return '<div class="ad-click-overlay-content"></div>';
        }
    }]);

    return ASAdClickOverlay;
}(Component);

_video2.default.registerComponent(Controls.AD_CLICK_OVERLAY, ASAdClickOverlay);

exports.default = ASAdClickOverlay;

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

var _UIControlsNames = __webpack_require__(18);

var Controls = _interopRequireWildcard(_UIControlsNames);

var _cc = __webpack_require__(281);

var _cc2 = _interopRequireDefault(_cc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubtitlesButton = _video2.default.getComponent('SubtitlesButton');

var ccIcon = _video2.default.dom.createEl('span', {
    innerHTML: _cc2.default,
    className: 'vjs-icon vjs-icon--cc'
}, {
    'aria-hidden': 'true'
});

var ASSubtitlesButton = function (_SubtitlesButton) {
    _inherits(ASSubtitlesButton, _SubtitlesButton);

    function ASSubtitlesButton(player, options) {
        _classCallCheck(this, ASSubtitlesButton);

        var _this = _possibleConstructorReturn(this, (ASSubtitlesButton.__proto__ || Object.getPrototypeOf(ASSubtitlesButton)).call(this, player, options));

        _this.menuButton_.el_.appendChild(ccIcon);
        return _this;
    }

    _createClass(ASSubtitlesButton, [{
        key: 'buildCSSClass',
        value: function buildCSSClass() {
            return 'as-subtitles-button ' + _get(ASSubtitlesButton.prototype.__proto__ || Object.getPrototypeOf(ASSubtitlesButton.prototype), 'buildCSSClass', this).call(this);
        }
    }, {
        key: 'buildWrapperCSSClass',
        value: function buildWrapperCSSClass() {
            return 'as-subtitles-button-wrapper ' + _get(ASSubtitlesButton.prototype.__proto__ || Object.getPrototypeOf(ASSubtitlesButton.prototype), 'buildWrapperCSSClass', this).call(this);
        }
    }]);

    return ASSubtitlesButton;
}(SubtitlesButton);

_video2.default.registerComponent(Controls.SUBTITLES_BUTTON, ASSubtitlesButton);

exports.default = ASSubtitlesButton;

/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(12);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Plugin = _video2.default.getPlugin('plugin');

var KEYBOARD_CLASS = 'vjs-probably-keyboard-focus';

var DetectKeyboardFocus = function (_Plugin) {
    _inherits(DetectKeyboardFocus, _Plugin);

    function DetectKeyboardFocus(player, options) {
        _classCallCheck(this, DetectKeyboardFocus);

        var _this = _possibleConstructorReturn(this, (DetectKeyboardFocus.__proto__ || Object.getPrototypeOf(DetectKeyboardFocus)).call(this, player, options));

        _this.handleKeydown = _this.handleKeydown.bind(_this);
        _this.handleMousedown = _this.handleMousedown.bind(_this);

        window.addEventListener('keydown', _this.handleKeydown);
        window.addEventListener('mousedown', _this.handleMousedown);

        _this.on('statechanged', _this.handleStateChange);

        _this.toggleClassName();
        return _this;
    }

    _createClass(DetectKeyboardFocus, [{
        key: 'dispose',
        value: function dispose() {
            _get(DetectKeyboardFocus.prototype.__proto__ || Object.getPrototypeOf(DetectKeyboardFocus.prototype), 'dispose', this).call(this);
            window.removeEventListener('keydown', this.handleKeydown);
            window.removeEventListener('mousedown', this.handleMousedown);
        }
    }, {
        key: 'toggleClassName',
        value: function toggleClassName() {
            this.player.toggleClass(KEYBOARD_CLASS, this.state.probablyKeyboard);
        }
    }, {
        key: 'handleStateChange',
        value: function handleStateChange(event, data) {
            if (event.changes.probablyKeyboard) {
                this.toggleClassName();
            }
        }
    }, {
        key: 'handleKeydown',
        value: function handleKeydown(event) {
            if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ') {
                this.setState({ probablyKeyboard: true });
            }
        }
    }, {
        key: 'handleMousedown',
        value: function handleMousedown(event) {
            this.setState({ probablyKeyboard: false });
        }
    }]);

    return DetectKeyboardFocus;
}(Plugin);

DetectKeyboardFocus.defaultState = {
    probablyKeyboard: false
};

_video2.default.registerPlugin('detectKeyboardFocus', DetectKeyboardFocus);

exports.default = DetectKeyboardFocus;

/***/ }),

/***/ 983:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[284]);
});


// WEBPACK FOOTER //
// asvp.2e2809bfb3d7c95ef1ec.bundle.js